"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2511],{

/***/ 66887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SM": function() { return /* binding */ EventPagesAPI; },
/* harmony export */   "eS": function() { return /* binding */ EventPagesFileAPI; },
/* harmony export */   "ec": function() { return /* binding */ commentAPI; }
/* harmony export */ });
/* unused harmony export voteAPI */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 투표
var voteAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].VOTE */ .Z.VOTE).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function voteAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
// 공동구매
var EventPagesAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].EVENTPAGES */ .Z.EVENTPAGES).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function EventPagesAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
// 공동구매 파일
var EventPagesFileAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].EVENTPAGES */ .Z.EVENTPAGES).postFiles(body);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function EventPagesFileAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
// 댓글관련
var commentAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].COMMENT */ .Z.COMMENT).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function commentAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 40542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ postMember; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var postMember = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MEMBER */ .Z.MEMBER).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postMember(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 50059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P3": function() { return /* binding */ GuestOrderFind; },
/* harmony export */   "RJ": function() { return /* binding */ StoreOrderApi; },
/* harmony export */   "jb": function() { return /* binding */ SettlementAPI; },
/* harmony export */   "mv": function() { return /* binding */ postOrder; }
/* harmony export */ });
/* unused harmony exports createOrder, makeOrder, createTempOrder, CarbonInsert */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var createOrder = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
var makeOrder = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, ref3, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.Data,
                        msg: res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Data) === null || ref3 === void 0 ? void 0 : ref3.Msg
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function makeOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
// 결제전 상품 가격 설정
var createTempOrder = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    resData = res === null || res === void 0 ? void 0 : res.data;
                    return _ctx.abrupt("return", resData);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createTempOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
var CarbonInsert = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CarbonInsert(body) {
        return _ref.apply(this, arguments);
    };
}();
// 마이페이지 order api
var postOrder = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res);
                case 7:
                    {
                        res;
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
// 주문번호로 조회
var GuestOrderFind = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GuestOrderFind(body) {
        return _ref.apply(this, arguments);
    };
}();
// order common
var StoreOrderApi = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ORDER */ .Z.ORDER).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function StoreOrderApi(body) {
        return _ref.apply(this, arguments);
    };
}();
// Settlement
var SettlementAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SETTLEMENT */ .Z.SETTLEMENT).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SettlementAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 81628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ inquirySet; },
/* harmony export */   "Hc": function() { return /* binding */ listSetCategory; },
/* harmony export */   "Ir": function() { return /* binding */ ViewCountProduct; },
/* harmony export */   "Qz": function() { return /* binding */ hashSetProducts; },
/* harmony export */   "qO": function() { return /* binding */ ProductsApi; },
/* harmony export */   "s3": function() { return /* binding */ searchProducts; }
/* harmony export */ });
/* unused harmony exports fetchProductsMain, fetchProductView, getListCategoryProducts */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 메인페이지 카테고리텝 상품목록
var fetchProductsMain = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: (ref1 = res === null || res === void 0 ? void 0 : res.data.Data) === null || ref1 === void 0 ? void 0 : ref1.Rows,
                        count: (ref2 = res === null || res === void 0 ? void 0 : res.data.Data) === null || ref2 === void 0 ? void 0 : ref2.Count
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchProductsMain(body) {
        return _ref.apply(this, arguments);
    };
}();
// 상품 디테일페이지
var fetchProductView = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref3, ref4, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Data) === null || ref4 === void 0 ? void 0 : ref4.Row
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchProductView(body) {
        return _ref.apply(this, arguments);
    };
}();
// 카테고리 fetch
var listSetCategory = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref5, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].CATEGORY */ .Z.CATEGORY).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.Data.Category
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function listSetCategory(body) {
        return _ref.apply(this, arguments);
    };
}();
// 카테고리 별 상품 리스트
var getListCategoryProducts = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getListCategoryProducts(body) {
        return _ref.apply(this, arguments);
    };
}();
// 해시태그 리스트
var hashSetProducts = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hashSetProducts(body) {
        return _ref.apply(this, arguments);
    };
}();
// 상품 조회수 증가
var ViewCountProduct = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewCountProduct(body) {
        return _ref.apply(this, arguments);
    };
}();
// 상품 검색
var searchProducts = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function searchProducts(body) {
        return _ref.apply(this, arguments);
    };
}();
// 제작문의
var inquirySet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function inquirySet(body) {
        return _ref.apply(this, arguments);
    };
}();
// products
var ProductsApi = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCTS */ .Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ProductsApi(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 13203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B3": function() { return /* binding */ modifyConfirmOption; },
/* harmony export */   "RX": function() { return /* binding */ uidConfirm; },
/* harmony export */   "UP": function() { return /* binding */ leaveConfirmOption; },
/* harmony export */   "VX": function() { return /* binding */ deleteConfirmOption; },
/* harmony export */   "ab": function() { return /* binding */ logoutConfirm; },
/* harmony export */   "q3": function() { return /* binding */ changeNotiConfirmOption; },
/* harmony export */   "qn": function() { return /* binding */ changeConfirmOption; },
/* harmony export */   "wb": function() { return /* binding */ cancelOrderConfirm; },
/* harmony export */   "wj": function() { return /* binding */ submitConfirmOption; }
/* harmony export */ });
var logoutConfirm = function(logoutConfirmHandler) {
    var content = {
        onAction: logoutConfirmHandler,
        title: "\uB85C\uADF8\uC544\uC6C3 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        actionBtnLabel: "\uD655\uC778",
        actionBtnValid: true,
        cancelBtnLabel: "\uCDE8\uC18C"
    };
    return content;
};
var uidConfirm = function(message) {
    return function() {
        var content = {
            title: message,
            actionBtnValid: false,
            cancelBtnLabel: "\uD655\uC778"
        };
        return content;
    };
};
var cancelOrderConfirm = function(handleSubmit) {
    var content = {
        onAction: handleSubmit,
        title: "\uC815\uB9D0 \uC8FC\uBB38\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        actionBtnLabel: "\uD655\uC778",
        actionBtnValid: true,
        cancelBtnLabel: "\uCDE8\uC18C"
    };
    return content;
};
var changeConfirmOption = {
    title: "\uC815\uB9D0 \uBCC0\uACBD \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};
var modifyConfirmOption = {
    title: "\uC815\uB9D0 \uC218\uC815 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};
var leaveConfirmOption = {
    title: "\uC815\uB9D0 \uD0C8\uD1F4 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};
var submitConfirmOption = {
    title: "\uC815\uB9D0 \uB4F1\uB85D \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};
var deleteConfirmOption = {
    title: "\uC815\uB9D0 \uC0AD\uC81C \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};
var changeNotiConfirmOption = {
    title: "\uC815\uB9D0 \uC54C\uB9BC \uC0C1\uD0DC\uB97C \uBCC0\uACBD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    actionBtnLabel: "\uD655\uC778",
    actionBtnValid: true,
    cancelBtnLabel: "\uCDE8\uC18C"
};


/***/ }),

/***/ 92534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PageRouter; }
/* harmony export */ });
var PageRouter = [
    // {
    //   url: "/products",
    //   title: "상품구매",
    // },
    {
        url: "/customizing/customizing-products",
        title: "\uB9DE\uCDA4\uC81C\uC791",
        sub: [
            {
                url: "/customizing/customizing-products",
                title: "\uB9DE\uCDA4\uC81C\uC791"
            },
            {
                url: "/customizing/design-service",
                title: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4"
            },
            {
                url: "/customizing/portfolio",
                title: "\uD3EC\uD2B8\uD3F4\uB9AC\uC624"
            },
            {
                url: "/partners",
                title: "\uACE0\uAC1D\uC0AC"
            }, 
        ]
    },
    {
        url: "/customizing/print/quote",
        title: "\uC18C\uB7C9\uC778\uC1C4",
        sub: [
            {
                url: "/customizing/print",
                title: "\uC0C1\uD488\uC18C\uAC1C"
            },
            {
                url: "/customizing/print/guide",
                title: "\uAC00\uC774\uB4DC"
            },
            {
                url: "/customizing/print/materials",
                title: "\uC7AC\uC9C8"
            },
            {
                url: "/customizing/print/sizes",
                title: "\uC0AC\uC774\uC988"
            },
            {
                url: "/customizing/print/requirements",
                title: "\uD544\uC218\uC0AC\uD56D"
            },
            {
                url: "/customizing/print/faq",
                title: "\uC18C\uB7C9\uC778\uC1C4 FAQ"
            },
            {
                url: "/customizing/print/quote",
                title: "\uC0C1\uD488 \u2022 \uACAC\uC801"
            }, 
        ]
    },
    {
        url: "/customizing/prototype",
        title: "\uC2DC\uC81C\uD488\uC81C\uC791"
    },
    {
        url: "/customizing/promotion",
        title: "\uD310\uCD09\uBB3C\uC81C\uC791"
    },
    {
        url: "/group-purchase",
        title: "\uACF5\uB3D9\uAD6C\uB9E4"
    },
    {
        url: "/esg-guide",
        title: "ESG\uC790\uB8CC\uC2E4",
        sub: [
            {
                url: "/esg-guide",
                title: "ESG"
            },
            {
                url: "/esg-guide/certification",
                title: "\uD3EC\uC7A5\uC7AC \uC778\uC99D\uC815\uBCF4"
            },
            {
                url: "/esg-guide/news",
                title: "ESG \uD658\uACBD\uB274\uC2A4"
            },
            {
                url: "/esg-guide/letter",
                title: "ESG \uB274\uC2A4\uB808\uD130"
            },
            {
                url: "/esg-guide/blog/package",
                title: "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC"
            },
            {
                url: "/esg-guide/blog/make",
                title: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0"
            }, 
        ]
    },
    {
        url: "/csboard/notice",
        title: "\uACE0\uAC1D\uC9C0\uC6D0",
        sub: [
            {
                url: "/csboard/notice",
                title: "\uACF5\uC9C0\uC0AC\uD56D"
            },
            {
                url: "/csboard/faq",
                title: "FAQ"
            },
            {
                url: "/csboard/library",
                title: "\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC"
            },
            {
                url: "/csboard/contact",
                title: "\uC81C\uD734\uBB38\uC758"
            },
            {
                url: "/csboard/b2b",
                title: "\uD328\uD0A4\uC9D5 \uC81C\uC548\uBC1B\uAE30"
            },
            {
                url: "/csboard/service",
                title: "\uAD6C\uD574\uB4DC\uB9BD\uB2C8\uB2E4"
            }, 
        ]
    }, 
];


/***/ }),

/***/ 8025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ priceComma; }
/* harmony export */ });
var priceComma = function(e) {
    var a = e;
    return Number(a).toLocaleString("ko-KR");
};


/***/ }),

/***/ 74971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HA": function() { return /* binding */ ViewBox; },
/* harmony export */   "L4": function() { return /* binding */ SfnzBadge; },
/* harmony export */   "Mo": function() { return /* binding */ StickerWrapper; },
/* harmony export */   "My": function() { return /* binding */ Sticker; },
/* harmony export */   "Q5": function() { return /* binding */ ProductImgWrapper; },
/* harmony export */   "ZD": function() { return /* binding */ ProductContentWrapper; },
/* harmony export */   "bz": function() { return /* binding */ PriceBox; },
/* harmony export */   "d4": function() { return /* binding */ CartIconBox; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "pm": function() { return /* binding */ ProductImg; },
/* harmony export */   "qW": function() { return /* binding */ ProductBottomWrapper; },
/* harmony export */   "rZ": function() { return /* binding */ ProductName; },
/* harmony export */   "vN": function() { return /* binding */ PriceWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: white;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n  overflow: hidden;\n  margin-bottom: 5px;\n\n  :hover {\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: #fff;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n\n  & img {\n    -webkit-transition: all 1s cubic-bezier(0, 0, 0.05, 1);\n    transition: all 1s cubic-bezier(0, 0, 0.05, 1);\n    :hover {\n      transform: scale3d(1.03, 1.03, 1.03) translateZ(0);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  z-index: 20;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 10px 15px 10px;\n  //background: #0c4128;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 3rem;\n  font-size: 16px;\n  font-weight: 500;\n  color: #253d4e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n  :hover {\n    color: #3bb77e;\n  }\n  @media (max-width: 760px) {\n    font-size: 1rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  padding: 5px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    span:first-child {\n      color: #dc3545;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 24px;\n      margin-right: 0.2rem;\n    }\n    span:last-child {\n      font-size: 14px;\n      line-height: 24px;\n      font-weight: 500;\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n      padding: 0;\n      margin: 0;\n    }\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n    height: 2rem;\n    margin-bottom: 0.5rem;\n    & h5 {\n      font-size: 16px;\n    }\n    & > div {\n      span:first-child {\n        font-size: 1rem;\n        color: #dc3545;\n      }\n      span:last-child {\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1.5rem;\n  position: relative;\n  display: inline-block;\n  font-weight: 700;\n  color: #3bb77e;\n\n  @media (max-width: 480px) {\n    font-size: 1.2rem;\n  }\n\n  & span {\n    width: 2.5rem;\n    display: flex;\n    justify-content: flex-end;\n    font-size: 1rem;\n    color: red;\n    font-weight: 500;\n  }\n\n  & i {\n    :hover {\n      color: #ffc107;\n      -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n      box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 1rem;\n  margin-top: 10px;\n  padding-top: 0.7rem;\n  border-top: 1px solid #ececec;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: center;\n  font-size: 0.8rem;\n\n  & div {\n    display: flex;\n    align-items: center;\n  }\n\n  & img {\n    width: 1rem;\n    margin-left: 5px;\n    margin-right: 0.5rem;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1rem;\n  height: 1rem;\n  font-size: 12px;\n  color: white;\n  background-color: #3bb77e;\n  border: 1px solid white;\n  border-radius: 2rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-0"
})(_templateObject());
var ProductImgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-1"
})(_templateObject1());
var ProductImg = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-9bff2b9f-2"
})(_templateObject2());
var SfnzBadge = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9bff2b9f-3"
})(_templateObject3());
// 컨텐츠 부분
var ProductContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-4"
})(_templateObject4());
var ProductName = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-9bff2b9f-5"
})(_templateObject5());
// 하단 부분
var ProductBottomWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-6"
})(_templateObject6());
var PriceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-7"
})(_templateObject7());
var PriceBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-8"
})(_templateObject8());
var CartIconBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-9"
})(_templateObject9());
var StickerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-10"
})(_templateObject10());
var ViewBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bff2b9f-11"
})(_templateObject11());
var Sticker = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9bff2b9f-12"
})(_templateObject12());


/***/ }),

/***/ 51375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ ViewListBox; },
/* harmony export */   "Ev": function() { return /* binding */ InnerListWrapper; },
/* harmony export */   "FZ": function() { return /* binding */ InnerHeader; },
/* harmony export */   "HV": function() { return /* binding */ InnerBody; },
/* harmony export */   "IS": function() { return /* binding */ InnerTabWrapper; },
/* harmony export */   "Ip": function() { return /* binding */ InnerWrapper; },
/* harmony export */   "J6": function() { return /* binding */ IconsWrapper; },
/* harmony export */   "JR": function() { return /* binding */ AlldeleteBtn; },
/* harmony export */   "MH": function() { return /* binding */ ReOrderBtnWrapper; },
/* harmony export */   "T$": function() { return /* binding */ UserFloatingWrapper; },
/* harmony export */   "XD": function() { return /* binding */ MobileFooterTab; },
/* harmony export */   "bE": function() { return /* binding */ MobileFooter; },
/* harmony export */   "lW": function() { return /* binding */ ViewListWrapper; },
/* harmony export */   "mY": function() { return /* binding */ CartBtnWrapper; },
/* harmony export */   "oB": function() { return /* binding */ InnerFooter; },
/* harmony export */   "zE": function() { return /* binding */ InnerEmptyWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 500;\n  display: flex;\n  height: ",
        ";\n  transform: ",
        ";\n  transition: all 0.3s ease-in-out;\n  color: #1b1b1b;\n  .custome-checkbox .form-check-label::before {\n    min-width: 17px;\n  }\n  & i {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  .icon {\n    background-color: #fff;\n    font-size: 20px;\n    margin-bottom: 5px;\n    border-radius: 10px;\n    background-color: #fff;\n    width: 59px;\n    height: 54px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: -3px 3px 7px 0px rgba(0, 0, 0, 0.1);\n  }\n  .active {\n    background-color: #3bb77e;\n    color: #fff;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 340px;\n  min-height: 700px;\n  height: 100%;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 17px 15px;\n  border-bottom: 1px solid #ececec;\n  font-size: 18px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ececec;\n  .tab {\n    width: 50%;\n    padding: 10px;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 15px;\n    :not(:last-child) {\n      border-right: 1px solid #ececec;\n    }\n    & i {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .active {\n    background-color: #3bb77e;\n    color: #fff;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: #1b1b1b;\n  width: fit-content;\n  line-height: 1.2;\n  border-bottom: 2px solid #1b1b1b;\n  :hover {\n    color: #3bb77e;\n    border-color: #3bb77e;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 15px;\n  overflow-y: auto;\n  .product_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 15px 0px;\n    .top {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 10px;\n      overflow-y: hidden;\n\n      .pname {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: pre-wrap;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n        font-size: 14px;\n        font-weight: 300;\n        cursor: pointer;\n      }\n      & i {\n        margin-left: 25px;\n        cursor: pointer;\n      }\n    }\n    .main_image_wrapper {\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .main_image {\n        width: 80px;\n        height: auto;\n      }\n      .hover_cover {\n        opacity: 0;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 10;\n        background: #fff;\n        transition: all 0.1s ease-in;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n      }\n      :hover {\n        .hover_cover {\n          opacity: 0.7;\n        }\n      }\n    }\n\n    .cnt_box {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-radius: 5px;\n      font-size: 16px;\n      font-weight: 300;\n      border: 2px solid #e5e5e5;\n      background: #fff;\n      padding: 5px;\n\n      .cnt {\n        padding: 0px 10px;\n      }\n      .icon {\n        padding: 0px 5px;\n        cursor: pointer;\n        :hover {\n          color: #3bb77e;\n        }\n      }\n    }\n\n    .price {\n      font-size: 16px;\n      font-weight: 500;\n    }\n  }\n  .deleteBtn {\n    color: #1b1b1b;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 25px;\n  color: #c4c4c4;\n  margin: auto 0;\n  .empty_icon {\n    overflow: hidden;\n    font-size: 150px;\n    line-height: normal;\n    & i {\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 25px 16px;\n  margin-top: auto;\n\n  .result {\n    border-top: 1px solid #ececec;\n    padding-top: 15px;\n    display: flex;\n    justify-content: space-between;\n  }\n  .cnt {\n    font-size: 16px;\n    & strong {\n      color: #3bb77e;\n    }\n  }\n  .price {\n    color: #3bb77e;\n    font-size: 20px;\n    font-weight: 500;\n  }\n  & button {\n    margin-top: 8px;\n    height: 59px;\n    font-size: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .reorder {\n    :hover {\n      background-color: #3bb77e;\n    }\n  }\n  .cart {\n    background-color: #fff;\n    border-color: #3bb77e;\n    color: #3bb77e;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-top: 1px solid #e4e4e4;\n  background-color: #fff;\n  padding: 10px 15px 0px 15px;\n  margin-bottom: 10px;\n  margin-top: auto;\n  color: #1b1b1b;\n\n  & strong {\n    color: #3bb77e;\n  }\n\n  & li {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 5px;\n    font-size: 1rem;\n    :last-of-type {\n      font-weight: 500;\n      color: #3bb77e;\n      margin-bottom: 0px;\n      margin-top: 15px;\n    }\n  }\n  .info {\n    line-height: 1.2;\n    margin-top: 10px;\n    font-size: 0.8rem;\n    word-break: keep-all;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid #ececec;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 50;\n  position: fixed;\n  bottom: 0;\n  width: 100vw;\n  background-color: #fff;\n  display: none;\n  justify-content: space-between;\n  border-top: 1px solid #ececec;\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n  .active {\n    color: #3bb77e;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 3px;\n  & i {\n    font-size: 20px;\n  }\n  & span {\n    font-size: 12px;\n  }\n  position: relative;\n  .search {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: -5px;\n    z-index: 99;\n    width: fit-content;\n    height: fit-content;\n    margin: 0 auto;\n    width: 54px;\n    height: 54px;\n    & img {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ececec;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  .main_img_wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .main_image {\n      min-width: 80px;\n      max-width: 80px;\n      height: auto;\n    }\n    .hover_cover {\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 10;\n      background: #fff;\n      transition: all 0.1s ease-in;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n    }\n    :hover {\n      .hover_cover {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .info {\n    display: flex;\n    flex-direction: column;\n    padding: 5px 10px;\n\n    & h6 {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: pre-wrap;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      font-size: 16px;\n      font-weight: 300;\n      margin-bottom: 10px;\n    }\n    & p {\n      font-size: 14px;\n      font-weight: 300;\n      color: #1b1b1b !important;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var UserFloatingWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-0"
})(_templateObject(), function(props) {
    return props.$scroll ? "calc(100vh - 73px)" : "calc(100vh - 235px )";
}, function(props) {
    return props.openInner ? "translate(0px)" : "translate(340px)";
});
var IconsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-1"
})(_templateObject1());
var InnerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-2"
})(_templateObject2());
var InnerHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-3"
})(_templateObject3());
var InnerBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-4"
})(_templateObject4());
var InnerTabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-5"
})(_templateObject5());
var AlldeleteBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-abfc9920-6"
})(_templateObject6());
var InnerListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-7"
})(_templateObject7());
var InnerEmptyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-8"
})(_templateObject8());
var ReOrderBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-9"
})(_templateObject9());
var CartBtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-10"
})(_templateObject10());
var InnerFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-11"
})(_templateObject11());
var MobileFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-12"
})(_templateObject12());
var MobileFooterTab = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-13"
})(_templateObject13());
// userview
var ViewListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-14"
})(_templateObject14());
var ViewListBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-abfc9920-15"
})(_templateObject15());


/***/ }),

/***/ 80632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ MobileContactInfo; },
/* harmony export */   "Hs": function() { return /* binding */ MobileListWrapper; },
/* harmony export */   "Is": function() { return /* binding */ FooterBodySection; },
/* harmony export */   "K5": function() { return /* binding */ MobileFooterBodySection; },
/* harmony export */   "Ld": function() { return /* binding */ MobileSocialIconWrapper; },
/* harmony export */   "VE": function() { return /* binding */ ScrollTopBtn; },
/* harmony export */   "Z4": function() { return /* binding */ FooterBottomWrapper; },
/* harmony export */   "az": function() { return /* binding */ FooterBottomCol; },
/* harmony export */   "bk": function() { return /* binding */ FooterContainer; },
/* harmony export */   "sw": function() { return /* binding */ FooterCopyWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 56px;\n  height: 56px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1rem;\n  position: fixed;\n  bottom: 20px;\n  right: 23px;\n  z-index: 999;\n  cursor: pointer;\n  @media (max-width: 991px) {\n    right: 13px;\n    bottom: 135px;\n    width: 44px;\n    height: 44px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n  border: 1px solid #ececec;\n\n  @media (max-width: 1199px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 50px;\n  margin-bottom: 50px;\n\n  @media (max-width: 1199px) {\n    flex-wrap: wrap;\n  }\n  @media (max-width: 767px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  & p {\n    margin: 0;\n  }\n\n  & li {\n    width: fit-content;\n    display: flex;\n    align-items: center;\n  }\n\n  & h6 {\n    margin-right: 5px;\n  }\n\n  & span {\n    word-break: keep-all;\n    margin-right: 5px;\n  }\n\n  & a {\n    width: 250px;\n  }\n\n  @media (max-width: 1199px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n\n  & h6 {\n    display: inline-block;\n    margin-right: 15px;\n  }\n  & a {\n    text-align: center;\n    font-size: 14px;\n    margin-right: 5px;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    height: 40px;\n    width: 40px !important;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    background: #3bb77e;\n    border-radius: 30px;\n    line-height: 1;\n    -ms-flex-line-pack: center;\n    align-content: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    align-items: center;\n    :hover {\n      opacity: 0.6;\n      -webkit-transform: translateY(-2px);\n      transform: translateY(-2px);\n      -webkit-transition-duration: 0.5s;\n      transition-duration: 0.5s;\n      margin-top: -2px;\n    }\n  }\n  & img {\n    max-width: 20px;\n    max-height: 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-right: var(--bs-gutter-x, 0.75rem);\n  padding-left: var(--bs-gutter-x, 0.75rem);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  width: 100%;\n  position: relative;\n  border: 1px solid #ececec;\n\n  @media (max-width: 1199px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  margin-bottom: 20px;\n  & li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    & a {\n      color: #696969;\n      font-size: 14px;\n    }\n  }\n  @media (max-width: 354px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 5px;\n    grid-row-gap: 5px;\n    & li {\n      & a {\n        font-size: 14px;\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n\n  & li {\n    display: flex;\n    align-items: center;\n    & h6 {\n      color: #696969;\n      margin-right: 10px;\n      font-size: 16px;\n      white-space: nowrap;\n    }\n    & span {\n      color: #696969;\n      font-size: 16px;\n      word-break: keep-all;\n    }\n  }\n  @media (max-width: 575px) {\n    & li {\n      & h6 {\n        font-size: 14px;\n      }\n      & span {\n        color: #696969;\n        font-size: 14px;\n        word-break: keep-all;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var ScrollTopBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3e5edacc-0"
})(_templateObject());
// 기존 FooterBodySection에 상하 테두리 관련 변경
var FooterBodySection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3e5edacc-1"
})(_templateObject1());
var FooterBottomWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3e5edacc-2"
})(_templateObject2());
var FooterBottomCol = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3e5edacc-3"
})(_templateObject3());
var MobileSocialIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3e5edacc-4"
})(_templateObject4());
var FooterCopyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3e5edacc-5"
})(_templateObject5());
// 푸터 전체 컨테이너에 상하 테두리 추가
var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].footer.withConfig */ .ZP.footer.withConfig({
    componentId: "sc-3e5edacc-6"
})(_templateObject6());
var MobileFooterBodySection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3e5edacc-7"
})(_templateObject7());
var MobileListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-3e5edacc-8"
})(_templateObject8());
var MobileContactInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-3e5edacc-9"
})(_templateObject9());


/***/ }),

/***/ 32511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/layout/Breadcrumb.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: #7e7e7e;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 0 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: #7e7e7e;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 0 10px;\n  &::before {\n    content: none !important;\n    display: none !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-25becd1-0"
})(_templateObject());
var StyledTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-25becd1-1"
})(_templateObject1());
var Breadcrumb = function(param) {
    var parent = param.parent, sub = param.sub, subTitle = param.subTitle, subChild = param.subChild, detailsubChild = param.detailsubChild, noBreadcrumb = param.noBreadcrumb, id = param.id, _isSubLinkActive = param.// 각 수준별로 링크 활성화 여부 제어
    isSubLinkActive, isSubLinkActive = _isSubLinkActive === void 0 ? true : _isSubLinkActive, _isSubTitleLinkActive = param.isSubTitleLinkActive, isSubTitleLinkActive = _isSubTitleLinkActive === void 0 ? true : _isSubTitleLinkActive, _isSubChildLinkActive = param.isSubChildLinkActive, isSubChildLinkActive = _isSubChildLinkActive === void 0 ? true : _isSubChildLinkActive;
    // 다음 단계가 undefined이면 현재 단계 링크 비활성화
    var effectiveSubLinkActive = subTitle === undefined ? false : isSubLinkActive;
    var effectiveSubTitleLinkActive = subChild === undefined ? false : isSubTitleLinkActive;
    var effectiveSubChildLinkActive = detailsubChild === undefined ? false : isSubChildLinkActive;
    // 메인 카테고리 URL 생성 함수
    var getSubUrl = function() {
        if (sub === "\uB85C\uADF8\uC778") return "/login/";
        if (sub === "\uC7A5\uBC14\uAD6C\uB2C8") return "/shop-cart/";
        if (sub === "\uB9C8\uC774\uD398\uC774\uC9C0") return "/mypage/order/";
        if (sub === "\uD658\uACBD\uD65C\uB3D9") return "/environment/about/";
        if (sub === "\uC0C1\uD488\uAD6C\uB9E4") return "/products/";
        if (sub === "ESG\uC790\uB8CC\uC2E4") return "/esg-guide/";
        if (sub === "\uACF5\uC9C0\uC0AC\uD56D") return "/csboard/notice/";
        if (sub === "\uB9DE\uCDA4\uC81C\uC791") return "/customizing/customizing-products/";
        if (sub === "\uC18C\uB7C9\uC778\uC1C4") return "/customizing/print/";
        // if (sub === "결제")
        return "/";
    };
    // 서브 타이틀 URL 생성 함수
    var getSubTitleUrl = function() {
        if (sub === "\uC0C1\uD488\uAD6C\uB9E4") {
            return "/products/".concat(encodeURIComponent(id), "/");
        }
        if (sub === "ESG\uC790\uB8CC\uC2E4") {
            if (subTitle === "ESG \uD658\uACBD\uB274\uC2A4") return "/esg-guide/news/";
            if (subTitle === "ESG \uB274\uC2A4\uB808\uD130") return "/esg-guide/letter/";
            //포장재 인증정보는 상세 없으므로 생략
            if (subTitle === "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC") return "/esg-guide/blog/package/";
            if (subTitle === "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0") return "/esg-guide/blog/make/";
            return "/esg-guide/";
        }
        if (sub === "\uACE0\uAC1D\uC13C\uD130") {
            return "/csboard/notice/";
        }
        return "/";
    };
    // 서브 차일드 URL 생성 함수
    var getSubChildUrl = function() {
        if (sub === "\uC0C1\uD488\uAD6C\uB9E4") {
            return "/products/".concat(encodeURIComponent(id), "/").concat(encodeURIComponent(subChild), "/");
        }
        return "/";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page-header breadcrumb-wrap ".concat(noBreadcrumb),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "breadcrumb",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: parent
                            })
                        }),
                        sub && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: effectiveSubLinkActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        href: getSubUrl(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: sub
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    sub
                                ]
                            })
                        }),
                        subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: effectiveSubTitleLinkActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        href: getSubTitleUrl(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: subTitle
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    subTitle
                                ]
                            })
                        }),
                        subChild && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: effectiveSubChildLinkActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        href: getSubChildUrl(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: subChild
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    ">",
                                    subChild
                                ]
                            })
                        }),
                        detailsubChild ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                ">",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                    children: detailsubChild
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var layout_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./redux/action/modal.js
var modal = __webpack_require__(62241);
// EXTERNAL MODULE: ./components/layout/Footer.styles.js
var Footer_styles = __webpack_require__(80632);
;// CONCATENATED MODULE: ./components/floating/footer.js


var FooterFloating = function(props) {
    var onClickTopButton = props.onClickTopButton, scrollY = props.scrollY;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: scrollY && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles/* ScrollTopBtn */.VE, {
                onClick: onClickTopButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/assets/imgs/theme/icons/toTopIcon_150x150.png"
                })
            })
        })
    });
};
/* harmony default export */ var footer = (FooterFloating);

;// CONCATENATED MODULE: ./components/layout/Footer.js








var Footer = function(param) {
    var _$openModal = param.openModal, _$modifyModal = param.modifyModal, dummyList = param.dummyList;
    var ref = (0,react.useState)(), scrollY = ref[0], setScrollY = ref[1];
    var onClickTopButton = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", function() {
            var scrollCheck = window.scrollY > 0;
            if (scrollCheck !== scroll) {
                setScrollY(scrollCheck);
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* FooterContainer */.bk, {
            className: "main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {
                    onClickTopButton: onClickTopButton,
                    scrollY: scrollY
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles/* FooterBodySection */.Is, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* FooterBottomWrapper */.Z4, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* FooterBottomCol */.az, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/logo-footer-icon.svg",
                                                    alt: "logo",
                                                    style: {
                                                        width: "15rem"
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "font-lg text-heading",
                                            children: [
                                                "\uC2A4\uB9C8\uD2B8 \uD328\uD0A4\uC9D5 \uC194\uB8E8\uC158 \uD50C\uB7AB\uD3FC ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uB294 \uC2A4\uB9C8\uD2B8 \uADF8\uB9B0\uD14C\uD06C\uB97C \uD1B5\uD574",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " \uC9C0\uC18D\uAC00\uB2A5\uD55C \uD328\uD0A4\uC9D5 \uC194\uB8E8\uC158\uC744 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "\uC81C\uC548\uD558\uB294 \uD50C\uB7AB\uD3FC\uC785\uB2C8\uB2E4."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* FooterBottomCol */.az, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "widget-title",
                                            children: "INTRODUCTION"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "widget-title-underLine",
                                            style: {
                                                width: "3rem",
                                                borderTop: "2px solid #3bb77e",
                                                marginBottom: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "contact-infor",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-location.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uC8FC\uC2DD\uD68C\uC0AC\uCE7C\uB81B\uBC14\uC774\uC624 \uB300\uD45C :"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "\uAD8C\uC601\uC0BC"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-location.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638 :"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "543-81-01280"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=5438101280",
                                                            style: {
                                                                width: "fit-content",
                                                                color: "#253D4E"
                                                            },
                                                            target: "_blank",
                                                            children: "[\uC0AC\uC5C5\uC790\uB4F1\uB85D\uC815\uBCF4\uD655\uC778]"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-location.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uC8FC\uC18C : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "\uC11C\uC6B8\uD2B9\uBCC4\uC2DC \uB9C8\uD3EC\uAD6C \uBC31\uBC94\uB85C 235 2\uCE35 ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                "(\uC2E0\uACF5\uB355\uB3D9, \uC2E0\uBCF4\uBE4C\uB529)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-location.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5 : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "\uC81C2022-\uC11C\uC6B8\uB9C8\uD3EC-2371\uD638"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-contact.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "TEL : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "02-6964-6930 "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "FAX : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "02-6455-5692"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-clock.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uC0C1\uB2F4\uAC00\uB2A5\uC2DC\uAC04 : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "09:00 - 18:00, \uC6D4 - \uAE08"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/assets/imgs/theme/icons/icon-email-2.svg",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: "\uC81C\uD734\uBB38\uC758 : "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/csboard/contact",
                                                                children: "\uC81C\uD734 \uBB38\uC758 \uD558\uB7EC\uAC00\uAE30"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* FooterBottomCol */.az, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "widget-title",
                                            children: "COMMUNITY"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "widget-title-underLine",
                                            style: {
                                                width: "3rem",
                                                borderTop: "2px solid #3bb77e",
                                                marginBottom: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "footer-list mb-sm-5 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/about",
                                                        children: "\uD68C\uC0AC\uC18C\uAC1C"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/csboard/notice/",
                                                        children: "\uACF5\uC9C0\uC0AC\uD56D"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/csboard/faq/",
                                                        children: "FAQ"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/privacy-policy",
                                                        children: "\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/store-policy",
                                                        children: "\uC774\uC6A9\uC57D\uAD00"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "http://www.stepfornetzero.com/",
                                                        target: "_blank",
                                                        children: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileSocialIconWrapper */.Ld, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://pf.kakao.com/_MCxnhxj",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/theme/icons/kakao-talk.png",
                                                                    alt: "kakaoIcon"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://www.facebook.com/caretstore",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/theme/icons/icon-facebook-white.svg",
                                                                    alt: "facebookIcon"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://www.instagram.com/caretstore/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/theme/icons/icon-instagram-white.svg",
                                                                    alt: "instagramIcon"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://talk.naver.com/ct/w4kznv",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/theme/icons/icon-naver-talk.png",
                                                                    alt: "naverTalkIcon"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://www.youtube.com/channel/UC1MTYtvC363yWAB4uf8CBhQ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/imgs/theme/icons/icon-youtube-white.svg",
                                                                    alt: "youtubeIcon"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://blog.naver.com/caretstore",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://cdn.imweb.me/upload/S20200506960caff1c89c9/522104c187709.png",
                                                                    alt: "blogIcon"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles/* MobileFooterBodySection */.K5, {
                    className: "section-padding pt-0 footer-mid",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container pb-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20 row"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileListWrapper */.Hs, {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/about",
                                            children: "\uD68C\uC0AC\uC18C\uAC1C"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/store-policy",
                                            children: "\uC774\uC6A9\uC57D\uAD00"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/privacy-policy",
                                            children: "\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/csboard/notice/",
                                            children: "\uACF5\uC9C0\uC0AC\uD56D"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/csboard/faq/",
                                            children: "FAQ"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "http://www.stepfornetzero.com/",
                                            target: "_blank",
                                            children: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileContactInfo */.$A, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uC8FC\uC2DD\uD68C\uC0AC\uCE7C\uB81B\uBC14\uC774\uC624 \uB300\uD45C :"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "\uAD8C\uC601\uC0BC"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638 :"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "543-81-01280"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uD1B5\uC2E0\uD310\uB9E4\uC5C5 : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "\uC81C2022-\uC11C\uC6B8\uB9C8\uD3EC-2371\uD638"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uC8FC\uC18C : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "\uC11C\uC6B8\uD2B9\uBCC4\uC2DC \uB9C8\uD3EC\uAD6C \uBC31\uBC94\uB85C 235 2\uCE35 (\uC2E0\uACF5\uB355\uB3D9, \uC2E0\uBCF4\uBE4C\uB529)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileContactInfo */.$A, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "TEL : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "02-6964-6930 "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "FAX : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "02-6455-5692"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uC0C1\uB2F4\uAC00\uB2A5\uC2DC\uAC04 : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "09:00 - 18:00, \uC6D4 - \uAE08"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "\uC81C\uD734\uBB38\uC758 : "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/csboard/contact",
                                                    children: "\uC81C\uD734 \uBB38\uC758 \uD558\uB7EC\uAC00\uAE30"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileSocialIconWrapper */.Ld, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://pf.kakao.com/_MCxnhxj",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/kakao-talk.png",
                                                alt: "kakaoIcon"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.facebook.com/caretstore",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-facebook-white.svg",
                                                alt: "facebookIcon"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.instagram.com/caretstore/",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-instagram-white.svg",
                                                alt: "instagramIcon"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://talk.naver.com/ct/w4kznv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-naver-talk.png",
                                                alt: "naverTalkIcon"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.youtube.com/channel/UC1MTYtvC363yWAB4uf8CBhQ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-youtube-white.svg",
                                                alt: "youtubeIcon"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://blog.naver.com/caretstore",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "https://cdn.imweb.me/upload/S20200506960caff1c89c9/522104c187709.png",
                                                alt: "blogIcon"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_styles/* FooterCopyWrapper */.sw, {
                    className: "container pb-20 wow animate__animated animate__fadeInUp ",
                    "data-wow-delay": "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xl-5 col-lg-6 col-md-6 mt-10",
                                style: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-sm mb-0",
                                    children: "\xa9 2021 CARETBIO. All rights reserved"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
var mapDispatchToProps = {
    openModal: modal/* openModal */.h7,
    modifyModal: modal/* modifyModal */.mn
};
/* harmony default export */ var layout_Footer = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Footer));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/baskets.js
var baskets = __webpack_require__(83173);
// EXTERNAL MODULE: ./redux/action/productFiltersAction.js
var productFiltersAction = __webpack_require__(7330);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/form-data/lib/browser.js
var browser = __webpack_require__(6230);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./api/dummy.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var varListDummy = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var body, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    body = {
                        modes: "VarList"
                    };
                    _ctx.next = 3;
                    return (0,http/* default */.Z)(resources/* default.DUMMY */.Z.DUMMY).post(body);
                case 3:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function varListDummy() {
        return _ref.apply(this, arguments);
    };
}();
var varListTestDummySSR = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var formData, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formData = new (browser_default())();
                    formData.append("modes", "VarList");
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return axios_default().post("https://api.caretbio.com/api/store/DefaultArray", formData, {
                        headers: formData.getHeaders()
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    console.error("SSR \uC694\uCCAD \uC2E4\uD328:", _ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    }));
    return function varListTestDummySSR() {
        return _ref.apply(this, arguments);
    };
}();
var postDefaultArray = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(body) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,http/* default */.Z)(resources/* default.DUMMY */.Z.DUMMY).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postDefaultArray(body) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./redux/constants/actionTypes.js
var actionTypes = __webpack_require__(46330);
;// CONCATENATED MODULE: ./redux/action/dummy.js
function dummy_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function dummy_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                dummy_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                dummy_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchDummyList = function() {
    return function() {
        var _ref = dummy_asyncToGenerator(runtime_default().mark(function _callee(dispatch) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return varListDummy();
                    case 3:
                        res = _ctx.sent;
                        dispatch({
                            type: actionTypes/* FETCH_DUMMY */.US,
                            payload: {
                                dummyList: res.Data
                            }
                        });
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./common/pageRouter.js
var pageRouter = __webpack_require__(92534);
// EXTERNAL MODULE: ./components/floating/user.styles.js
var user_styles = __webpack_require__(51375);
// EXTERNAL MODULE: ./api/order.js
var order = __webpack_require__(50059);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./api/baskets.js
var api_baskets = __webpack_require__(18682);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./components/floating/user/UserReOrder.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function UserReOrder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UserReOrder_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UserReOrder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UserReOrder_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var UserReOrder = function(props) {
    var activeTab = props.activeTab, fetchBasketsAction = props.fetchBasketsAction, setActievTab = props.setActievTab;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)([]), confirmItems = ref7[0], setConfirmItems = ref7[1];
    var ref1 = (0,react.useState)([]), selectedItem = ref1[0], setSelectedItem = ref1[1];
    var ref2 = (0,react.useState)([]), reOrderProducts = ref2[0], setReOrderProducts = ref2[1];
    var ref3 = (0,react.useState)(false), reOrderLoading = ref3[0], setReOrderLoading = ref3[1];
    // 전체 선택
    var selectAllItems = function(e) {
        if (e.target.checked) {
            var tempArr = new Array(reOrderProducts.length).fill(true);
            setSelectedItem(tempArr);
            setConfirmItems(reOrderProducts);
        } else {
            var tempArr2 = new Array(reOrderProducts.length).fill(false);
            setSelectedItem(tempArr2);
            setConfirmItems([]);
        }
    };
    // 선택
    var selectItem = function(e, el, i) {
        var tempArr = _toConsumableArray(selectedItem);
        tempArr[i] = e.target.checked;
        setSelectedItem(tempArr);
        if (e.target.checked) {
            var tempArr2 = _toConsumableArray(confirmItems);
            tempArr2.push(el);
            setConfirmItems(tempArr2);
        } else {
            var tempArr21 = _toConsumableArray(confirmItems);
            var index = tempArr21.findIndex(function(product) {
                return product.pcode === el.pcode;
            });
            tempArr21.splice(index, 1);
            setConfirmItems(tempArr21);
        }
    };
    // 개수 증가
    var increaseCnt = function(item) {
        var i = reOrderProducts.findIndex(function(el) {
            return el.pcode === item.pcode;
        });
        reOrderProducts[i].cnt = Number(reOrderProducts[i].cnt) + 1;
        setReOrderProducts(_toConsumableArray(reOrderProducts));
    };
    // 개수 감소
    var decreaseCnt = function(item) {
        var i = reOrderProducts.findIndex(function(el) {
            return el.pcode === item.pcode;
        });
        if (reOrderProducts[i].cnt > 1) {
            reOrderProducts[i].cnt = Number(reOrderProducts[i].cnt) - 1;
            setReOrderProducts(_toConsumableArray(reOrderProducts));
        }
    };
    // 전체 금액
    var price1 = function() {
        var price = 0;
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(item) {
            return price += item.discount_price * Number(item.cnt);
        });
        return price;
    };
    // 재구매 컨펌
    var confirmReOrder = function() {
        var _ref = UserReOrder_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sessionStorage.setItem("repayOrder", JSON.stringify(confirmItems));
                        setActievTab(undefined);
                        router.push("/checkout?type=repay");
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function confirmReOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 담기
    var confirmCart = function() {
        var _ref = UserReOrder_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify(confirmItems)
                        };
                        _ctx.next = 3;
                        return (0,api_baskets/* insertBaskets */.nh)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.code === "0000") {
                            fetchBasketsAction();
                            (0,common_alert/* successAddToCart */.qZ)();
                        } else {
                            (0,common_alert/* failAlert */.qh)(res.msg || "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30 \uC2E4\uD328");
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function confirmCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // 재구매 리스트 불러오기
    var fetchReOrderProducts = function() {
        var _ref = UserReOrder_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref4, ref5, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setReOrderLoading(true);
                        body = {
                            modes: "ReOrderProducts"
                        };
                        _ctx.next = 4;
                        return (0,order/* StoreOrderApi */.RJ)(body);
                    case 4:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            if (selectedItem.length <= 0) {
                                ;
                                setSelectedItem(new Array(((ref4 = res.Data) === null || ref4 === void 0 ? void 0 : ref4.Data) ? (ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Data.length : 1).fill(false));
                            }
                            setReOrderProducts((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data.map(function(el) {
                                return _objectSpread({}, el, {
                                    cnt: 1
                                });
                            }));
                            setReOrderLoading(false);
                        }
                        if (res.Code === "9999") {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref6 = res.Data) === null || ref6 === void 0 ? void 0 : ref6.Msg) || "\uC7AC\uAD6C\uB9E4 \uB9AC\uC2A4\uD2B8 \uBD88\uB7EC\uC624\uAE30 \uC2E4\uD328");
                            setReOrderLoading(false);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchReOrderProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if ((0,auth/* getCookie */.ej)("token")) {
            if (activeTab === "reorder") fetchReOrderProducts();
        }
    }, [
        router.isReady,
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            reOrderProducts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerListWrapper */.Ev, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "custome-checkbox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                className: "form-check-input",
                                id: "checkReOrderAll",
                                onChange: function(e) {
                                    return selectAllItems(e);
                                },
                                checked: !selectedItem.includes(false)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "form-check-label d-flex align-items-center text-dark",
                                htmlFor: "checkReOrderAll",
                                children: "\uC804\uCCB4 \uC120\uD0DD"
                            })
                        ]
                    }),
                    reOrderProducts.map(function(product, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product_box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "top",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "custome-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "form-check-input",
                                                id: "checkBox".concat(i),
                                                onChange: function(e) {
                                                    return selectItem(e, product, i);
                                                },
                                                checked: selectedItem[i] ? true : false
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "form-check-label d-flex",
                                                htmlFor: "checkBox".concat(i),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    className: "pname",
                                                    children: product.pname
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "main_image_wrapper",
                                            onClick: function() {
                                                return router.push("/products/".concat(product.ename, "/").concat(product.pcode, "/"));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: product.main_image,
                                                    alt: product.pname,
                                                    role: "button",
                                                    className: "main_image"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hover_cover",
                                                    children: "\uC0C1\uC138\uBCF4\uAE30"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex flex-column justify-content-between ms-2 py-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cnt_box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fi-rs-minus-small",
                                                                onClick: function() {
                                                                    return decreaseCnt(product);
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "cnt",
                                                            children: Number(product.cnt)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fi-rs-plus-small",
                                                                onClick: function() {
                                                                    return increaseCnt(product);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "price",
                                                    children: [
                                                        (0,splicePrice/* priceComma */.a)(product.discount_price * Number(product.cnt)),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerEmptyWrapper */.zE, {
                children: [
                    reOrderLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white position-absolute w-100 h-100 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                            animation: "border",
                            role: "status"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "empty_icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-box-open"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\uC774\uC804 \uAD6C\uB9E4 \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* ReOrderBtnWrapper */.MH, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "result",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cnt",
                                children: [
                                    "\uCD1D ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.length
                                    }),
                                    "\uAC74"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price",
                                children: [
                                    (0,splicePrice/* priceComma */.a)(price1()),
                                    "\uC6D0"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "btn reorder",
                        onClick: function() {
                            return confirmReOrder();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-time-past me-2"
                            }),
                            "\uC7AC\uAD6C\uB9E4"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "btn cart",
                        onClick: function() {
                            return confirmCart();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-shopping-cart me-2"
                            }),
                            "\uC7A5\uBC14\uAD6C\uB2C8"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var user_UserReOrder = (UserReOrder);

;// CONCATENATED MODULE: ./components/floating/user/UserCart.js
function UserCart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function UserCart_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return UserCart_arrayLikeToArray(arr);
}
function UserCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UserCart_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UserCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UserCart_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function UserCart_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function UserCart_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function UserCart_toConsumableArray(arr) {
    return UserCart_arrayWithoutHoles(arr) || UserCart_iterableToArray(arr) || UserCart_unsupportedIterableToArray(arr) || UserCart_nonIterableSpread();
}
function UserCart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return UserCart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UserCart_arrayLikeToArray(o, minLen);
}











var UserCart = function(props) {
    var activeTab = props.activeTab, basketItems = props.basketItems, clearBasketsAction = props.clearBasketsAction, modifyConfirmModal = props.modifyConfirmModal, openConfirmModal = props.openConfirmModal, closeConfirmModal = props.closeConfirmModal, deleteBasketsAction = props.deleteBasketsAction, fetchBasketsAction = props.fetchBasketsAction, cartItems = props.cartItems, clearCart = props.clearCart, deleteFromCart = props.deleteFromCart, setActievTab = props.setActievTab, decreaseCnt = props.decreaseCnt, increaseCnt = props.increaseCnt, userInfo = props.userInfo;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)([]), confirmItems = ref5[0], setConfirmItems = ref5[1];
    var ref1 = (0,react.useState)([]), selectedItem = ref1[0], setSelectedItem = ref1[1];
    var ref2 = (0,react.useState)(false), cartLoading = ref2[0], setCartLoading = ref2[1];
    var ref3 = (0,react.useState)([]), cartProducts = ref3[0], setCartProducts = ref3[1];
    var ref4 = (0,react.useState)(), token1 = ref4[0], setToken = ref4[1];
    // 전체 선택
    var selectAllItems = function(e) {
        if (e.target.checked) {
            var tempArr = new Array(cartProducts.length).fill(true);
            setSelectedItem(tempArr);
            setConfirmItems(cartProducts);
        } else {
            var tempArr2 = new Array(cartProducts.length).fill(false);
            setSelectedItem(tempArr2);
            setConfirmItems([]);
        }
    };
    // 전체삭제
    var deleteAll = function() {
        var content = {
            title: "\uC804\uBD80 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            actionBtnLabel: "\uD655\uC778",
            actionBtnValid: true,
            cancelBtnLabel: "\uCDE8\uC18C",
            onAction: function() {
                if ((0,auth/* getCookie */.ej)("token")) {
                    clearBasketsAction();
                } else {
                    clearCart();
                    (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8 \uC804\uCCB4 \uC0AD\uC81C \uC644\uB8CC");
                }
                setConfirmItems([]);
                closeConfirmModal();
            }
        };
        modifyConfirmModal(content);
        openConfirmModal();
    };
    // 선택
    var selectItem = function(e, el, i) {
        var tempArr = UserCart_toConsumableArray(selectedItem);
        tempArr[i] = e.target.checked;
        setSelectedItem(tempArr);
        if (e.target.checked) {
            var tempArr2 = UserCart_toConsumableArray(confirmItems);
            tempArr2.push(el);
            setConfirmItems(tempArr2);
        } else {
            var tempArr21 = UserCart_toConsumableArray(confirmItems);
            var index = tempArr21.findIndex(function(product1) {
                return product1.pcode === el.pcode;
            });
            tempArr21.splice(index, 1);
            setConfirmItems(tempArr21);
        }
    };
    // 선택 삭제
    var handleDelete = function(item, i) {
        var content = {
            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            actionBtnLabel: "\uD655\uC778",
            actionBtnValid: true,
            cancelBtnLabel: "\uCDE8\uC18C",
            onAction: function() {
                var ref;
                (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) ? deleteBasketsAction(item, i) : deleteFromCart(item.pcode, i);
                confirmItems.splice(i, 1);
                setConfirmItems(UserCart_toConsumableArray(confirmItems));
                selectedItem.splice(i, 1);
                setSelectedItem(UserCart_toConsumableArray(selectedItem));
                closeConfirmModal();
            }
        };
        modifyConfirmModal(content);
        openConfirmModal();
    };
    // 회원 장바구니 갯수 증가
    var increaseBasketProduct = function() {
        var _ref = UserCart_asyncToGenerator(runtime_default().mark(function _callee(item) {
            var i, body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        i = basketItems.findIndex(function(el) {
                            return el.pcode === item.pcode;
                        });
                        basketItems[i].cnt = Number(basketItems[i].cnt) + 1;
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify([
                                {
                                    pcode: item.pcode,
                                    cnt: basketItems[i].cnt
                                }
                            ])
                        };
                        _ctx.next = 5;
                        return (0,api_baskets/* insertBaskets */.nh)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setConfirmItems(data === null || data === void 0 ? void 0 : data.data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function increaseBasketProduct(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 회원 장바구니 갯수 감소
    var decreaseBasketProduct = function() {
        var _ref = UserCart_asyncToGenerator(runtime_default().mark(function _callee(item) {
            var i, body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        i = basketItems.findIndex(function(el) {
                            return el.pcode === item.pcode;
                        });
                        if (basketItems[i].cnt > 1) basketItems[i].cnt = Number(basketItems[i].cnt) - 1;
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify([
                                {
                                    pcode: item.pcode,
                                    cnt: basketItems[i].cnt
                                }
                            ])
                        };
                        _ctx.next = 5;
                        return (0,api_baskets/* insertBaskets */.nh)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setConfirmItems(data === null || data === void 0 ? void 0 : data.data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function decreaseBasketProduct(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 결제하기
    var onClickCheckout = function() {
        var _ref = UserCart_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!((basketItems === null || basketItems === void 0 ? void 0 : basketItems.length) < 1)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"));
                    case 3:
                        if (!(((ref = confirmItems.filter(function(el) {
                            return el != undefined;
                        })) === null || ref === void 0 ? void 0 : ref.length) < 1)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC120\uD0DD\uB41C \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"));
                    case 5:
                        sessionStorage.setItem("cartOrder", JSON.stringify(confirmItems.filter(function(el) {
                            return el != undefined;
                        })));
                        setActievTab(undefined);
                        router.push({
                            pathname: "/checkout",
                            query: {
                                type: "cart"
                            }
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    // 전체 금액
    var price1 = function() {
        var price = 0;
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(item) {
            return price += item.discount_price * item.cnt;
        });
        return price;
    };
    // 할인,할증 없는 배송료
    var nonCheckDelPrice = function() {
        var delPrice = 0;
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(item) {
            return delPrice += (item.delivery_type === "\uBB34\uB8CC" || item.delivery === "\uBB34\uB8CC" ? 0 : item.delivery_price) * (item.bundle === "Y" ? item.cnt : 1);
        });
        return delPrice;
    };
    // 할인,할증 포함 배송료
    var deliveryPrice = function() {
        var delPrice = 0;
        var baesong_temp = [];
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(temp_item) {
            var delivery_price_temp = 0;
            if (temp_item.delivery_type === "C" || temp_item.delivery === "C") return 0;
            delivery_price_temp = Number(temp_item.delivery_price);
            var delivery_price = 0;
            if (temp_item.delivery_type === "A" || temp_item.delivery_type === "F" || temp_item.delivery === "A" || temp_item.delivery === "F") {
                if (temp_item.bundle === "Y") {
                    delivery_price = delivery_price_temp * Number(temp_item.cnt);
                } else if (temp_item.bundle === "N") {
                    if (baesong_temp.includes(temp_item.supplier)) {
                        delivery_price = 0;
                    } else {
                        delivery_price = delivery_price_temp;
                        baesong_temp.push(temp_item.supplier);
                    }
                }
            } else {
                delivery_price = delivery_price_temp;
            }
            delPrice += delivery_price;
        });
        return delPrice;
    };
    // 토큰 유무 판별
    var checkItems = function() {
        var _ref = UserCart_asyncToGenerator(runtime_default().mark(function _callee() {
            var newItems, newItems1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCartLoading(true);
                        if (!token1) {
                            _ctx.next = 16;
                            break;
                        }
                        if (basketItems) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setCartProducts(basketItems);
                        if (!(selectedItem.length > 0 && basketItems.length > selectedItem.length)) {
                            _ctx.next = 12;
                            break;
                        }
                        newItems = new Array(basketItems.length - selectedItem.length).fill(true);
                        setSelectedItem(UserCart_toConsumableArray(newItems).concat(UserCart_toConsumableArray(selectedItem)));
                        setConfirmItems([
                            basketItems[0]
                        ].concat(UserCart_toConsumableArray(confirmItems)));
                        return _ctx.abrupt("return");
                    case 12:
                        {
                            setConfirmItems(basketItems);
                            setSelectedItem(new Array(basketItems ? basketItems.length : 1).fill(true));
                        }
                    case 13:
                        setCartLoading(false);
                        _ctx.next = 28;
                        break;
                    case 16:
                        if (cartItems) {
                            _ctx.next = 18;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 18:
                        setCartProducts(cartItems);
                        if (!(selectedItem.length > 0 && cartItems.length > selectedItem.length)) {
                            _ctx.next = 26;
                            break;
                        }
                        newItems1 = new Array(cartItems.length - selectedItem.length).fill(true);
                        setSelectedItem(UserCart_toConsumableArray(newItems1).concat(UserCart_toConsumableArray(selectedItem)));
                        setConfirmItems([
                            cartItems[0]
                        ].concat(UserCart_toConsumableArray(confirmItems)));
                        return _ctx.abrupt("return");
                    case 26:
                        {
                            setConfirmItems(cartItems);
                            setSelectedItem(new Array(cartItems ? cartItems.length : 1).fill(true));
                        }
                    case 27:
                        setCartLoading(false);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkItems() {
            return _ref.apply(this, arguments);
        };
    }();
    // 회원 여부 체크
    var checkUser = function() {
        var _ref = UserCart_asyncToGenerator(runtime_default().mark(function _callee() {
            var token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,auth/* getCookie */.ej)("token");
                    case 2:
                        token = _ctx.sent;
                        setToken(token);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkUser() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkUser();
    }, []);
    (0,react.useEffect)(function() {
        checkItems();
    }, [
        token1,
        cartItems,
        basketItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            cartProducts && cartProducts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerListWrapper */.Ev, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-2 d-flex justify-content-between align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custome-checkbox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        className: "form-check-input",
                                        id: "checkAllCart",
                                        onChange: selectAllItems,
                                        checked: selectedItem.includes(false) ? false : true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label d-flex align-items-center text-dark",
                                        htmlFor: "checkAllCart",
                                        children: "\uC804\uCCB4 \uC120\uD0DD"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(user_styles/* AlldeleteBtn */.JR, {
                                onClick: function() {
                                    return deleteAll();
                                },
                                children: "\uC804\uCCB4\uC0AD\uC81C"
                            })
                        ]
                    }),
                    cartProducts.map(function(product2, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product_box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "top",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "custome-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    id: "checkBoxCart".concat(i),
                                                    onChange: function(e) {
                                                        return selectItem(e, product2, i);
                                                    },
                                                    checked: selectedItem[i] ? true : false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "form-check-label d-flex",
                                                    htmlFor: "checkBoxCart".concat(i),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "pname",
                                                        children: product2.pname
                                                    })
                                                })
                                            ]
                                        }),
                                        activeTab === "cart" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "deleteBtn",
                                            onClick: function() {
                                                return handleDelete(product2, i);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-trash"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "main_image_wrapper",
                                            onClick: function() {
                                                return router.push("/products/".concat(product2.ename, "/").concat(product2.pcode, "/"));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: product2.main_image,
                                                    alt: product2.pname,
                                                    role: "button",
                                                    className: "main_image"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hover_cover",
                                                    children: "\uC0C1\uC138\uBCF4\uAE30"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex flex-column justify-content-between ms-2 py-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cnt_box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fi-rs-minus-small",
                                                                onClick: function(e) {
                                                                    return token1 ? decreaseBasketProduct(product2) : decreaseCnt(product2.pcode);
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "cnt",
                                                            children: product2.cnt
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fi-rs-plus-small",
                                                                onClick: function(e) {
                                                                    return token1 ? increaseBasketProduct(product2) : increaseCnt(product2.pcode);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "price",
                                                    children: [
                                                        (0,splicePrice/* priceComma */.a)(product2.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerEmptyWrapper */.zE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "empty_icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-box-open"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* CartBtnWrapper */.mY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "\uCD1D ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.length
                                        }),
                                        "\uAC74"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uCD1D \uC0C1\uD488\uAE08\uC561"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,splicePrice/* priceComma */.a)(price1()) + "\uC6D0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uCD1D \uBC30\uC1A1\uBE44"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "+" + (0,splicePrice/* priceComma */.a)(nonCheckDelPrice()) + "\uC6D0"
                                    })
                                ]
                            }),
                            deliveryPrice() - nonCheckDelPrice() !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: deliveryPrice() - nonCheckDelPrice() < 0 ? "text-danger" : "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: deliveryPrice() - nonCheckDelPrice() < 0 && "\uBB36\uC74C \uBC30\uC1A1 \uD560\uC778"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (0,splicePrice/* priceComma */.a)(deliveryPrice() - nonCheckDelPrice()),
                                            "\uC6D0"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uC608\uC0C1 \uACB0\uC81C\uAE08\uC561"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (0,splicePrice/* priceComma */.a)(price1() + deliveryPrice()),
                                            "\uC6D0"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "info",
                        children: "* \uCD5C\uC885 \uACB0\uC81C \uAE08\uC561\uC740 \uB3C4\uC11C\uC0B0\uAC04 \uD560\uC99D, \uCFE0\uD3F0 \uC0AC\uC6A9 \uB4F1\uC73C\uB85C \uC778\uD574 \uBCC0\uB3D9\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn reorder",
                onClick: function() {
                    return onClickCheckout();
                },
                children: "\uC120\uD0DD \uC0C1\uD488 \uC8FC\uBB38"
            })
        ]
    });
};
/* harmony default export */ var user_UserCart = (UserCart);

;// CONCATENATED MODULE: ./components/floating/user/UserView.js






var UserView = function(props) {
    var viewList = props.viewList;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_styles/* ViewListWrapper */.lW, {
            children: viewList && viewList.length > 0 && viewList.map(function(product, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* ViewListBox */.A8, {
                    onClick: function() {
                        return router.push("/products/".concat(product.ename, "/").concat(product.pcode, "/"));
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "main_img_wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: product.main_image,
                                    alt: product.pname,
                                    className: "main_image"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "hover_cover",
                                    children: "\uC0C1\uC138\uBCF4\uAE30"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: product.pname
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        (0,splicePrice/* priceComma */.a)(product.discount_price),
                                        "\uC6D0"
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        })
    });
};
/* harmony default export */ var user_UserView = (UserView);

;// CONCATENATED MODULE: ./components/floating/user.js















var UserFloating = function(props) {
    var ref, ref1;
    var scroll = props.scroll, userInfo = props.userInfo, basketItems = props.basketItems, clearBasketsAction = props.clearBasketsAction, modifyConfirmModal = props.modifyConfirmModal, openConfirmModal = props.openConfirmModal, closeConfirmModal = props.closeConfirmModal, deleteBasketsAction = props.deleteBasketsAction, fetchBasketsAction = props.fetchBasketsAction, insertBasketsAction = props.insertBasketsAction, deleteFromCart = props.deleteFromCart, vp = props.vp, cartItems = props.cartItems, clearCart = props.clearCart, decreaseCnt = props.decreaseCnt, increaseCnt = props.increaseCnt, onClickSearch = props.onClickSearch, toggleClick = props.toggleClick;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(""), activeTab = ref2[0], setActievTab = ref2[1];
    var ref3 = (0,react.useState)([]), viewList = ref3[0], setViewList = ref3[1];
    var handleOpen = function(tab) {
        if (activeTab === tab) {
            setActievTab(undefined);
            return;
        }
        setActievTab(tab);
    };
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (vp.vp && vp.vp.length > 0) {
            setViewList(vp.vp);
        } else {
            setViewList(JSON.parse(sessionStorage.getItem("vp")));
        }
    }, [
        router.isReady,
        router.query,
        vp
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* UserFloatingWrapper */.T$, {
                openInner: activeTab,
                $scroll: scroll,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* IconsWrapper */.J6, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon ".concat(activeTab === "reorder" && "active"),
                                onClick: function() {
                                    return handleOpen("reorder");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-time-past"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon ".concat(activeTab === "cart" && "active"),
                                onClick: function() {
                                    return handleOpen("cart");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-shopping-cart"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon ".concat(activeTab === "view" && "active"),
                                onClick: function() {
                                    return handleOpen("view");
                                },
                                children: viewList && viewList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: viewList[0].main_image,
                                    alt: viewList[0].pname,
                                    style: {
                                        width: "40px"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-square-plus"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerWrapper */.Ip, {
                        openInner: activeTab,
                        scroll: scroll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerHeader */.FZ, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "/mypage/order",
                                            children: [
                                                userInfo === null || userInfo === void 0 ? void 0 : (ref1 = userInfo.Member) === null || ref1 === void 0 ? void 0 : ref1.name,
                                                " \uB2D8"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/login",
                                            children: "\uB85C\uADF8\uC778 \uD574\uC8FC\uC138\uC694."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        onClick: function() {
                                            return handleOpen();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-cross"
                                        })
                                    })
                                ]
                            }),
                            activeTab !== "view" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerTabWrapper */.IS, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tab ".concat(activeTab === "reorder" && "active"),
                                        onClick: function() {
                                            return handleOpen("reorder");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-time-past me-1"
                                            }),
                                            "\uC7AC\uAD6C\uB9E4"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tab ".concat(activeTab === "cart" && "active"),
                                        onClick: function() {
                                            return handleOpen("cart");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-shopping-cart me-1"
                                            }),
                                            "\uC7A5\uBC14\uAD6C\uB2C8"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* InnerBody */.HV, {
                                children: [
                                    activeTab === "reorder" && /*#__PURE__*/ (0,jsx_runtime.jsx)(user_UserReOrder, {
                                        activeTab: activeTab,
                                        setActievTab: setActievTab,
                                        insertBasketsAction: insertBasketsAction,
                                        fetchBasketsAction: fetchBasketsAction
                                    }),
                                    activeTab === "cart" && /*#__PURE__*/ (0,jsx_runtime.jsx)(user_UserCart, {
                                        activeTab: activeTab,
                                        setActievTab: setActievTab,
                                        basketItems: basketItems,
                                        clearBasketsAction: clearBasketsAction,
                                        modifyConfirmModal: modifyConfirmModal,
                                        openConfirmModal: openConfirmModal,
                                        closeConfirmModal: closeConfirmModal,
                                        deleteBasketsAction: deleteBasketsAction,
                                        fetchBasketsAction: fetchBasketsAction,
                                        insertBasketsAction: insertBasketsAction,
                                        cartItems: cartItems,
                                        deleteFromCart: deleteFromCart,
                                        clearCart: clearCart,
                                        decreaseCnt: decreaseCnt,
                                        increaseCnt: increaseCnt,
                                        userInfo: userInfo
                                    }),
                                    activeTab === "view" && /*#__PURE__*/ (0,jsx_runtime.jsx)(user_UserView, {
                                        viewList: viewList
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(user_styles/* InnerFooter */.oB, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileSocialIconWrapper */.Ld, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://pf.kakao.com/_MCxnhxj",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/kakao-talk.png",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/caretstore",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-facebook-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.instagram.com/caretstore/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-instagram-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://talk.naver.com/ct/w4kznv",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-naver-talk.png",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.youtube.com/channel/UC1MTYtvC363yWAB4uf8CBhQ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-youtube-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://blog.naver.com/caretstore",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://cdn.imweb.me/upload/S20200506960caff1c89c9/522104c187709.png",
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* MobileFooter */.bE, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* MobileFooterTab */.XD, {
                        className: "".concat(router.pathname === "/" && "active"),
                        onClick: function() {
                            return router.push("/");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-home"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uD648"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* MobileFooterTab */.XD, {
                        onClick: function() {
                            return toggleClick();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-burger-menu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uBA54\uB274"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(user_styles/* MobileFooterTab */.XD, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: "search",
                            onClick: function() {
                                return onClickSearch();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/imgs/theme/icons/search_icon.png",
                                alt: "search_icon"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* MobileFooterTab */.XD, {
                        className: "".concat(router.pathname === "/reorder" && "active"),
                        onClick: function() {
                            return router.push("/reorder");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-time-past"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uC7AC\uAD6C\uB9E4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_styles/* MobileFooterTab */.XD, {
                        className: "".concat(router.pathname.includes("/mypage") && "active"),
                        onClick: function() {
                            return router.push("/mypage/order");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-user"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uB9C8\uC774\uD398\uC774\uC9C0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var user = (UserFloating);

;// CONCATENATED MODULE: ./components/layout/mobileSearch/MobileSearch.styles.js
function MobileSearch_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MobileSearch_styles_templateObject() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n"
    ]);
    MobileSearch_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileSearch_styles_templateObject1() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n"
    ]);
    MobileSearch_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n          animation: ",
        " 0.3s ease-in-out;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n          animation: ",
        " 0.3s ease-in-out;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  top: 0;\n  left: 0;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.09);\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.09);\n  z-index: 10000050;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding: 0 0 50px 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #1b1b1b;\n  padding: 15px;\n  position: relative;\n\n  .back-button {\n    font-size: 20px;\n    & i {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  padding: 20px 30px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  & input {\n    width: 100%;\n    max-height: 30px;\n    border: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n  & h6 {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  font-size: 14px;\n  & a {\n    margin-right: 10px;\n    margin-bottom: 10px;\n    color: #fff !important;\n    background-color: #3bb77e;\n    padding: 5px 10px;\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  & h6 {\n    margin-bottom: 20px;\n  }\n\n  & li {\n    border-bottom: 1px solid #ececec;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  & span {\n    color: #1b1b1b;\n    font-size: 14px;\n  }\n\n  .rank {\n    min-width: 20px;\n    font-size: 16px;\n    font-weight: 800;\n    color: #3bb77e;\n    margin-right: 5px;\n    display: flex;\n    justify-content: end;\n    line-height: 26px;\n  }\n\n  .keyword {\n    font-size: 14px;\n    margin-right: 5px;\n    line-height: 16.94px;\n  }\n\n  .desc {\n    color: #acacac;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 15.73px;\n    padding-top: 1px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  left: 0;\n  top: calc(100% + 1px);\n  z-index: 999999;\n  background-color: #fff;\n  width: 100%;\n  padding: 0px 30px 20px;\n  border-bottom: 1px solid #ececec;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        "\n  padding: 10px 0px 20px;\n  display: flex;\n  flex-direction: column;\n\n  .size_input_wrapper {\n    padding: 10px 0px;\n    display: flex;\n    flex-direction: column;\n  }\n  .btn {\n    font-size: 16px;\n    font-weight: 400;\n    padding: 5px 10px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        '\n  display: flex;\n  width: 100%;\n  position: relative;\n  padding: 5px 40px 5px 5px;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  & input {\n    border: none;\n    border-radius: 0%;\n    height: 100%;\n    padding: 0px 10px;\n    color: #253d4e;\n    font-size: 16px;\n    width: calc(100% - 40px);\n    background-color: transparent;\n  }\n  ::after {\n    content: "mm";\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 40px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #253d4e;\n    font-size: 16px;\n  }\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = MobileSearch_styles_taggedTemplateLiteral([
        '\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 0px;\n\n  & select {\n    width: 100%;\n    padding: 5px 16px;\n    cursor: pointer;\n  }\n  ::after {\n    font-family: uicons-regular-straight !important;\n    font-weight: normal !important;\n    content: "\f131";\n    position: absolute;\n    right: 10px;\n    top: 0px;\n    width: 16px;\n    font-size: 16px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    z-index: -1;\n  }\n'
    ], [
        '\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 0px;\n\n  & select {\n    width: 100%;\n    padding: 5px 16px;\n    cursor: pointer;\n  }\n  ::after {\n    font-family: uicons-regular-straight !important;\n    font-weight: normal !important;\n    content: "\\f131";\n    position: absolute;\n    right: 10px;\n    top: 0px;\n    width: 16px;\n    font-size: 16px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    z-index: -1;\n  }\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}

var slideIn = (0,styled_components_browser_esm/* keyframes */.F4)(MobileSearch_styles_templateObject());
var slideOut = (0,styled_components_browser_esm/* keyframes */.F4)(MobileSearch_styles_templateObject1());
var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6c9c0155-0"
})(_templateObject4(), function(param) {
    var searchToggled = param.searchToggled;
    return searchToggled ? "visible" : "hidden";
}, function(param) {
    var searchToggled = param.searchToggled;
    return searchToggled ? 1 : 0;
}, function(param) {
    var searchToggled = param.searchToggled;
    return searchToggled ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), slideIn) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), slideOut);
});
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-1"
})(_templateObject5());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-2"
})(_templateObject6());
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-3"
})(_templateObject7());
var SeacrhSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6c9c0155-4"
})(_templateObject8());
var HeaderSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-5"
})(_templateObject9());
var SeacrhTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-6"
})(_templateObject10());
var TagList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-7"
})(_templateObject11());
var RankWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-8"
})(_templateObject12());
var FilteredTagsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-9"
})(_templateObject13());
var MobileSizeSearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-10"
})(_templateObject14());
var SizeInputBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c9c0155-11"
})(_templateObject15());
var SizeRangeSelect = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-6c9c0155-12"
})(_templateObject16());

;// CONCATENATED MODULE: ./components/layout/header/search/Search.styles.js
function Search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Search_styles_templateObject() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding: 0px;\n  @media (max-width: 1200px) {\n    padding: 0px 20px;\n  }\n"
    ]);
    Search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Search_styles_templateObject1() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  .search_icon {\n    width: fit-content;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    & img {\n      width: 50px;\n    }\n  }\n  @media (max-width: 1200px) {\n    .search_icon {\n      & img {\n        width: 40px;\n      }\n    }\n  }\n"
    ]);
    Search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Search_styles_templateObject2() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border: 2px solid #bce3c9;\n  border-radius: 5px;\n  margin-right: 10px;\n  min-width: 180px;\n  padding: 10px 20px;\n  & input {\n    width: 100%;\n    max-height: 30px;\n    border: none;\n    padding: 0px;\n  }\n  @media (max-width: 1200px) {\n    width: 100%;\n  }\n"
    ]);
    Search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Search_styles_templateObject3() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 10px;\n  border: 2px solid #bce3c9;\n  border-radius: 5px;\n  height: 100%;\n  width: 100%;\n  padding: 10px 20px;\n  margin-right: 10px;\n  @media (max-width: 1200px) {\n    display: none;\n  }\n"
    ]);
    Search_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Search_styles_templateObject4() {
    var data = Search_styles_taggedTemplateLiteral([
        '\n  display: flex;\n  width: 100px;\n  position: relative;\n  padding: 0px 40px 0px 0px;\n  height: 100%;\n  & input {\n    border: none;\n    border-radius: 0%;\n    height: 100%;\n    padding: 0px;\n    color: #253d4e;\n    font-size: 16px;\n    width: 40px;\n  }\n  ::after {\n    content: "mm";\n    position: absolute;\n    right: 0px;\n    width: 40px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #253d4e;\n    font-size: 16px;\n  }\n\n  @media (max-width: 1200px) {\n    width: 160px;\n  }\n'
    ]);
    Search_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Search_styles_templateObject5() {
    var data = Search_styles_taggedTemplateLiteral([
        '\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0px;\n\n  ::before {\n    content: "";\n    position: absolute;\n    top: 15%;\n    left: 0px;\n    width: 0px;\n    height: 70%;\n    border-left: 1px solid #ccc;\n  }\n  & select {\n    width: 100%;\n    padding: 0px 16px;\n    cursor: pointer;\n  }\n  ::after {\n    font-family: uicons-regular-straight !important;\n    font-weight: normal !important;\n    content: "\f131";\n    position: absolute;\n    right: 0px;\n    width: 16px;\n    font-size: 16px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    z-index: -1;\n  }\n  @media (max-width: 1200px) {\n    width: 200px;\n  }\n'
    ], [
        '\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0px;\n\n  ::before {\n    content: "";\n    position: absolute;\n    top: 15%;\n    left: 0px;\n    width: 0px;\n    height: 70%;\n    border-left: 1px solid #ccc;\n  }\n  & select {\n    width: 100%;\n    padding: 0px 16px;\n    cursor: pointer;\n  }\n  ::after {\n    font-family: uicons-regular-straight !important;\n    font-weight: normal !important;\n    content: "\\f131";\n    position: absolute;\n    right: 0px;\n    width: 16px;\n    font-size: 16px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    z-index: -1;\n  }\n  @media (max-width: 1200px) {\n    width: 200px;\n  }\n'
    ]);
    Search_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Search_styles_templateObject6() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: fit-content;\n  color: #1b1b1b;\n  text-align: start;\n"
    ]);
    Search_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Search_styles_templateObject7() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  width: fit-content;\n  min-width: 278px;\n  height: auto;\n  background-color: #fff;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  display: none;\n  z-index: 100;\n  padding: 20px;\n  flex-direction: column;\n\n  & h6 {\n    font-size: 16px;\n    color: #1b1b1b;\n  }\n"
    ]);
    Search_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Search_styles_templateObject8() {
    var data = Search_styles_taggedTemplateLiteral([
        '\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  bottom: -25px;\n  font-size: 13px;\n  & a {\n    color: #7e7e7e;\n    position: relative;\n    text-decoration: none;\n    margin-right: 10px;\n    :last-of-type {\n      margin-right: 0px;\n    }\n    ::after {\n      content: "";\n      position: absolute;\n      width: 0;\n      left: 50%;\n      bottom: 0;\n      border-bottom: 1px solid #3bb77e;\n      transition: width 0.2s, left 0.2s;\n      -webkit-transition: width 0.2s, left 0.2s ease;\n    }\n\n    :hover {\n      color: #3bb77e !important;\n      ::after {\n        width: 100%;\n        left: 0;\n      }\n    }\n  }\n'
    ]);
    Search_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Search_styles_templateObject9() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 20%;\n  position: relative;\n  margin-right: 30px;\n  z-index: 10;\n  > form {\n    margin-right: 0;\n    height: 45px;\n    position: absolute;\n    border: none !important;\n    border-radius: 10px;\n    width: 0px;\n    right: 20px;\n    top: -30%;\n    font-size: 0px !important;\n    transition: width 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    & i {\n      cursor: pointer;\n    }\n  }\n  .active {\n    z-index: 50;\n    width: 250px;\n    border: 2px solid #bce3c9 !important;\n    font-size: 1.1rem !important;\n    & i {\n      cursor: pointer;\n    }\n  }\n\n  & input {\n    height: 30px !important;\n    font-size: 14px;\n    background-color: #fff !important;\n    border: none !important;\n    padding: 0 0 0 10px;\n  }\n\n  @media (max-width: 1440px) {\n    width: 20%;\n    margin-right: -40px;\n  }\n  @media (max-width: 1200px) {\n    display: none;\n  }\n"
    ]);
    Search_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Search_styles_templateObject10() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #121212;\n  font-size: 23px;\n  cursor: pointer;\n  z-index: 50;\n  > i {\n    margin-top: 2px;\n  }\n"
    ]);
    Search_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Search_styles_templateObject11() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  position: ",
        ";\n  top: ",
        ";\n  left: ",
        ";\n  width: 615px;\n  display: ",
        ";\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  z-index: 100;\n  & h6 {\n    font-size: 16px;\n    font-weight: 700;\n  }\n  @media (max-width: 1200px) {\n    top: ",
        ";\n    left: ",
        ";\n    top: ",
        ";\n    width: 550px;\n  }\n"
    ]);
    Search_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Search_styles_templateObject12() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  position: fixed;\n  top: 73px;\n  z-index: 100;\n  width: 615px;\n  border: 2px solid #bce3c9;\n  border-radius: 5px;\n  background: #fff;\n\n  & input {\n    width: 100%;\n    border: none;\n  }\n  @media (max-width: 1200px) {\n    top: 108px;\n    width: 550px;\n  }\n"
    ]);
    Search_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Search_styles_templateObject13() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #e1e1e1;\n  padding: 15px 20px;\n  @media (max-width: 1200px) {\n    border-bottom: 0px;\n  }\n"
    ]);
    Search_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Search_styles_templateObject14() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & i {\n    ::before {\n      font-weight: 700 !important;\n    }\n  }\n"
    ]);
    Search_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Search_styles_templateObject15() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  font-size: 14px;\n  margin-top: 10px;\n  row-gap: 8px;\n\n  & a {\n    margin-right: 10px;\n    color: #fff !important;\n    background-color: #3bb77e;\n    padding: 5px 10px;\n    border-radius: 10px;\n  }\n"
    ]);
    Search_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Search_styles_templateObject16() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 20px;\n  border-top: 2px solid #bce3c9;\n  border-bottom: 2px solid #bce3c9;\n  display: none;\n\n  .size_input_wrapper {\n    display: flex;\n    gap: 10px;\n    width: calc(100% - 70px);\n    padding: 0px 10px;\n  }\n  .search_icon {\n    width: 40px;\n    display: flex;\n    & img {\n      width: 40px;\n    }\n  }\n  @media (max-width: 1200px) {\n    display: flex;\n  }\n"
    ]);
    Search_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = Search_styles_taggedTemplateLiteral([
        '\n  display: grid;\n  grid-template-columns: repeat(11, 1fr);\n\n  & a {\n    color: #5b5b5b !important;\n    position: relative;\n    text-decoration: none;\n\n    :hover {\n      color: #3bb77e !important;\n    }\n\n    ::after {\n      content: "";\n      position: absolute;\n      width: 0;\n      left: 50%;\n      bottom: 0;\n      border-bottom: 1px solid #3bb77e;\n      transition: width 0.2s, left 0.2s;\n      -webkit-transition: width 0.2s, left 0.2s ease;\n    }\n\n    :hover::after {\n      width: 100%;\n      left: 0;\n    }\n  }\n'
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  grid-column: 6 span / 6 span;\n  border-right: 1px solid #e1e1e1;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  margin-top: 15px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n\n  & figure {\n    margin-right: 5px;\n    display: inline-flex;\n  }\n\n  .delete {\n    cursor: pointer;\n    display: flex;\n    font-size: 12px;\n    margin-left: auto;\n    padding-top: 1px;\n    :hover {\n      color: #dc3545;\n    }\n  }\n\n  & a {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = Search_styles_taggedTemplateLiteral([
        '\n  color: #b0b0b0;\n  width: fit-content;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  margin-top: auto;\n  ::after {\n    content: "";\n    position: absolute;\n    width: 100%;\n    left: 0%;\n    bottom: 0;\n    border-bottom: 1px solid #b0b0b0;\n  }\n  :hover {\n    color: #dc3545;\n    ::after {\n      border-color: #dc3545;\n    }\n  }\n'
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  grid-column: 5 span / 5 span;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = Search_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  :last-of-type {\n    margin-bottom: 0px;\n  }\n\n  .number {\n    min-width: 20px;\n    font-size: 16px;\n    font-weight: 800;\n    color: #3bb77e;\n    margin-right: 5px;\n    display: flex;\n    justify-content: end;\n    line-height: 26px;\n  }\n\n  & a {\n    color: #000000 !important;\n    font-size: 14px;\n    margin-right: 5px;\n    line-height: 16.94px;\n    white-space: nowrap;\n  }\n\n  .desc {\n    color: #acacac;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 15.73px;\n    padding-top: 1px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}

var Search_styles_SeacrhSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-64283347-0"
})(Search_styles_templateObject());
var SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-1"
})(Search_styles_templateObject1());
var Search_styles_HeaderSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-2"
})(Search_styles_templateObject2());
var SizeSearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-3"
})(Search_styles_templateObject3());
var Search_styles_SizeInputBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-4"
})(Search_styles_templateObject4());
var Search_styles_SizeRangeSelect = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-64283347-5"
})(Search_styles_templateObject5());
var SwiperRank = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-6"
})(Search_styles_templateObject6());
var RankBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-7"
})(Search_styles_templateObject7());
var Search_styles_SeacrhTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-8"
})(Search_styles_templateObject8());
var ScrollSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-9"
})(Search_styles_templateObject9());
var SeachIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-10"
})(Search_styles_templateObject10());
var FloatingSearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-11"
})(Search_styles_templateObject11(), function(props) {
    return props.$scroll ? "fixed" : "absolute";
}, function(props) {
    return props.$scroll ? "124px" : "55px";
}, function(props) {
    return props.$scroll ? "" : "0px";
}, function(props) {
    return props.open ? "flex" : "none";
}, function(props) {
    return props.$scroll ? "124px" : "55px";
}, function(props) {
    return props.$scroll ? "" : "20px";
}, function(props) {
    return props.$scroll ? "160px" : "55px";
});
var FloatingScrolledSearchBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-12"
})(Search_styles_templateObject12());
var FloatingHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-13"
})(Search_styles_templateObject13());
var HeaderTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-14"
})(Search_styles_templateObject14());
var Search_styles_TagList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-15"
})(Search_styles_templateObject15());
var FloatingSizeSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-16"
})(Search_styles_templateObject16());
var FloatingBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-17"
})(_templateObject17());
var RecentSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-18"
})(_templateObject18());
var RecentList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-19"
})(_templateObject19());
var RecentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-20"
})(_templateObject20());
var RecentDeleteAll = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-21"
})(_templateObject21());
var RankSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-22"
})(_templateObject22());
var RankList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-23"
})(_templateObject23());
var RankRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64283347-24"
})(_templateObject24());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
;// CONCATENATED MODULE: ./hook/header/useSearchQuery.js
function useSearchQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useSearchQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useSearchQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useSearchQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 검색어 불러오기
var fetchSearchTags = function() {
    var _ref = useSearchQuery_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, body, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    body = {
                        modes: "AllSearchTag"
                    };
                    _ctx.next = 4;
                    return postDefaultArray(body);
                case 4:
                    res = _ctx.sent;
                    if (!(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.Data.Data);
                case 7:
                    throw new Error("\uAC80\uC0C9\uC5B4 \uB370\uC774\uD130\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchSearchTags() {
        return _ref.apply(this, arguments);
    };
}();
var useSearchTagQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.DUMMY.SEARCH */.U.DUMMY.SEARCH,
        queryFn: fetchSearchTags,
        enabled: false,
        staleTime: 1000 * 60 * 30
    });
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./components/layout/mobileSearch/MobileSearch.js
function MobileSearch_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileSearch_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return MobileSearch_arrayLikeToArray(arr);
}
function MobileSearch_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileSearch_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function MobileSearch_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileSearch_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileSearch_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MobileSearch_toConsumableArray(arr) {
    return MobileSearch_arrayWithoutHoles(arr) || MobileSearch_iterableToArray(arr) || MobileSearch_unsupportedIterableToArray(arr) || MobileSearch_nonIterableSpread();
}
function MobileSearch_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileSearch_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileSearch_arrayLikeToArray(o, minLen);
}












var MobileSearch = function(param) {
    var searchToggled = param.searchToggled, onClickSearch = param.onClickSearch, dummyList = param.dummyList;
    var ref9;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react.useState)([]), recentList = ref2[0], setRecentList = ref2[1];
    var ref3 = (0,react.useState)(false), hasFetchedSearchTags = ref3[0], setHasFetchedSearchTags = ref3[1];
    var ref4 = (0,react.useState)([]), filteredTags = ref4[0], setFilteredTags = ref4[1];
    var ref5 = (0,react.useState)(false), openSearch = ref5[0], setOpenSearch = ref5[1];
    var ref6 = (0,react.useState)({
        garo: "",
        sero: "",
        high: "",
        erange: ""
    }), selectedSizes = ref6[0], setSizes = ref6[1];
    var onChangeSize = function(e, id) {
        setSizes(MobileSearch_objectSpread({}, selectedSizes, MobileSearch_defineProperty({}, id, e.target.value)));
    };
    var handleSearch = function(txt) {
        var ref, ref8;
        if (!txt && ((ref8 = (ref = Object.values(selectedSizes)) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el > 0;
        })) === null || ref8 === void 0 ? void 0 : ref8.length) == 0) {
            return (0,common_alert/* failAlert */.qh)("\uAC80\uC0C9\uC5B4 \uD639\uC740 \uC0AC\uC774\uC988\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
        }
        if (txt) {
            if (txt.length < 2) return (0,common_alert/* failAlert */.qh)("\uB450 \uAE00\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
            clearTimeout();
            if (recentList.includes(txt)) {
                var idx = recentList.findIndex(function(v) {
                    return v === txt;
                });
                recentList.splice(idx, 1);
                setRecentList([
                    txt
                ].concat(MobileSearch_toConsumableArray(recentList)));
                localStorage.setItem("RST", JSON.stringify([
                    txt
                ].concat(MobileSearch_toConsumableArray(recentList))));
            } else {
                if (recentList.length === 9) {
                    var tempArr = recentList.slice(0, 8);
                    setRecentList([
                        txt
                    ].concat(MobileSearch_toConsumableArray(tempArr)));
                    localStorage.setItem("RST", JSON.stringify([
                        txt
                    ].concat(MobileSearch_toConsumableArray(tempArr))));
                } else {
                    setRecentList([
                        txt
                    ].concat(MobileSearch_toConsumableArray(recentList)));
                    localStorage.setItem("RST", JSON.stringify([
                        txt
                    ].concat(MobileSearch_toConsumableArray(recentList))));
                }
            }
        }
        router.push({
            pathname: "/search",
            query: MobileSearch_objectSpread({}, selectedSizes, {
                search: txt
            })
        });
        setOpenSearch(false);
        setSearchTerm("");
    };
    var handleInput = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            setTimeout(function() {
                handleSearch(searchTerm);
            }, 200);
        }
    };
    var deleteRecentSearch = function(i) {
        recentList.splice(i, 1);
        setRecentList(MobileSearch_toConsumableArray(recentList));
        localStorage.setItem("RST", JSON.stringify(MobileSearch_toConsumableArray(recentList)));
    };
    var deleteRecentSearchAll = function() {
        setRecentList([]);
        localStorage.setItem("RST", JSON.stringify([]));
    };
    // 검색어 불러오기
    var ref7 = useSearchTagQuery(), searchTags = ref7.data;
    (0,react.useEffect)(function() {
        var ref, ref10;
        if (!router.isReady) return;
        if (searchToggled === true) {
            onClickSearch();
        }
        if (router.query.search) {
            setSearchTerm(router.query.search);
        }
        if (((ref10 = (ref = Object.values(router.query)) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el > 0;
        })) === null || ref10 === void 0 ? void 0 : ref10.length) > 0) {
            var ref11, ref12, ref13, ref14;
            setSizes({
                garo: ((ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.garo) > 0 ? router.query.garo : "",
                sero: ((ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.sero) > 0 ? router.query.sero : "",
                high: ((ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.high) > 0 ? router.query.high : "",
                erange: ((ref14 = router.query) === null || ref14 === void 0 ? void 0 : ref14.erange) > 0 ? router.query.erange : ""
            });
        }
        setRecentList(JSON.parse(localStorage.getItem("RST")) || []);
    }, [
        router.isReady,
        router.query
    ]);
    (0,react.useEffect)(function() {
        if ((searchTags === null || searchTags === void 0 ? void 0 : searchTags.length) === 0) return;
        if (Array.isArray(searchTags) && searchTerm.length > 0) {
            setFilteredTags(searchTags.filter(function(el) {
                return el.toLowerCase().includes(searchTerm.toLowerCase());
            }).slice(0, 10));
        } else {
            setFilteredTags([]);
        }
    }, [
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        if (!hasFetchedSearchTags && searchTerm.length > 1) {
            queryClient.invalidateQueries(queryKeys/* QUERY_KEYS.DUMMY.SEARCH */.U.DUMMY.SEARCH);
            setHasFetchedSearchTags(true);
        }
    }, [
        searchTerm
    ]);
    var sizes = [
        0,
        10,
        20,
        30,
        40,
        50,
        60
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            searchToggled: searchToggled,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                role: "button",
                                className: "back-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-arrow-left",
                                    onClick: onClickSearch
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSearch, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    value: searchTerm,
                                    onKeyDown: handleInput,
                                    onChange: function(e) {
                                        return setSearchTerm(e.target.value);
                                    },
                                    type: "text",
                                    placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
                                    onFocus: function(e) {
                                        return setOpenSearch(true);
                                    }
                                })
                            }),
                            openSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilteredTagsWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSizeSearchWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "size_input_wrapper",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInputBox, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                placeholder: "\uAC00\uB85C",
                                                                type: "tel",
                                                                value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo,
                                                                onChange: function(e) {
                                                                    return onChangeSize(e, "garo");
                                                                },
                                                                onKeyDown: handleInput
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInputBox, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                placeholder: "\uC138\uB85C",
                                                                type: "tel",
                                                                value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero,
                                                                onChange: function(e) {
                                                                    return onChangeSize(e, "sero");
                                                                },
                                                                onKeyDown: handleInput
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeInputBox, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                placeholder: "\uB192\uC774",
                                                                type: "tel",
                                                                value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high,
                                                                onChange: function(e) {
                                                                    return onChangeSize(e, "high");
                                                                },
                                                                onKeyDown: handleInput
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeRangeSelect, {
                                                            htmlFor: "size-erange",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                id: "size-erange",
                                                                value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.erange,
                                                                onChange: function(e) {
                                                                    return onChangeSize(e, "erange");
                                                                },
                                                                children: sizes.map(function(el, i) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                                        value: el > 0 ? el : "",
                                                                        children: [
                                                                            "\xb1 ",
                                                                            el
                                                                        ]
                                                                    }, i);
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn",
                                                    onClick: function() {
                                                        return handleSearch(searchTerm);
                                                    },
                                                    children: "\uAC80\uC0C9"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: filteredTags.length > 0 ? "\uC5F0\uAD00 \uAC80\uC0C9\uC5B4" : "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentList, {
                                            children: [
                                                filteredTags.length > 0 ? filteredTags.map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/icons/search_icon_gray.png",
                                                                    width: 18,
                                                                    height: 18,
                                                                    priority: true,
                                                                    alt: "search_icon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    setSizes({
                                                                        garo: "",
                                                                        sero: "",
                                                                        high: "",
                                                                        erange: ""
                                                                    });
                                                                    setOpenSearch(false);
                                                                    router.push("/search/?search=".concat(el));
                                                                },
                                                                role: "button",
                                                                children: el
                                                            })
                                                        ]
                                                    }, i);
                                                }) : recentList.length > 0 ? recentList.map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/icons/search_icon_gray.png",
                                                                    width: 18,
                                                                    height: 18,
                                                                    priority: true,
                                                                    alt: "search_icon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    setSizes({
                                                                        garo: "",
                                                                        sero: "",
                                                                        high: "",
                                                                        erange: ""
                                                                    });
                                                                    setOpenSearch(false);
                                                                    router.push("/search/?search=".concat(el));
                                                                },
                                                                role: "button",
                                                                children: el
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "delete",
                                                                onClick: function() {
                                                                    return deleteRecentSearch(i);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi-rs-x"
                                                                })
                                                            })
                                                        ]
                                                    }, i);
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "\uCD5C\uADFC \uAC80\uC0C9\uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex align-items-center justify-content-between mt-10",
                                                    children: [
                                                        (filteredTags === null || filteredTags === void 0 ? void 0 : filteredTags.length) === 0 && recentList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentDeleteAll, {
                                                            onClick: function() {
                                                                return deleteRecentSearchAll();
                                                            },
                                                            children: "\uC804\uCCB4\uC0AD\uC81C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            role: "button",
                                                            className: "ms-auto text-secondary",
                                                            onClick: function() {
                                                                return setOpenSearch(false);
                                                            },
                                                            children: "\uB2EB\uAE30"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeacrhSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeacrhTags, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "\uCD94\uCC9C \uAC80\uC0C9\uC5B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList, {
                                            children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.keywords) && Object.values(dummyList.keywords).map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        setSizes({
                                                            garo: "",
                                                            sero: "",
                                                            high: "",
                                                            erange: ""
                                                        });
                                                        setOpenSearch(false);
                                                        router.push("/search/?search=".concat(el));
                                                    },
                                                    role: "button",
                                                    children: el
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "\uC2E4\uC2DC\uAC04 \uAC80\uC0C9\uC5B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: (dummyList === null || dummyList === void 0 ? void 0 : (ref9 = dummyList.ranking) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.ranking.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "rank",
                                                            children: i + 1
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "keyword",
                                                                onClick: function() {
                                                                    setSizes({
                                                                        garo: "",
                                                                        sero: "",
                                                                        high: "",
                                                                        erange: ""
                                                                    });
                                                                    setOpenSearch(false);
                                                                    router.push("/search/?search=".concat(el.keyword));
                                                                },
                                                                role: "button",
                                                                children: el.keyword
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "desc",
                                                            children: el.content
                                                        })
                                                    ]
                                                }, i);
                                            }))
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobileSearch_MobileSearch = (MobileSearch);

// EXTERNAL MODULE: ./redux/action/cart.js
var cart = __webpack_require__(68866);
// EXTERNAL MODULE: ./api/checkSiteConfig.js
var checkSiteConfig = __webpack_require__(81197);
;// CONCATENATED MODULE: ./redux/action/siteInfo.js
function siteInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function siteInfo_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                siteInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                siteInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchSiteInfo = function(router) {
    return function() {
        var _ref = siteInfo_asyncToGenerator(runtime_default().mark(function _callee(dispatch) {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        body = {
                            modes: "Config",
                            division: "store",
                            channel: router.query.channel || (sessionStorage.getItem("channelName") === "\uBC14\uB85C\uACE0" ? "BAROGO" : "")
                        };
                        _ctx.next = 4;
                        return (0,checkSiteConfig/* default */.Z)(body);
                    case 4:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            if (res.Data.channel.token) {
                                sessionStorage.setItem("channel", res.Data.channel.token);
                                sessionStorage.setItem("channelName", res.Data.channel.company);
                                sessionStorage.setItem("channelInfo", "".concat(res.Data.channel.company ? res.Data.channel.company + "+" : "").concat(res.Data.channel.regIdYn));
                            }
                            sessionStorage.setItem("logo", JSON.stringify({
                                pc: res.Data.channel.logo,
                                mobile: res.Data.channel.mobile_logo
                            }));
                        }
                        dispatch({
                            type: actionTypes/* SITE_INFO */.vs,
                            payload: {
                                siteInfo: res.Data
                            }
                        });
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./api/apis.js
var apis = __webpack_require__(66887);
// EXTERNAL MODULE: ./common/util/getDate.js
var getDate = __webpack_require__(69644);
;// CONCATENATED MODULE: ./common/badge/proceedingMenuBadge.js
function proceedingMenuBadge_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function proceedingMenuBadge_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                proceedingMenuBadge_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                proceedingMenuBadge_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function proceedingMenuBadge_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function proceedingMenuBadge_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            proceedingMenuBadge_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function proceedingMenuBadge_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function proceedingMenuBadge_templateObject() {
    var data = proceedingMenuBadge_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: ",
        ';\n\n  .speech-bubble {\n    display: inline-block;\n    position: relative;\n    background-color: #e4f5d4;\n    color: #3bb77e;\n    padding: 5px 10px;\n    border-radius: 20px;\n    line-height: 1;\n\n    &::after {\n      content: "";\n      position: absolute;\n      bottom: -15px;\n      left: 50%;\n      transform: translateX(-50%);\n      border-width: 8px;\n      border-style: solid;\n      border-color: #e4f5d4 transparent transparent transparent;\n    }\n  }\n'
    ]);
    proceedingMenuBadge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-518576ba-0"
})(proceedingMenuBadge_templateObject(), function(props) {
    return props.$scroll ? "-25px" : "-30px";
}, function(props) {
    return props.$scroll ? "12px" : "14px";
});
var ProceedingMenuBadge = function(param) {
    var siteInfo = param.siteInfo;
    var ref6 = (0,react.useState)({}), detailData = ref6[0], setDetailData = ref6[1];
    var ref1 = (0,react.useState)("loading"), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), scroll = ref2[0], setScroll = ref2[1];
    // check open
    var checkOpen = function(data) {
        if (!data.sdate) {
            return "loading";
        }
        if ((0,getDate/* getTimeStamp */.dg)() < new Date(data.sdate).getTime()) {
            return "before";
        } else if ((0,getDate/* getTimeStamp */.dg)() > new Date(data.edate).getTime()) {
            return "after";
        } else {
            return "proceeding";
        }
    };
    var fetchDetail = function() {
        var _ref = proceedingMenuBadge_asyncToGenerator(runtime_default().mark(function _callee(code) {
            var body, res, ref, ref3, ref4, ref5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewSet",
                            code: code
                        };
                        _ctx.next = 3;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            setDetailData(proceedingMenuBadge_objectSpread({}, (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Row, {
                                info: res === null || res === void 0 ? void 0 : (ref3 = res.Data) === null || ref3 === void 0 ? void 0 : ref3.Info
                            }));
                            setOpen(checkOpen(proceedingMenuBadge_objectSpread({}, (ref4 = res.Data) === null || ref4 === void 0 ? void 0 : ref4.Row, {
                                info: res === null || res === void 0 ? void 0 : (ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Info
                            })));
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchDetail(code) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (siteInfo.Purchase) {
            fetchDetail(siteInfo.Purchase);
        }
        document.addEventListener("scroll", function() {
            var scrollCheck = window.scrollY >= 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, [
        siteInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: open === "proceeding" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeWrapper, {
            $scroll: scroll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "speech-bubble",
                children: "\uC9C4\uD589\uC911"
            })
        })
    });
};
/* harmony default export */ var proceedingMenuBadge = (ProceedingMenuBadge);

;// CONCATENATED MODULE: ./components/layout/Header.styles.js
function Header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Header_styles_templateObject() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background-color: #ffffff;\n"
    ]);
    Header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  width: 180px;\n  background-color: #f4f4f4;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    Header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  padding: 40px 20px;\n  border: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-align: start;\n  cursor: pointer;\n  transition: all 0.3s;\n  border-bottom-left-radius: ",
        ";\n  font-size: 16px;\n  line-height: 1.4;\n\n  &:hover {\n    background-color: #ffffff;\n    color: #3bb77e;\n  }\n"
    ]);
    Header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  width: 1px;\n  background-color: #cccccc;\n"
    ]);
    Header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_styles_templateObject4() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n"
    ]);
    Header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_styles_templateObject5() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n\n  @media (max-width: 1197px) and (min-width: 789px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  @media (max-width: 788px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    Header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Header_styles_templateObject6() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n\n  figure {\n    width: 75%;\n    height: 80px;\n    background: #f4f4f4;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 16px;\n    margin-bottom: 8px;\n\n    img {\n      object-fit: contain;\n      width: 100%;\n    }\n  }\n\n  &:hover span {\n    color: #3bb77e;\n  }\n"
    ]);
    Header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Header_styles_templateObject7() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: #333333;\n  text-align: center;\n  line-height: 1.4;\n"
    ]);
    Header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Header_styles_templateObject8() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  margin-top: auto;\n  padding-top: 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n"
    ]);
    Header_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Header_styles_templateObject9() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  min-width: 180px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #333;\n  cursor: pointer;\n\n  .main_category_button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n\n    i {\n      font-size: 20px;\n      transition: color 0.3s;\n    }\n\n    span {\n      font-weight: 500;\n      font-size: 17px;\n      transition: color 0.3s;\n    }\n\n    .vertical-line {\n      width: 2px;\n      height: 24px;\n      background-color: #cccccc;\n      margin-left: 12px;\n    }\n\n    &:hover i {\n      color: #3bb77e;\n    }\n\n    &:hover span {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    Header_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Header_styles_templateObject10() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: #212529;\n\n  .btn {\n    margin-right: 0 auto;\n  }\n"
    ]);
    Header_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Header_styles_templateObject11() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: #212529;\n\n  i {\n    margin-top: 2px;\n  }\n\n  span {\n    margin-right: 8px;\n  }\n\n  .btn {\n    margin-right: 0 auto;\n  }\n"
    ]);
    Header_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Header_styles_templateObject12() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  padding: 20px 0;\n  word-break: keep-all;\n  width: fit-content;\n\n  > nav > ul > li {\n    margin-right: 20px;\n    line-height: 30px !important;\n    padding: 0 !important;\n    > a {\n      font-size: 1.1rem !important;\n    }\n  }\n\n  .special {\n    border: 1px solid purple;\n    background-color: purple;\n    border-radius: 10px;\n    padding: 0px 10px;\n    color: white !important;\n  }\n"
    ]);
    Header_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Header_styles_templateObject13() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  color: #fff;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  background-color: #3bb77e;\n  width: fit-content;\n  padding: 5px 10px;\n  border-radius: 5px;\n  & i {\n    margin-right: 5px;\n  }\n  :hover {\n    color: #fff;\n  }\n"
    ]);
    Header_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Header_styles_templateObject14() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f2f3f4;\n"
    ]);
    Header_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Header_styles_templateObject15() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  .list {\n    display: none;\n    position: absolute;\n    top: 50%;\n    right: 120%;\n    background-color: #fff;\n    z-index: 99999;\n    padding: 10px;\n    border: 1px solid #3bb77e;\n    border-radius: 10px;\n    width: 250px;\n    word-break: keep-all;\n    line-height: 1.5;\n    .limit {\n      font-size: 0.8rem;\n    }\n  }\n  :hover {\n    .list {\n      display: block;\n      > div {\n        display: flex;\n        flex-direction: column;\n        border-bottom: 1px solid #ececec;\n        margin-bottom: 5px;\n        padding-bottom: 5px;\n        :last-of-type {\n          border-bottom: none;\n          margin-bottom: 0px;\n        }\n      }\n    }\n  }\n"
    ]);
    Header_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Header_styles_templateObject16() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  background-color: #1d1d1d;\n\n  @media screen and (min-width: 575px) {\n    .swiper-wrapper {\n      transition-timing-function: linear;\n    }\n  }\n"
    ]);
    Header_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function Header_styles_templateObject17() {
    var data = Header_styles_taggedTemplateLiteral([
        '\n  height: 42px;\n  font-size: 14px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n\n  & a {\n    color: #fff;\n    position: relative;\n    text-decoration: none;\n\n    ::after {\n      content: "";\n      position: absolute;\n      width: 0;\n      left: 50%;\n      bottom: 0;\n      border-bottom: 1px solid #fff;\n      transition: width 0.2s, left 0.2s;\n      -webkit-transition: width 0.2s, left 0.2s ease;\n    }\n\n    :hover::after {\n      width: 100%;\n      left: 0;\n    }\n  }\n'
    ]);
    Header_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function Header_styles_templateObject18() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media screen and (max-width: 991px) {\n    display: none;\n  }\n"
    ]);
    Header_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function Header_styles_templateObject19() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  width: 20%;\n  max-width: 300px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  & a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .pc {\n    position: absolute;\n    transition: 0.3s ease-in-out;\n    transform: translateY(0px);\n    opacity: 1;\n  }\n  .over {\n    position: absolute;\n    transition: 0.3s ease-in-out;\n    opacity: 0;\n    transform: translateY(10px) rotateX(90deg);\n  }\n  :hover {\n    .pc {\n      transform: translateY(-20px) rotateX(-90deg);\n      opacity: 0;\n    }\n    .over {\n      transform: translateY(0px) rotateX(0deg);\n      opacity: 1;\n    }\n  }\n"
    ]);
    Header_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function Header_styles_templateObject20() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: calc(80% - 170px);\n  max-width: 655px;\n"
    ]);
    Header_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function Header_styles_templateObject21() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  from{\n    opacity: 0;\n	}\n	to{\n    opacity: 1;\n	}\n"
    ]);
    Header_styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function Header_styles_templateObject22() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 170px;\n  height: 95px;\n  & img {\n    max-width: 100%;\n    animation: ",
        " 0.3s linear normal;\n  }\n"
    ]);
    Header_styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function Header_styles_templateObject23() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #121212;\n  font-size: 23px;\n  z-index: 50;\n  width: 53px;\n  padding-right: 8px;\n  > i {\n    cursor: pointer;\n    margin-top: 2px;\n  }\n"
    ]);
    Header_styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function Header_styles_templateObject24() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  50% {\n    opacity: 0;\n  }\n"
    ]);
    Header_styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: -5px;\n  bottom: -10px;\n  height: 18px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 5px;\n  border: 1px solid #fd7e14;\n  border-radius: 10px;\n  color: #fd7e14;\n  background-color: #fff;\n  font-size: 11px;\n  font-weight: 300;\n  animation: ",
        " 1s step-end infinite;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n  position: relative;\n\n  &.custom-menu {\n    position: static;\n  }\n\n  &:hover > a {\n    color: #3bb77e;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (min-width: 992px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: none;\n  position: absolute;\n  top: 90%;\n  left: 0;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  width: 1110px;\n  z-index: 100;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: block;\n\n  @media (max-width: 991px) {\n    display: none;\n  }\n\n  &:hover ",
        ", ",
        ":hover {\n    display: flex;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 8px 12px;\n  min-width: 140px;\n  color: #333;\n\n  i {\n    font-size: 17px;\n    margin-right: 8px;\n    margin-top: 3px;\n  }\n\n  span {\n    font-size: 17px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = Header_styles_taggedTemplateLiteral([
        "\n  width: 2px;\n  height: 20px;\n  background-color: #e0e0e0;\n  margin-left: 20px;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}

var MegaMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-0"
})(Header_styles_templateObject());
var LeftMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-1"
})(Header_styles_templateObject1());
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-45b7dff9-2"
})(Header_styles_templateObject2(), function(param) {
    var active = param.active;
    return active ? "#ffffff" : "#f4f4f4";
}, function(param) {
    var active = param.active;
    return active ? "#3bb77e" : "#7b7b7b";
}, function(param) {
    var active = param.active;
    return active ? "700" : "500";
}, function(param) {
    var active = param.active;
    return active ? "0px" : "16px";
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-3"
})(Header_styles_templateObject3());
var GridAndBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-4"
})(Header_styles_templateObject4());
var CategoryGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-5"
})(Header_styles_templateObject5());
var CategoryBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-6"
})(Header_styles_templateObject6());
var CategoryName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-45b7dff9-7"
})(Header_styles_templateObject7());
var BannerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-45b7dff9-8"
})(Header_styles_templateObject8());
var CategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-9"
})(Header_styles_templateObject9());
var NotificationArea = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-45b7dff9-10"
})(Header_styles_templateObject10());
var MobileNotificationArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-11"
})(Header_styles_templateObject11());
var MenuNavigation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-12"
})(Header_styles_templateObject12());
var MobileCateBtn = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-45b7dff9-13"
})(Header_styles_templateObject13());
var MobileCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-14"
})(Header_styles_templateObject14());
var CouponInfo = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-45b7dff9-15"
})(Header_styles_templateObject15());
var StripeBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-16"
})(Header_styles_templateObject16());
var StripeBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-17"
})(Header_styles_templateObject17());
// 중간 헤더 (로고, 검색, 고객센터)
var TopHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-18"
})(Header_styles_templateObject18());
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-19"
})(Header_styles_templateObject19());
var Header_styles_SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-20"
})(Header_styles_templateObject20());
var SlidesIn = (0,styled_components_browser_esm/* keyframes */.F4)(Header_styles_templateObject21());
var AwardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-21"
})(Header_styles_templateObject22(), SlidesIn);
var SearchIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-22"
})(Header_styles_templateObject23());
var BlinkEffects = (0,styled_components_browser_esm/* keyframes */.F4)(Header_styles_templateObject24());
var CouponBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-23"
})(_templateObject25(), BlinkEffects);
// 메뉴 아이템 스타일
var MenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-45b7dff9-24"
})(_templateObject26());
// 1. 데스크톱에서만 보이는 wrapper
var HeaderNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-25"
})(_templateObject27());
// 5. 드롭다운 영역
var DropdownArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-26"
})(_templateObject28());
// 2. 카테고리 전체 wrapper
var CategoryHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-27"
})(_templateObject29(), DropdownArea, DropdownArea);
// 3. 카테고리 버튼 영역
var MainCategoryButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-28"
})(_templateObject30());
// 4. 구분선
var VerticalLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45b7dff9-29"
})(_templateObject31());

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./store/useBannerStore.js
var useBannerStore = __webpack_require__(13880);
;// CONCATENATED MODULE: ./components/layout/header/StripeBanner.js





swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var StripeBanner_StripeBanner = function(param) {
    var banners = param.banners;
    var mainStripe = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }).mainStripe;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeBannerWrapper, {
            children: mainStripe && mainStripe.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                centeredSlides: true,
                autoplay: true,
                freeMode: true,
                observer: true,
                observeParents: true,
                speed: 300,
                allowTouchMove: false,
                loop: true,
                loopedSlides: 4,
                breakpoints: {
                    575: {
                        slidesPerView: 2,
                        speed: 8000,
                        autoplay: {
                            delay: 0,
                            disableOnInteraction: false,
                            stopOnLastSlide: false
                        }
                    },
                    768: {
                        slidesPerView: 2,
                        speed: 8000,
                        autoplay: {
                            delay: 0,
                            disableOnInteraction: false,
                            stopOnLastSlide: false
                        }
                    },
                    992: {
                        slidesPerView: 3,
                        speed: 8000,
                        autoplay: {
                            delay: 0,
                            disableOnInteraction: false,
                            stopOnLastSlide: false
                        }
                    },
                    1440: {
                        slidesPerView: 4,
                        speed: 8000,
                        autoplay: {
                            delay: 0,
                            disableOnInteraction: false,
                            stopOnLastSlide: false
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: mainStripe.map(function(banner, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "swiper-slide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeBanner, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: banner.link_url,
                                    target: banner.new_win === "Y" ? "_blank" : "",
                                    children: banner.img_alt
                                })
                            })
                        }, i);
                    })
                })
            })
        })
    });
};
/* harmony default export */ var header_StripeBanner = (StripeBanner_StripeBanner);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/layout/header/search/Search.js
function Search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Search_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Search_arrayLikeToArray(arr);
}
function Search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Search_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Search_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Search_toConsumableArray(arr) {
    return Search_arrayWithoutHoles(arr) || Search_iterableToArray(arr) || Search_unsupportedIterableToArray(arr) || Search_nonIterableSpread();
}
function Search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Search_arrayLikeToArray(o, minLen);
}



















swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Search = function(param) {
    var scroll = param.scroll, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, dummyList = param.dummyList, openSearch = param.openSearch, setOpenSearch = param.setOpenSearch, scrollSearchBtnRef = param.scrollSearchBtnRef;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref11 = (0,react.useState)(""), searchTerm = ref11[0], setSearchTerm = ref11[1];
    var ref1 = (0,react.useState)([]), recentList = ref1[0], setRecentList = ref1[1];
    var floatingRef = (0,react.useRef)(null);
    var inputRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), hasFetchedSearchTags = ref2[0], setHasFetchedSearchTags = ref2[1];
    var ref3 = (0,react.useState)([]), filteredTags = ref3[0], setFilteredTags = ref3[1];
    var ref4 = (0,react.useState)({
        garo: "",
        sero: "",
        high: "",
        erange: "20"
    }), selectedSizes = ref4[0], setSizes = ref4[1];
    var onChangeSize = function(e, id) {
        setSizes(Search_objectSpread({}, selectedSizes, Search_defineProperty({}, id, e.target.value)));
    };
    var handleSearch = function(txt) {
        if (!txt && (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo) <= 0 && (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero) <= 0 && (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high) <= 0) {
            return (0,common_alert/* failAlert */.qh)("\uAC80\uC0C9\uC5B4 \uD639\uC740 \uC0AC\uC774\uC988\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
        }
        if (txt) {
            if (txt.length < 2) return (0,common_alert/* failAlert */.qh)("\uB450 \uAE00\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
            clearTimeout();
            if (recentList.includes(txt)) {
                var idx = recentList.findIndex(function(v) {
                    return v === txt;
                });
                recentList.splice(idx, 1);
                setRecentList([
                    txt
                ].concat(Search_toConsumableArray(recentList)));
                localStorage.setItem("RST", JSON.stringify([
                    txt
                ].concat(Search_toConsumableArray(recentList))));
            } else {
                if (recentList.length === 9) {
                    var tempArr = recentList.slice(0, 8);
                    setRecentList([
                        txt
                    ].concat(Search_toConsumableArray(tempArr)));
                    localStorage.setItem("RST", JSON.stringify([
                        txt
                    ].concat(Search_toConsumableArray(tempArr))));
                } else {
                    setRecentList([
                        txt
                    ].concat(Search_toConsumableArray(recentList)));
                    localStorage.setItem("RST", JSON.stringify([
                        txt
                    ].concat(Search_toConsumableArray(recentList))));
                }
            }
        }
        router.push({
            pathname: "/search",
            query: {
                garo: (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo) || "",
                sero: (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero) || "",
                high: (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high) || "",
                erange: (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo) > 0 || (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero) > 0 || (selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high) > 0 ? selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.erange : "",
                search: txt
            }
        });
        setOpenSearch(false);
        setSearchTerm("");
    };
    var deleteRecentSearch = function(i) {
        recentList.splice(i, 1);
        setRecentList(Search_toConsumableArray(recentList));
        localStorage.setItem("RST", JSON.stringify(Search_toConsumableArray(recentList)));
    };
    var deleteRecentSearchAll = function() {
        setRecentList([]);
        localStorage.setItem("RST", JSON.stringify([]));
    };
    var handleInput = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            setTimeout(function() {
                handleSearch(searchTerm);
            }, 200);
        }
    };
    // 검색어 불러오기
    var ref5 = useSearchTagQuery(), searchTags = ref5.data;
    (0,react.useEffect)(function() {
        var ref, ref6;
        if (!router.isReady) return;
        if (router.query.search) {
            setSearchTerm(router.query.search);
        }
        if (((ref6 = (ref = Object.values(router.query)) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el > 0;
        })) === null || ref6 === void 0 ? void 0 : ref6.length) > 0) {
            var ref7, ref8, ref9, ref10;
            setSizes({
                garo: ((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.garo) > 0 ? router.query.garo : "",
                sero: ((ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.sero) > 0 ? router.query.sero : "",
                high: ((ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.high) > 0 ? router.query.high : "",
                erange: ((ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.erange) > 0 ? router.query.erange : ""
            });
        }
        setRecentList(JSON.parse(localStorage.getItem("RST")) || []);
    }, [
        router.isReady,
        router.query
    ]);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(e) {
            if (inputRef.current.contains(e.target) || floatingRef.current.contains(e.target) || (scrollSearchBtnRef === null || scrollSearchBtnRef === void 0 ? void 0 : scrollSearchBtnRef.current) && scrollSearchBtnRef.current.contains(e.target)) {
                return;
            } else {
                setOpenSearch(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        if ((searchTags === null || searchTags === void 0 ? void 0 : searchTags.length) === 0) return;
        if (Array.isArray(searchTags) && searchTerm.length > 0) {
            setFilteredTags(searchTags.filter(function(el) {
                return el.toLowerCase().includes(searchTerm.toLowerCase());
            }).slice(0, 10));
        } else {
            setFilteredTags([]);
        }
    }, [
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        if (!hasFetchedSearchTags && searchTerm.length > 1) {
            queryClient.invalidateQueries(queryKeys/* QUERY_KEYS.DUMMY.SEARCH */.U.DUMMY.SEARCH);
            setHasFetchedSearchTags(true);
        }
    }, [
        searchTerm
    ]);
    var sizes = [
        0,
        10,
        20,
        30,
        40,
        50,
        60
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-flex position-relative w-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styles_SeacrhSection, {
                className: "".concat(scroll ? "d-none" : "d-flex"),
                ref: inputRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_HeaderSearch, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    value: searchTerm,
                                    onKeyDown: handleInput,
                                    onChange: function(e) {
                                        return setSearchTerm(e.target.value);
                                    },
                                    type: "text",
                                    onFocus: function(e) {
                                        return setOpenSearch(true);
                                    },
                                    placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SizeSearchWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uAC00\uB85C",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo,
                                            onChange: function(e) {
                                                return onChangeSize(e, "garo");
                                            },
                                            onKeyDown: handleInput
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uC138\uB85C",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero,
                                            onChange: function(e) {
                                                return onChangeSize(e, "sero");
                                            },
                                            onKeyDown: handleInput
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uB192\uC774",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high,
                                            onChange: function(e) {
                                                return onChangeSize(e, "high");
                                            },
                                            onKeyDown: handleInput
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeRangeSelect, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.erange,
                                            onChange: function(e) {
                                                return onChangeSize(e, "erange");
                                            },
                                            children: sizes.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    value: el > 0 ? el : "",
                                                    children: [
                                                        "\xb1 ",
                                                        el
                                                    ]
                                                }, i);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "search_icon",
                                onClick: function() {
                                    return handleSearch(searchTerm);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/imgs/theme/icons/search_icon.png",
                                    alt: "search_icon",
                                    role: "button"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SeacrhTags, {
                        children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.keywords) && Object.values(dummyList.keywords).map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: function() {
                                    return handleSearch(el);
                                },
                                children: [
                                    "#",
                                    el,
                                    i + 1 !== Object.values(dummyList.keywords).length && ","
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSearch, {
                className: "mr-20 ".concat(scroll ? "d-flex" : "d-none"),
                openSearch: openSearch,
                onClick: function() {
                    return setOpenSearch(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeachIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fi-rs-search"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingSearchWrapper, {
                open: openSearch,
                $scroll: scroll,
                ref: floatingRef,
                children: [
                    scroll == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingScrolledSearchBar, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex align-items-center w-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    className: "form-control",
                                    value: searchTerm,
                                    onKeyDown: handleInput,
                                    onChange: function(e) {
                                        return setSearchTerm(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-search",
                                        onClick: function() {
                                            return handleSearch(searchTerm);
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTop, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: "\uCD94\uCC9C \uAC80\uC0C9\uC5B4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        onClick: function() {
                                            return setOpenSearch(false);
                                        },
                                        role: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-x"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_TagList, {
                                children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.keywords) && Object.values(dummyList.keywords).map(function(el, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            setSizes({
                                                garo: "",
                                                sero: "",
                                                high: "",
                                                erange: ""
                                            });
                                            setOpenSearch(false);
                                            router.push("/search/?search=".concat(el));
                                        },
                                        role: "button",
                                        children: el
                                    }, i);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingSizeSearch, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "size_input_wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uAC00\uB85C",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.garo,
                                            onChange: function(e) {
                                                return onChangeSize(e, "garo");
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uC138\uB85C",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.sero,
                                            onChange: function(e) {
                                                return onChangeSize(e, "sero");
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeInputBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: "\uB192\uC774",
                                            type: "tel",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.high,
                                            onChange: function(e) {
                                                return onChangeSize(e, "high");
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styles_SizeRangeSelect, {
                                        htmlFor: "size-erange",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            id: "size-erange",
                                            value: selectedSizes === null || selectedSizes === void 0 ? void 0 : selectedSizes.erange,
                                            onChange: function(e) {
                                                return onChangeSize(e, "erange");
                                            },
                                            children: sizes.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                    value: el,
                                                    children: [
                                                        "\xb1 ",
                                                        el
                                                    ]
                                                }, i);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "search_icon",
                                onClick: function() {
                                    return handleSearch(searchTerm);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/imgs/theme/icons/search_icon.png",
                                    alt: "search_icon",
                                    role: "button"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingBody, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentSearch, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: filteredTags.length > 0 ? "\uC5F0\uAD00 \uAC80\uC0C9\uC5B4" : "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentList, {
                                        children: [
                                            filteredTags.length > 0 ? filteredTags.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/icons/search_icon_gray.png",
                                                                width: 18,
                                                                height: 18,
                                                                priority: true,
                                                                alt: "search_icon"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                setSizes({
                                                                    garo: "",
                                                                    sero: "",
                                                                    high: "",
                                                                    erange: ""
                                                                });
                                                                setOpenSearch(false);
                                                                router.push("/search/?search=".concat(el));
                                                            },
                                                            role: "button",
                                                            children: el
                                                        })
                                                    ]
                                                }, i);
                                            }) : recentList.length > 0 ? recentList.map(function(el, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/icons/search_icon_gray.png",
                                                                width: 18,
                                                                height: 18,
                                                                priority: true,
                                                                alt: "search_icon"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: function() {
                                                                setSizes({
                                                                    garo: "",
                                                                    sero: "",
                                                                    high: "",
                                                                    erange: ""
                                                                });
                                                                setOpenSearch(false);
                                                                router.push("/search/?search=".concat(el));
                                                            },
                                                            role: "button",
                                                            children: el
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "delete",
                                                            onClick: function() {
                                                                return deleteRecentSearch(i);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fi-rs-x"
                                                            })
                                                        })
                                                    ]
                                                }, i);
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "\uCD5C\uADFC \uAC80\uC0C9\uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                                            }),
                                            (filteredTags === null || filteredTags === void 0 ? void 0 : filteredTags.length) === 0 && recentList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentDeleteAll, {
                                                onClick: function() {
                                                    return deleteRecentSearchAll();
                                                },
                                                children: "\uC804\uCCB4\uC0AD\uC81C"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankSearch, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: "\uC2E4\uC2DC\uAC04 \uAC80\uC0C9\uC5B4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankList, {
                                        children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.ranking) && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.ranking.map(function(el, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "number",
                                                        children: i + 1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            setSizes({
                                                                garo: "",
                                                                sero: "",
                                                                high: "",
                                                                erange: ""
                                                            });
                                                            setOpenSearch(false);
                                                            router.push("/search/?search=".concat(el.keyword));
                                                        },
                                                        role: "button",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.keyword
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "desc",
                                                        children: el.content
                                                    })
                                                ]
                                            }, i);
                                        }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Search_mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
var mapDidpatchToProps = {
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h
};
/* harmony default export */ var search_Search = ((0,es/* connect */.$j)(Search_mapStateToProps, mapDidpatchToProps)(Search));

;// CONCATENATED MODULE: ./components/layout/header/FirstHeader.js





var FirstHeader = function(param) {
    var logo = param.logo, banners = param.banners, awardIdx = param.awardIdx, scroll = param.scroll, openSearch = param.openSearch, setOpenSearch = param.setOpenSearch, scrollSearchBtnRef = param.scrollSearchBtnRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopHeader, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                    children: (logo === null || logo === void 0 ? void 0 : logo.pc) && logo.pc !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: logo.pc,
                                    alt: "pc_logo",
                                    className: "pc"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: logo.over,
                                    alt: "over_logo",
                                    className: "over"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        animation: "border",
                        role: "status"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styles_SearchWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_Search, {
                        scroll: scroll,
                        openSearch: openSearch,
                        setOpenSearch: setOpenSearch,
                        scrollSearchBtnRef: scrollSearchBtnRef
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardWrapper, {
                    children: (banners === null || banners === void 0 ? void 0 : banners.main_award) && (banners === null || banners === void 0 ? void 0 : banners.main_award.length) > 0 && (banners === null || banners === void 0 ? void 0 : banners.main_award[awardIdx]) && (banners === null || banners === void 0 ? void 0 : banners.main_award.map(function(img, imgIdx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: img.P_FileUrl,
                            alt: "2023\uD328\uD0A4\uC9D5\uB300\uC804",
                            style: {
                                display: awardIdx === imgIdx ? "block" : "none"
                            }
                        }, imgIdx);
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var header_FirstHeader = (FirstHeader);

// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct-styles.js
var SingleProduct_styles = __webpack_require__(74971);
;// CONCATENATED MODULE: ./common/toggle.js
function toggle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function toggle_templateObject() {
    var data = toggle_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  background-color: ",
        ";\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n  padding: 2px;\n  height: ",
        ";\n  position: relative;\n  margin-left: ",
        ";\n\n  .dialog-button {\n    font-size: ",
        ";\n    line-height: 16px;\n    font-weight: bold;\n    cursor: pointer;\n    background-color: ",
        ";\n    color: white;\n    padding: ",
        ";\n    border-radius: 18px;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    /* min-width: 46px; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ",
        ";\n    min-width: unset;\n    border-radius: 3px;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n    position: absolute;\n    left: ",
        ";\n    transition: all 0.3s ease;\n  }\n\n  .disabled {\n    background-color: ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    toggle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33b6186-0"
})(toggle_templateObject(), function(props) {
    return props.width || "70px";
}, function(props) {
    return props.bgColor || "#c4c4c4";
}, function(props) {
    return props.height || "32px";
}, function(props) {
    return props.mlAuto || "0";
}, function(props) {
    return props.fontSize || "12px";
}, function(props) {
    return props.btnBgColor || "#002b49";
}, function(props) {
    return props.btnPadding || "8px 12px";
}, function(props) {
    return props.btnWidth || "38px";
}, function(props) {
    return props.btnLeft;
}, function(props) {
    return props.disabledColor || "#707070";
}, function(props) {
    return props.disabledLeft;
});
var ToggleButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleWrapper, {
        width: props.width,
        height: props.height,
        fontSize: props.fontSize,
        bgColor: props.bgColor,
        btnWidth: props.btnWidth,
        btnBgColor: props.btnBgColor,
        btnPadding: props.btnPadding,
        btnLeft: props.btnLeft,
        disabledColor: props.disabledColor,
        disabledLeft: props.disabledLeft,
        mlAuto: props.mlAuto,
        onClick: function() {
            return props.onClickToggleBtn();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "dialog-button ".concat(props.isToggleActive ? "" : "disabled"),
            children: props.isToggleActive ? "On" : "Off"
        })
    });
};

;// CONCATENATED MODULE: ./components/layout/header/menu/CategoryProductMenu.js
function CategoryProductMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CategoryProductMenu_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CategoryProductMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CategoryProductMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CategoryProductMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function CategoryProductMenu_templateObject() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n"
    ]);
    CategoryProductMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryProductMenu_templateObject1() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  flex: 1;\n  height: 354px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #ffffff;\n  padding: 20px 0;\n  border-radius: 0 0 8px 8px;\n"
    ]);
    CategoryProductMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryProductMenu_templateObject2() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(8, 1fr); //  8\uAC1C \uACE0\uC815\n  width: 100%;\n  max-width: 1110px;\n  padding: 0 10px;\n"
    ]);
    CategoryProductMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryProductMenu_templateObject3() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    CategoryProductMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryProductMenu_templateObject4() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  padding: 66px 20px;\n  border: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-align: start;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 16px;\n  line-height: 1.4;\n\n  &:hover {\n    background-color: #ffffff;\n    color: #3bb77e;\n  }\n\n  /* \uC0C1\uB2E8 \uBC84\uD2BC */\n  &:first-child {\n    border-radius: 0;\n  }\n\n  /* \uD558\uB2E8 \uBC84\uD2BC (\uC88C\uCE21 \uD558\uB2E8 \uB465\uAE00\uAC8C) */\n  &:last-child {\n    border-bottom-left-radius: 8px;\n  }\n"
    ]);
    CategoryProductMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryProductMenu_templateObject5() {
    var data = CategoryProductMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: color 0.2s;\n  font-size: 16px;\n  color: #666;\n  text-align: center;\n  word-break: keep-all;\n  margin-bottom: 10px;\n\n  &:nth-child(n + 17) {\n    margin-bottom: 0;\n  }\n\n  .image-box {\n    width: 60%;\n    height: 65px;\n    background: #f4f4f4;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 12px;\n    margin-bottom: 6px;\n    cursor: pointer;\n    img {\n      object-fit: contain;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  .name {\n    font-size: 15px;\n    text-align: center;\n    line-height: 1.4;\n    transition: color 0.2s;\n    margin-bottom: 6px;\n  }\n\n  .name.active {\n    color: #3bb77e;\n  }\n\n  &:hover .name {\n    color: #3bb77e;\n    cursor: pointer;\n  }\n"
    ]);
    CategoryProductMenu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var CategorySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3f235653-0"
})(CategoryProductMenu_templateObject());
var CategoryListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f235653-1"
})(CategoryProductMenu_templateObject1());
var CategoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3f235653-2"
})(CategoryProductMenu_templateObject2());
var CategorySelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f235653-3"
})(CategoryProductMenu_templateObject3());
var CategoryProductMenu_MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3f235653-4"
})(CategoryProductMenu_templateObject4(), function(param) {
    var $active = param.$active;
    return $active ? "#ffffff" : "#d9d9d9";
}, function(param) {
    var $active = param.$active;
    return $active ? "#3bb77e" : "#7b7b7b";
}, function(param) {
    var $active = param.$active;
    return $active ? "700" : "500";
});
var Category = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3f235653-5"
})(CategoryProductMenu_templateObject5());
var CategoryProductMenu = function(param) {
    var setToggled = param.setToggled, categoriRef = param.categoriRef, dummyList = param.dummyList, _$updateProductCategory = param.updateProductCategory;
    var router = (0,next_router.useRouter)();
    var currentEname = router.query.slug;
    var ref2 = (0,react.useState)([]), category1 = ref2[0], setCategory = ref2[1];
    var ref1 = (0,react.useState)("S"), categoryType = ref1[0], setCategoryType = ref1[1];
    var selectCategory = function(e, category) {
        if (category.code === router.query.code) return;
        e.preventDefault();
        router.push("/products/".concat(category.ename, "/"));
    // categoriRef.current.children[1].style.display = "none";
    // categoriRef.current.children[1].style.zIndex = -1;
    };
    var handleCategoryType = function(type) {
        setCategoryType(type);
        fetchCategory(type);
    };
    var fetchCategory = function() {
        var _ref = CategoryProductMenu_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, filtered;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        filtered = (ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
                            return categoryType === "T" ? el.division === "T" : el.division === "S";
                        });
                        _$updateProductCategory(filtered);
                        setCategory(filtered);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    // 저장된 categoryType 불러오기
    (0,react.useEffect)(function() {
        var savedType = localStorage.getItem("categoryType");
        if (savedType === "S" || savedType === "T") {
            setCategoryType(savedType);
        }
    }, []);
    // categoryType이 변경될 때 저장
    (0,react.useEffect)(function() {
        localStorage.setItem("categoryType", categoryType);
        if (dummyList.category) {
            fetchCategory();
        }
    }, [
        categoryType,
        dummyList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySelect, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryProductMenu_MenuButton, {
                        $active: categoryType === "S",
                        $type: "S",
                        onClick: function() {
                            return handleCategoryType("S");
                        },
                        children: [
                            "\uD3EC\uC7A5\uC7AC",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30 >"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryProductMenu_MenuButton, {
                        $active: categoryType === "T",
                        $type: "T",
                        onClick: function() {
                            return handleCategoryType("T");
                        },
                        children: [
                            "\uD3EC\uC7A5\uD560 \uC0C1\uD488",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30 >"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList, {
                    children: category1 === null || category1 === void 0 ? void 0 : category1.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
                            onClick: function(e) {
                                return selectCategory(e, item);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image-box",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.image,
                                        alt: item.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "name ".concat(item.ename === currentEname ? "active" : ""),
                                    children: item.name
                                })
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
};
var CategoryProductMenu_mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
var CategoryProductMenu_mapDidpatchToProps = {
    updateProductCategory: productFiltersAction/* updateProductCategory */.pP
};
/* harmony default export */ var menu_CategoryProductMenu = ((0,es/* connect */.$j)(CategoryProductMenu_mapStateToProps, CategoryProductMenu_mapDidpatchToProps)(CategoryProductMenu));

;// CONCATENATED MODULE: ./components/layout/header/SecondHeader.js
function SecondHeader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SecondHeader_templateObject() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  background-color: #fff;\n  &.sticky-bar.stick {\n    position: sticky;\n    top: 0;\n    z-index: 999;\n    background: #fff;\n  }\n"
    ]);
    SecondHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject1() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    SecondHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject2() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: block;\n  @media (min-width: 992px) {\n    display: none;\n  }\n"
    ]);
    SecondHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject3() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: none;\n  @media (min-width: 992px) {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    SecondHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject4() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  align-items: center;\n  margin-right: 20px;\n  i {\n    cursor: pointer;\n  }\n"
    ]);
    SecondHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject5() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  min-width: 160px;\n"
    ]);
    SecondHeader_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject6() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  position: relative;\n  margin-left: 20px;\n"
    ]);
    SecondHeader_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SecondHeader_templateObject7() {
    var data = SecondHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n  span {\n    height: 2px;\n    background: #000;\n    margin: 3px 0;\n  }\n"
    ]);
    SecondHeader_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}













var HeaderBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-0"
})(SecondHeader_templateObject());
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-1"
})(SecondHeader_templateObject1());
var LogoMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-2"
})(SecondHeader_templateObject2());
var NavSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-3"
})(SecondHeader_templateObject3());
var SearchIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-4"
})(SecondHeader_templateObject4(), function(props) {
    return props.scroll ? "flex" : "none";
});
var HeaderActions = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7cbdefc2-5"
})(SecondHeader_templateObject5());
var ActionItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7cbdefc2-6"
})(SecondHeader_templateObject6());
var MobileMenuIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cbdefc2-7"
})(SecondHeader_templateObject7());
var SecondHeader = function(param) {
    var scroll = param.scroll, logo = param.logo, banners = param.banners, categoriRef = param.categoriRef, setToggled = param.setToggled, menus = param.menus, decideUrl = param.decideUrl, userName = param.userName, userCompanyName = param.userCompanyName, isUser = param.isUser, authHandler = param.authHandler, getCookie = param.getCookie, basketsCount = param.basketsCount, toggleClick = param.toggleClick, userInfo = param.userInfo, userCoupons = param.userCoupons, notificationPermission = param.notificationPermission, onClickToggleBtn = param.onClickToggleBtn, totalCartItems = param.totalCartItems, openSearch = param.openSearch, setOpenSearch = param.setOpenSearch, scrollSearchBtnRef = param.scrollSearchBtnRef, isToggleActive = param.isToggleActive;
    var ref1;
    var router = (0,next_router.useRouter)();
    var userCoupon = (0,react.useMemo)(function() {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.Coupon) {
            var ref;
            return userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Coupon) === null || ref === void 0 ? void 0 : ref.rows;
        } else {
            return null;
        }
    }, [
        userInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: scroll && !router.asPath.startsWith("/products/") ? "header-bottom header-bottom-bg-color sticky-bar stick" : "header-bottom header-bottom-bg-color sticky-bar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-wrap header-space-between position-relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logo logo-width-1 d-block d-lg-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: (logo === null || logo === void 0 ? void 0 : logo.mobile) && logo.mobile !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: logo.mobile,
                                        alt: "mobile_logo"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                        animation: "border",
                                        role: "status"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNav, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryHeaderWrapper, {
                                ref: categoriRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainCategoryButton, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-burger-menu",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "\uCE74\uD14C\uACE0\uB9AC"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArea, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_CategoryProductMenu, {
                                            setToggled: setToggled,
                                            categoriRef: categoriRef
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuNavigation, {
                                className: "main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block font-heading",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: menus
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            className: "header-nav d-none d-lg-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                                    className: scroll ? "d-flex" : "d-none",
                                    ref: scrollSearchBtnRef,
                                    children: !openSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-search",
                                        onClick: function() {
                                            return setOpenSearch(function(prev) {
                                                return !prev;
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "d-flex justify-content-end",
                                        style: {
                                            minWidth: "160px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "header-action-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "header-action-icon-2 position-relative",
                                                        children: [
                                                            !scroll && decideUrl === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "https://file.caretbio.com/caretbio/b4d44e283d9fe834c3f77d62d7de889c.png",
                                                                alt: "register_tooltip",
                                                                style: {
                                                                    position: "absolute",
                                                                    maxWidth: "none",
                                                                    left: "-50px",
                                                                    bottom: "30px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/" + "".concat(decideUrl),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "position-relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "svgInject",
                                                                            src: "/assets/imgs/theme/icons/icon-user.svg"
                                                                        }),
                                                                        (userCoupon === null || userCoupon === void 0 ? void 0 : userCoupon.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponBadge, {
                                                                            children: "\uCFE0\uD3F0"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "cart-dropdown-wrap cart-dropdown-hm2 account-dropdown",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                    children: [
                                                                        userName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "d-flex flex-column mb-10",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: userName
                                                                                    })
                                                                                }),
                                                                                userCompanyName && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                        href: "/mypage/business_registration/",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                className: "fi-rs-building mr-10"
                                                                                            }),
                                                                                            userCompanyName
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct_styles/* Sticker */.My, {
                                                                                                className: "mr-10",
                                                                                                children: "P"
                                                                                            }),
                                                                                            (0,splicePrice/* priceComma */.a)((userInfo === null || userInfo === void 0 ? void 0 : (ref1 = userInfo.Member) === null || ref1 === void 0 ? void 0 : ref1.point) || 0),
                                                                                            " P"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                Number(userCoupons === null || userCoupons === void 0 ? void 0 : userCoupons.total_count) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponInfo, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/mypage/coupon",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                    className: "fi-rs-gift-card mr-10"
                                                                                                }),
                                                                                                "\uCFE0\uD3F0: ",
                                                                                                userCoupons === null || userCoupons === void 0 ? void 0 : userCoupons.total_count,
                                                                                                " \uC7A5"
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                notificationPermission === "granted" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationArea, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fi fi-rs-bell mt-1 mr-10"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: "\uC54C\uB9BC"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                                                                                            width: "48px",
                                                                                            height: "24px",
                                                                                            fontSize: "10px",
                                                                                            bgColor: "#b6b6b6",
                                                                                            btnWidth: "24px",
                                                                                            btnBgColor: "#3bb77e",
                                                                                            btnPadding: "2px 4px",
                                                                                            btnLeft: "22px",
                                                                                            disabledColor: "#707070",
                                                                                            disabledLeft: "2px",
                                                                                            mlAuto: "auto",
                                                                                            isToggleActive: isToggleActive,
                                                                                            onClickToggleBtn: onClickToggleBtn
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/mypage/order",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                    className: "fi fi-rs-user mr-10"
                                                                                                }),
                                                                                                "\uB9C8\uC774\uD398\uC774\uC9C0"
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }) : "",
                                                                        !isUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/order-search",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fi fi-rs-barcode mr-10"
                                                                                        }),
                                                                                        "\uC8FC\uBB38 \uC870\uD68C"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            onClick: authHandler,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                type: "button",
                                                                                className: "header-nav-logout-btn",
                                                                                children: isUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fi-rs-log-out mr-10"
                                                                                        }),
                                                                                        "\uB85C\uADF8\uC544\uC6C3"
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fi-rs-lock-alt mr-10"
                                                                                        }),
                                                                                        "\uB85C\uADF8\uC778"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        !isUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/register/",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "fi-rs-sign-out-alt mr-10"
                                                                                        }),
                                                                                        "\uD68C\uC6D0 \uAC00\uC785"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            isUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "header-action-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "header-action-icon-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/shop-wishlist",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "svgInject",
                                                                    src: "/assets/imgs/theme/icons/icon-heart.svg"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "header-action-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "header-action-icon-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/shop-cart",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "mini-cart-icon",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/assets/imgs/theme/icons/icon-cart.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "pro-count blue",
                                                                            children: getCookie("token") ? basketsCount : totalCartItems
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/shop-cart",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {})
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-action-icon-2 d-flex d-lg-none",
                            style: {
                                width: "3200%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "burger-icon burger-icon-white",
                                onClick: toggleClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-burger-menu",
                                    style: {
                                        fontSize: "24px"
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-action-right d-block d-lg-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    margin: "0"
                                },
                                className: "header-action-2",
                                children: [
                                    isUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-action-icon-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/shop-wishlist",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-heart.svg"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-action-icon-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/shop-cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "mini-cart-icon",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/theme/icons/icon-cart.svg"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "pro-count white",
                                                        children: basketsCount || totalCartItems
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var header_SecondHeader = (SecondHeader);

// EXTERNAL MODULE: ./redux/action/userInfo.js
var action_userInfo = __webpack_require__(44625);
;// CONCATENATED MODULE: ./components/layout/header/ImageBanner.js
function ImageBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ImageBanner_templateObject() {
    var data = ImageBanner_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  position: relative;\n  width: 100%;\n  height: 48px;\n  text-align: center;\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  @media screen and (min-width: 575px) {\n    .swiper-wrapper {\n      transition-timing-function: linear;\n    }\n  }\n"
    ]);
    ImageBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImageBanner_templateObject1() {
    var data = ImageBanner_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: transparent;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.3s;\n  z-index: 10;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    ImageBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ImageBanner_StripeBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4d83e0-0"
})(ImageBanner_templateObject(), function(props) {
    return props.bgColor;
});
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4f4d83e0-1"
})(ImageBanner_templateObject1());
var ImageBanner = function(param) {
    var banners = param.banners, handleClose = param.handleClose;
    var ref;
    var imageBanner = (banners === null || banners === void 0 ? void 0 : (ref = banners.main_image_stripe) === null || ref === void 0 ? void 0 : ref[0]) || null;
    if (!imageBanner) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageBanner_StripeBannerWrapper, {
            bgColor: imageBanner.bg_color,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: imageBanner.link_url,
                    target: imageBanner.new_win === "Y" ? "_blank" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: imageBanner.P_FileUrl,
                        alt: imageBanner.img_alt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: handleClose,
                    children: "\xd7"
                })
            ]
        })
    });
};
/* harmony default export */ var header_ImageBanner = (ImageBanner);

// EXTERNAL MODULE: ./common/confirm.js
var common_confirm = __webpack_require__(13203);
;// CONCATENATED MODULE: ./hook/header/useAuthHandler.js








var useAuthHandler = function(param) {
    var userInfo = param.userInfo, setIsUser = param.setIsUser, setBtnText = param.setBtnText;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var userName = (0,react.useMemo)(function() {
        var ref;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.name) {
            var ref1;
            return (userInfo === null || userInfo === void 0 ? void 0 : (ref1 = userInfo.Member) === null || ref1 === void 0 ? void 0 : ref1.name) + "\uB2D8";
        } else {
            return null;
        }
    }, [
        userInfo
    ]);
    var userCompanyName = (0,react.useMemo)(function() {
        var ref, ref2;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Company) === null || ref === void 0 ? void 0 : (ref2 = ref.Data) === null || ref2 === void 0 ? void 0 : ref2.code) {
            var ref3, ref4;
            return userInfo === null || userInfo === void 0 ? void 0 : (ref3 = userInfo.Company) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Data) === null || ref4 === void 0 ? void 0 : ref4.name;
        } else {
            return "";
        }
    }, [
        userInfo
    ]);
    // 로그아웃 핸들러
    var logoutConfirmHandler = function() {
        (0,auth/* removeCookie */.nJ)("token");
        dispatch((0,action_userInfo/* initUserInfo */.bf)());
        if ((0,auth/* getCookie */.ej)("username")) (0,auth/* removeCookie */.nJ)("username");
        if (router.asPath === "/") {
            dispatch((0,baskets/* initBaskets */.fK)());
            dispatch((0,action_confirm/* closeConfirmModal */.d6)());
            router.reload();
        } else {
            dispatch((0,baskets/* initBaskets */.fK)());
            dispatch((0,action_confirm/* closeConfirmModal */.d6)());
            router.push("/");
        }
    };
    // 토큰 유무에 따른 로그인 및 로그아웃 액션 처리
    var authHandler = function() {
        if (!(0,auth/* getCookie */.ej)("token")) {
            return router.push("/login");
        } else {
            dispatch((0,action_confirm/* modifyConfirmModal */.sR)((0,common_confirm/* logoutConfirm */.ab)(logoutConfirmHandler)));
            return dispatch((0,action_confirm/* openConfirmModal */._5)());
        }
    };
    // 토큰 유무에 따른 로그인 버튼 레이아웃 분기처리
    var showBtnText = function() {
        if (!(0,auth/* getCookie */.ej)("token")) {
            setIsUser(false);
            return setBtnText("\uB85C\uADF8\uC778");
        } else if ((0,auth/* getCookie */.ej)("token")) {
            setIsUser(true);
            return setBtnText("\uB85C\uADF8\uC544\uC6C3");
        }
    };
    // 컴포넌트 마운트 시 버튼 텍스트 설정
    (0,react.useEffect)(function() {
        showBtnText();
    }, [
        userInfo
    ]);
    return {
        userName: userName,
        userCompanyName: userCompanyName,
        authHandler: authHandler,
        logoutConfirmHandler: logoutConfirmHandler,
        showBtnText: showBtnText
    };
};

// EXTERNAL MODULE: ./api/members.js
var members = __webpack_require__(40542);
;// CONCATENATED MODULE: ./hook/header/useNotiSettingHandler.js
function useNotiSettingHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useNotiSettingHandler_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useNotiSettingHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useNotiSettingHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useNotiSettingHandler_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useNotiSettingHandler_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useNotiSettingHandler_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var useNotiSettingHandler = function(param) {
    var userInfo = param.userInfo;
    var ref1 = (0,react.useState)(false), isToggleActive = ref1[0], setIsToggleActive = ref1[1];
    // 사용자 push 알림 허용 유무 정보
    var getPushStats = function() {
        var ref;
        if ((userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.pushYn) === "Y") {
            setIsToggleActive(true);
        } else setIsToggleActive(false);
    };
    // 사용자 알림 on/off 설정 action handler
    var onClickToggleBtnActionHandler = function() {
        var _ref = useNotiSettingHandler_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsToggleActive(!isToggleActive);
                        body = {
                            modes: "PushSet",
                            select: !isToggleActive === true ? "Y" : "N"
                        };
                        _ctx.next = 4;
                        return (0,members/* postMember */._)(body);
                    case 4:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 10;
                            break;
                        }
                        (0,action_confirm/* closeConfirmModal */.d6)();
                        return _ctx.abrupt("return", (0,common_alert/* successAlert */.Cq)(res.Data.Msg));
                    case 10:
                        (0,action_confirm/* closeConfirmModal */.d6)();
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)(res.Data.MSg));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickToggleBtnActionHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    // 사용자 알림 on/off 설정
    var onClickToggleBtn = function() {
        modifyConfirmModal(useNotiSettingHandler_objectSpread({}, common_confirm/* changeNotiConfirmOption */.q3, {
            onAction: function() {
                onClickToggleBtnActionHandler();
            }
        }));
        return openConfirmModal();
    };
    return {
        isToggleActive: isToggleActive,
        getPushStats: getPushStats,
        onClickToggleBtn: onClickToggleBtn
    };
};

;// CONCATENATED MODULE: ./components/layout/header/HeaderImageBanner.js


var HeaderImageBanner = function(param) {
    var imageUrl = param.imageUrl, altText = param.altText;
    var ref = (0,react.useState)(false), imgLoaded = ref[0], setImgLoaded = ref[1];
    // 이미지 로드 이벤트 핸들러
    var handleLoad = function() {
        setImgLoaded(true);
    };
    var handleError = function() {
    // console.error("이미지 로드 실패:");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imageUrl,
        alt: altText || "\uBC30\uB108 \uC774\uBBF8\uC9C0",
        style: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "12px"
        },
        onLoad: handleLoad,
        onError: handleError
    });
};

;// CONCATENATED MODULE: ./components/layout/header/menu/CategoryCustomizingMenu.js
function CategoryCustomizingMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryCustomizingMenu_templateObject() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background-color: #ffffff;\n"
    ]);
    CategoryCustomizingMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject1() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  width: 170px;\n  background-color: #f4f4f4;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CategoryCustomizingMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject2() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  border: none;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-align: start;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 16px;\n  line-height: 1.4;\n\n  &:hover {\n    background-color: #ffffff;\n    color: #3bb77e;\n  }\n"
    ]);
    CategoryCustomizingMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject3() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden; /* \uC2A4\uD06C\uB864 \uC5C6\uC560\uAE30 */\n"
    ]);
    CategoryCustomizingMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject4() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    CategoryCustomizingMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject5() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  background: #f4f4f4;\n  border-radius: 16px;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n"
    ]);
    CategoryCustomizingMenu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject6() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  width: 135px;\n  display: flex;\n  flex-direction: column;\n  padding: 15px 20px;\n  border-right: 1px solid #e0e0e0;\n\n  &:last-child {\n    border-right: none;\n  }\n\n  /* \uC704\uC544\uB798 \uACF5\uAC04 \uB9CC\uB4E4\uAE30 */\n  margin-top: 15px;\n  margin-bottom: 15px;\n\n  h4 {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 12px;\n\n    a {\n      color: inherit;\n      text-decoration: none;\n\n      &:hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      margin-bottom: 6px;\n\n      a {\n        font-size: 15px;\n        color: #666;\n        text-decoration: none;\n\n        &:hover {\n          color: #3bb77e;\n        }\n      }\n    }\n  }\n\n  ul li a.active {\n    color: #3bb77e;\n  }\n"
    ]);
    CategoryCustomizingMenu_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject7() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 10px 20px;\n  gap: 20px;\n  background: #f3f3f3;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n"
    ]);
    CategoryCustomizingMenu_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject8() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  cursor: pointer;\n  text-decoration: none;\n  color: #666;\n\n  &:hover {\n    color: #3bb77e;\n  }\n\n  &::after {\n    content: ",
        ";\n    margin-left: ",
        ";\n  }\n"
    ]);
    CategoryCustomizingMenu_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject9() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  background-color: #797979;\n  padding: 4px 30px;\n  border-radius: 28px;\n  cursor: pointer;\n  white-space: nowrap;\n  margin-left: auto;\n  &:hover {\n    background-color: #797979;\n  }\n"
    ]);
    CategoryCustomizingMenu_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject10() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    CategoryCustomizingMenu_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function CategoryCustomizingMenu_templateObject11() {
    var data = CategoryCustomizingMenu_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0px;\n  left: 78.4%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 370px;\n  margin: 6px 0;\n  height: auto;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n\n  @media (max-width: 1200px) {\n    left: 80%;\n    max-width: 320px;\n  }\n"
    ]);
    CategoryCustomizingMenu_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}






var CategoryCustomizingMenu_MegaMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-0"
})(CategoryCustomizingMenu_templateObject());
var CategoryCustomizingMenu_LeftMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-1"
})(CategoryCustomizingMenu_templateObject1());
var CategoryCustomizingMenu_MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ddfde37f-2"
})(CategoryCustomizingMenu_templateObject2(), function(param) {
    var categoryType = param.categoryType;
    return categoryType === "S" ? "86px 20px" : "84px 20px";
}, function(param) {
    var active = param.active;
    return active ? "#ffffff" : "#D9D9D9";
}, function(param) {
    var active = param.active;
    return active ? "#3bb77e" : "#7b7b7b";
}, function(param) {
    var active = param.active;
    return active ? "700" : "500";
});
var CategoryCustomizingMenu_GridAndBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-3"
})(CategoryCustomizingMenu_templateObject3());
var CategoryCustomizingMenu_CategoryGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-4"
})(CategoryCustomizingMenu_templateObject4());
var CategoryImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ddfde37f-5"
})(CategoryCustomizingMenu_templateObject5());
var CategoryCustomizingMenu_CategoryBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-6"
})(CategoryCustomizingMenu_templateObject6());
var BottomExtraMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-7"
})(CategoryCustomizingMenu_templateObject7());
var ExtraMenuItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ddfde37f-8"
})(CategoryCustomizingMenu_templateObject8(), function(param) {
    var hasDivider = param.hasDivider;
    return hasDivider ? '"|"' : '""';
}, function(param) {
    var hasDivider = param.hasDivider;
    return hasDivider ? "12px" : "0";
});
var EstimateCartButton = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ddfde37f-9"
})(CategoryCustomizingMenu_templateObject9());
var BannerArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddfde37f-10"
})(CategoryCustomizingMenu_templateObject10());
var CategoryCustomizingMenu_BannerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ddfde37f-11"
})(CategoryCustomizingMenu_templateObject11());
var CategoryCustomizingMenu = function(param) {
    var dummyList = param.dummyList, headerMenu = param.headerMenu, categories = param.categories, categoriesType = param.categoriesType, otherMenuItems = param.otherMenuItems;
    var ref4, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var second = router.query.code;
    var ref3 = (0,react.useState)("S"), categoryType = ref3[0], setCategoryType = ref3[1];
    var handleCategoryType = function(type) {
        setCategoryType(type);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_MegaMenuWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_LeftMenu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_MenuButton, {
                                active: categoryType === "S",
                                categoryType: categoryType,
                                onClick: function() {
                                    return handleCategoryType("S");
                                },
                                children: [
                                    "\uD3EC\uC7A5\uC7AC",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30 >"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_MenuButton, {
                                active: categoryType === "T",
                                categoryType: categoryType,
                                onClick: function() {
                                    return handleCategoryType("T");
                                },
                                children: [
                                    "\uD3EC\uC7A5\uD560 \uC0C1\uD488",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uBA3C\uC800 \uC120\uD0DD\uD558\uAE30 >"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_GridAndBanner, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCustomizingMenu_CategoryGrid, {
                                children: (ref4 = categoryType === "S" ? categories : categoriesType) === null || ref4 === void 0 ? void 0 : ref4.map(function(category, idx) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CategoryCustomizingMenu_CategoryBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryImg, {
                                                src: category.image,
                                                alt: category.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/customizing/customizing-products/new/?first=".concat(category.code, "&code="),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: category.name
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: (ref = category.children) === null || ref === void 0 ? void 0 : ref.map(function(child, cIdx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/customizing/customizing-products/new/?first=".concat(category.code, "&code=").concat(child.code),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: second === child.code ? "active" : "",
                                                                style: {
                                                                    fontWeight: "100"
                                                                },
                                                                children: child.name
                                                            })
                                                        })
                                                    }, cIdx);
                                                })
                                            })
                                        ]
                                    }, idx);
                                })
                            }),
                            categoryType === "S" && (headerMenu === null || headerMenu === void 0 ? void 0 : headerMenu.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerArea, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCustomizingMenu_BannerButton, {
                                    onClick: function() {
                                        var ref;
                                        var url = headerMenu && headerMenu.length > 0 && ((ref = headerMenu[0]) === null || ref === void 0 ? void 0 : ref.link_url) || "https://www.caretstore.co.kr/";
                                        router.push(url);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageBanner, {
                                        imageUrl: (ref1 = headerMenu[0]) === null || ref1 === void 0 ? void 0 : ref1.P_FileUrl,
                                        altText: ((ref2 = headerMenu[0]) === null || ref2 === void 0 ? void 0 : ref2.img_alt) || ""
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            otherMenuItems && otherMenuItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomExtraMenu, {
                children: [
                    otherMenuItems.filter(function(item) {
                        return item.title !== "\uB9DE\uCDA4\uC81C\uC791";
                    }).map(function(item, idx, arr) {
                        var isLast = idx === arr.length - 1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item.url || "#",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraMenuItem, {
                                hasDivider: !isLast,
                                style: {
                                    fontWeight: "100"
                                },
                                children: item.title
                            })
                        }, idx);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://www.caretstore.co.kr/customizing/customizing-cart/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EstimateCartButton, {
                            children: "\uACAC\uC801 \uBC14\uAD6C\uB2C8"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var menu_CategoryCustomizingMenu = (CategoryCustomizingMenu);

;// CONCATENATED MODULE: ./components/layout/header/menu/CategoryMenu.js
function CategoryMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryMenu_templateObject() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  padding: 30px 40px;\n  align-items: center;\n  gap: 35px;\n"
    ]);
    CategoryMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject1() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 68px;\n  border-right: 1px solid #e0e0e0;\n  padding-right: 40px;\n"
    ]);
    CategoryMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject2() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #1db66d;\n"
    ]);
    CategoryMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject3() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"
    ]);
    CategoryMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject4() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  margin-bottom: 8px;\n  font-size: 16px;\n  line-height: 1.4;\n\n  a {\n    color: #666;\n    text-decoration: none;\n\n    &:hover {\n      color: #3bb77e;\n    }\n\n    &.active {\n      font-weight: 800;\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    CategoryMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CategoryMenu_templateObject5() {
    var data = CategoryMenu_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    max-width: 610px;\n    height: auto;\n  }\n"
    ]);
    CategoryMenu_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var MenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3229a35c-0"
})(CategoryMenu_templateObject());
var CategoryMenu_LeftMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3229a35c-1"
})(CategoryMenu_templateObject1());
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3229a35c-2"
})(CategoryMenu_templateObject2());
var MenuList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3229a35c-3"
})(CategoryMenu_templateObject3());
var CategoryMenu_MenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3229a35c-4"
})(CategoryMenu_templateObject4());
var CategoryMenu_BannerArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3229a35c-5"
})(CategoryMenu_templateObject5());
var CategoryMenu = function(param) {
    var page = param.page, title = param.title, img = param.img, url = param.url;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryMenu_LeftMenu, {
                hasBanner: !img,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                        children: page.sub.map(function(subItem, subIdx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenu_MenuItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: subItem.url || "#",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: router.pathname === subItem.url ? "active" : "",
                                        style: {
                                            fontWeight: "100"
                                        },
                                        children: subItem.title
                                    })
                                })
                            }, subIdx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenu_BannerArea, {
                onClick: function() {
                    if (url) {
                        router.push(url);
                    }
                },
                style: {
                    cursor: url ? "pointer" : "default"
                },
                children: img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: img,
                    alt: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://file.caretbio.com/caretbio/3c0efd8a1a5306490192452fb4bd6ca1.png",
                    alt: "\uAE30\uBCF8 \uBC30\uB108 \uC774\uBBF8\uC9C0"
                })
            })
        ]
    });
};
/* harmony default export */ var menu_CategoryMenu = (CategoryMenu);

;// CONCATENATED MODULE: ./components/layout/Header.js
function Header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Header_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Header_arrayLikeToArray(arr);
}
function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Header_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Header_toConsumableArray(arr) {
    return Header_arrayWithoutHoles(arr) || Header_iterableToArray(arr) || Header_unsupportedIterableToArray(arr) || Header_nonIterableSpread();
}
function Header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Header_arrayLikeToArray(o, minLen);
}
function Header_templateObject() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: ",
        ";\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  width: 1110px;\n  z-index: 100;\n  gap: 24px;\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: relative;\n\n  &:hover ",
        " {\n    display: flex;\n  }\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






























var StyledMegaMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a18fd70-0"
})(Header_templateObject(), function(param) {
    var $left = param.$left;
    return "".concat($left, "px");
});
// 부모 li가 hover 상태일 때 보여주기
var MenuItemWithDropdown = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3a18fd70-1"
})(Header_templateObject1(), StyledMegaMenu);
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Header_Header = function(param) {
    var logo = param.logo, show = param.show, totalCartItems = param.totalCartItems, toggleClick = param.toggleClick, _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, userInfo = param.userInfo, _$deleteBasketsAction = param.deleteBasketsAction, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, _$clearBasketsAction = param.clearBasketsAction, basketItems = param.basketItems, basketsCount = param.basketsCount, _$initBaskets = param.initBaskets, _$deleteFromCart = param.deleteFromCart, _$updateProductCategory = param.updateProductCategory, productFilters = param.productFilters, loading = param.loading, userCoupons = param.userCoupons, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, _$fetchDummyList = param.fetchDummyList, dummyList = param.dummyList, vp = param.vp, cartItems = param.cartItems, _$clearCart = param.clearCart, _$decreaseCnt = param.decreaseCnt, _$increaseCnt = param.increaseCnt, _$fetchSiteInfo = param.fetchSiteInfo, siteInfo = param.siteInfo, _$initUserInfo = param.initUserInfo, banners = param.banners;
    var router = (0,next_router.useRouter)();
    var ref14 = (0,react.useState)(false), isToggled = ref14[0], setToggled = ref14[1];
    var ref1 = (0,react.useState)(0), scroll = ref1[0], setScroll = ref1[1];
    var ref2 = (0,react.useState)(""), btnText = ref2[0], setBtnText = ref2[1];
    var ref3 = (0,react.useState)(false), isUser = ref3[0], setIsUser = ref3[1];
    var ref4 = (0,react.useState)(""), decideUrl = ref4[0], setDecideUrl = ref4[1];
    var categoriRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(""), notificationPermission = ref5[0], setNotificationPermission = ref5[1];
    var ref6 = (0,react.useState)(0), awardIdx = ref6[0], setAwardIdx = ref6[1];
    var ref7 = (0,react.useState)(null), menus1 = ref7[0], setMenus = ref7[1];
    var ref8 = (0,react.useState)(false), searchToggled = ref8[0], setSearchToggled = ref8[1];
    var ref9 = (0,react.useState)(false), openSearch = ref9[0], setOpenSearch = ref9[1];
    var scrollSearchBtnRef = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), isMobile = ref10[0], setIsMobile = ref10[1];
    //배너 데이터
    var ref11 = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), bannerList = ref11.bannerList, headerMenu = ref11.headerMenu, mainAward = ref11.mainAward, mainStripe = ref11.mainStripe, mainImageStripe = ref11.mainImageStripe, lnbEsg = ref11.lnbEsg, lnbCsboard = ref11.lnbCsboard, lnbSmallPrint = ref11.lnbSmallPrint;
    // 모바일 여부 확인
    (0,react.useEffect)(function() {
        var checkMobile = function() {
            setIsMobile(window.innerWidth <= 767);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return function() {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);
    var handleClose = function() {
        // 1일 후 만료되는 쿠키 설정
        var expiryDate = new Date();
        // 당일 밤 11:59:59로 설정
        expiryDate.setHours(23, 59, 59, 999);
        // 현재 시간 확인
        var now = new Date();
        if (now > expiryDate) {
            // 이미 당일 밤 11:59:59를 지났다면 다음날 밤 11:59:59로 설정
            expiryDate.setDate(expiryDate.getDate() + 1);
        }
        // 쿠키를 "true"로 설정하여 배너 숨김 유지
        (0,auth/* setCookie */.d8)(auth/* BANNER_COOKIE_NAME */.Dq, "true", {
            path: "/",
            expires: expiryDate
        });
    };
    var onClickSearch = function() {
        setSearchToggled(!searchToggled);
    };
    var hadleClickOutSide = function(e) {
        if (categoriRef.current) {
            var ref;
            if (!((ref = categoriRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                categoriRef.current.children[1].style.visibility = "hidden";
                categoriRef.current.children[1].style.zIndex = -1;
            } else {
                categoriRef.current.children[1].style.visibility = "visible";
                categoriRef.current.children[1].style.zIndex = 99;
            }
        }
    };
    var isTokenValid = function() {
        var token = (0,auth/* getCookie */.ej)("token");
        var loginUrl = "login";
        var mypageUrl = "mypage/order";
        if (!token) return setDecideUrl(loginUrl);
        else return setDecideUrl(mypageUrl);
    };
    //사용자 알림 처리
    var ref12 = useNotiSettingHandler({
        userInfo: userInfo
    }), isToggleActive = ref12.isToggleActive, getPushStats = ref12.getPushStats, onClickToggleBtn = ref12.onClickToggleBtn;
    //토큰&로그인&로그아웃 처리
    var ref13 = useAuthHandler({
        userInfo: userInfo,
        openConfirmModal: _$openConfirmModal,
        setIsUser: setIsUser,
        setBtnText: setBtnText
    }), userName = ref13.userName, userCompanyName = ref13.userCompanyName, authHandler = ref13.authHandler, showBtnText = ref13.showBtnText, logoutConfirmHandler = ref13.logoutConfirmHandler;
    // 메뉴 라우팅
    var buildPage = function(pages) {
        if (!pages) return;
        var temp = Header_toConsumableArray(pages);
        // 시제품 판촉물 필터링
        var filteredPages = temp.map(function(page) {
            if (page.sub) {
                return Header_objectSpread({}, page, {
                    sub: page.sub.filter(function(subPage) {
                        // 시제품 제작 메뉴는 siteConfig.Prototype이 null이 아닐 때만 표시
                        if (subPage.url === "/customizing/prototype") {
                            return (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Prototype) !== null;
                        }
                        if (subPage.url === "/customizing/promotion") {
                            return (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Promotion) !== null;
                        }
                        return true;
                    })
                });
            }
            return page;
        });
        var menus = filteredPages.map(function(page, pageIdx) {
            if (!page.sub) {
                // 현재 경로에서 쿼리 제거
                var currentPath = router.asPath.split("?")[0];
                var targetPath = page.url.split("?")[0];
                // targetPath가 상대 경로라면 절대 경로로 변환
                if (!targetPath.startsWith("/")) {
                    targetPath = "/" + targetPath;
                }
                // 슬래시(`/`)로 끝나지 않도록 처리하여 비교 시 일관성 유지
                targetPath = targetPath.replace(/\/$/, "");
                // 현재 경로가 targetPath로 시작하면 active 처리
                var isActive = currentPath === targetPath || currentPath.startsWith(targetPath + "/");
                // 서브메뉴가 없는 일반 메뉴 처리
                if (page.url === "/group-purchase") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: page.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: isActive ? "active" : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "position-relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(proceedingMenuBadge, {
                                            siteInfo: siteInfo
                                        }),
                                        page.title
                                    ]
                                })
                            })
                        })
                    }, pageIdx);
                } else {
                    if (page.url === "/customizing/prototype" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Prototype) === null) {
                        return null;
                    }
                    if (page.url === "/customizing/promotion" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Promotion) === null) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: page.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: isActive ? "active" : "",
                                children: page.title
                            })
                        })
                    }, pageIdx);
                }
            } else {
                // 맞춤제작 메뉴 특별 처리
                if (page.title === "\uB9DE\uCDA4\uC81C\uC791") {
                    // siteInfo.MakeCategory에서 데이터를 가져와 동적으로 구성
                    var categories = (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.MakeCategory) || [];
                    var categoriesType = (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.MakeTypeCategory) || [];
                    // PageRouter에서 맞춤제작 관련 정적 메뉴 항목 찾기
                    var customizingRouter = pageRouter/* PageRouter.find */.L.find(function(route) {
                        return route.title === "\uB9DE\uCDA4\uC81C\uC791";
                    });
                    // 하단 메뉴용 항목 (견적 바구니, 포트폴리오, 고객사)
                    var bottomMenuItems = customizingRouter.sub;
                    // 기타 메뉴 항목들 (시제품 제작, 판촉물 제작)
                    var otherMenuItems = bottomMenuItems.filter(function(item) {
                        // siteInfo 값에 따라 필터링
                        if (item.url === "/customizing/prototype" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Prototype) === null) {
                            return false;
                        }
                        if (item.url === "/customizing/promotion" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Promotion) === null) {
                            return false;
                        }
                        return true;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItemWithDropdown, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: page.url || "#",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: page.sub.some(function(subItem) {
                                        return router.asPath.includes(subItem.url) || subItem.subCategories && subItem.subCategories.some(function(cat) {
                                            return router.asPath.includes(cat.url);
                                        });
                                    }) ? "active" : "",
                                    children: page.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMegaMenu, {
                                $left: -142,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_CategoryCustomizingMenu, {
                                    dummyList: dummyList,
                                    headerMenu: headerMenu,
                                    categories: categories,
                                    categoriesType: categoriesType,
                                    otherMenuItems: otherMenuItems
                                })
                            })
                        ]
                    }, pageIdx);
                } else {
                    var ref, ref15, ref16, ref17, ref18, ref19;
                    // 일반적인 서브메뉴가 있는 메뉴 처리
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItemWithDropdown, {
                        children: [
                            page.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: page.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: page.sub.some(function(subItem) {
                                        return router.asPath.includes(subItem.url);
                                    }) ? "active" : "",
                                    children: page.title
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                role: "button",
                                className: page.sub.some(function(subItem) {
                                    return router.asPath.includes(subItem.url);
                                }) ? "active" : "",
                                children: page.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMegaMenu, {
                                $left: page.title === "\uACE0\uAC1D\uC9C0\uC6D0" ? -600 // 고객지원 메뉴 위치 조정
                                 : page.title === "ESG\uC790\uB8CC\uC2E4" ? -498 // ESG 메뉴 위치 조정
                                 : -225 // 소량인쇄
                                ,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_CategoryMenu, {
                                    page: page,
                                    title: page.title,
                                    img: page.title === "\uACE0\uAC1D\uC9C0\uC6D0" ? lnbCsboard === null || lnbCsboard === void 0 ? void 0 : (ref = lnbCsboard[0]) === null || ref === void 0 ? void 0 : ref.P_FileUrl : page.title === "ESG\uC790\uB8CC\uC2E4" ? lnbEsg === null || lnbEsg === void 0 ? void 0 : (ref15 = lnbEsg[0]) === null || ref15 === void 0 ? void 0 : ref15.P_FileUrl : lnbSmallPrint === null || lnbSmallPrint === void 0 ? void 0 : (ref16 = lnbSmallPrint[0]) === null || ref16 === void 0 ? void 0 : ref16.P_FileUrl,
                                    url: page.title === "\uACE0\uAC1D\uC9C0\uC6D0" ? lnbCsboard === null || lnbCsboard === void 0 ? void 0 : (ref17 = lnbCsboard[0]) === null || ref17 === void 0 ? void 0 : ref17.link_url : page.title === "ESG\uC790\uB8CC\uC2E4" ? lnbEsg === null || lnbEsg === void 0 ? void 0 : (ref18 = lnbEsg[0]) === null || ref18 === void 0 ? void 0 : ref18.link_url : lnbSmallPrint === null || lnbSmallPrint === void 0 ? void 0 : (ref19 = lnbSmallPrint[0]) === null || ref19 === void 0 ? void 0 : ref19.link_url
                                })
                            })
                        ]
                    }, pageIdx);
                }
            }
        });
        return menus;
    };
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", function() {
            var scrollCheck = window.scrollY >= 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
        document.addEventListener("mouseover", hadleClickOutSide);
        return function() {
            document.removeEventListener("mouseover", hadleClickOutSide);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (mainAward && mainAward.length > 0) {
            setTimeout(function() {
                if (awardIdx + 1 >= mainAward.length) {
                    setAwardIdx(0);
                    return;
                }
                setAwardIdx(function(prev) {
                    return prev + 1;
                });
            }, 3000);
        }
    }, [
        bannerList,
        awardIdx
    ]);
    (0,react.useEffect)(function() {
        getPushStats();
        isTokenValid();
        showBtnText();
    }, [
        userInfo
    ]);
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        setMenus(buildPage(pageRouter/* PageRouter */.L));
        (0,auth/* getCookie */.ej)("token") && _$fetchBasketsAction();
        if (Object.keys(dummyList).length === 0) {
            _$fetchDummyList();
        }
        if (Object.keys(siteInfo).length === 0) {
            _$fetchSiteInfo(router);
        }
        if ( true && "Notification" in window) {
            // 알림 허용 상태 변경 시 실행되는 함수
            var handlePermissionChange = function() {
                setNotificationPermission(Notification.permission);
            };
            // 알림 허용 상태 변경 이벤트를 감지하고 상태를 업데이트합니다.
            Notification.requestPermission().then(handlePermissionChange);
            window.addEventListener("change", handlePermissionChange);
            // 컴포넌트 언마운트 시 이벤트 리스너를 제거합니다.
            return function() {
                window.removeEventListener("change", handlePermissionChange);
            };
        }
    }, [
        router.isReady,
        siteInfo
    ]);
    var bannerCookie = (0,auth/* getCookie */.ej)(auth/* BANNER_COOKIE_NAME */.Dq);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Suspense, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "header-area header-style-1 header-height-2",
                children: [
                    isMobile ? Array.isArray(mainStripe) && mainStripe.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_StripeBanner, {
                        banners: bannerList
                    }) : bannerCookie ? /*#__PURE__*/ (0,jsx_runtime.jsx)(header_StripeBanner, {
                        banners: bannerList
                    }) : Array.isArray(mainImageStripe) && mainImageStripe.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_ImageBanner, {
                        banners: bannerList,
                        handleClose: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_FirstHeader, {
                        logo: logo,
                        banners: bannerList,
                        awardIdx: awardIdx,
                        scroll: scroll,
                        openSearch: openSearch,
                        setOpenSearch: setOpenSearch,
                        scrollSearchBtnRef: scrollSearchBtnRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_SecondHeader, {
                        scroll: scroll,
                        logo: logo,
                        banners: bannerList,
                        categoriRef: categoriRef,
                        setToggled: setToggled,
                        menus: menus1,
                        decideUrl: decideUrl,
                        userName: userName,
                        userCompanyName: userCompanyName,
                        isUser: isUser,
                        authHandler: authHandler,
                        getCookie: auth/* getCookie */.ej,
                        basketsCount: basketsCount,
                        toggleClick: toggleClick,
                        userInfo: userInfo,
                        userCoupons: userCoupons,
                        notificationPermission: notificationPermission,
                        onClickToggleBtn: onClickToggleBtn,
                        totalCartItems: totalCartItems,
                        openSearch: openSearch,
                        setOpenSearch: setOpenSearch,
                        scrollSearchBtnRef: scrollSearchBtnRef,
                        isToggleActive: isToggleActive
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileSearch_MobileSearch, {
                searchToggled: searchToggled,
                onClickSearch: onClickSearch,
                dummyList: dummyList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(user, {
                scroll: scroll,
                userInfo: userInfo,
                basketItems: basketItems,
                clearBasketsAction: _$clearBasketsAction,
                modifyConfirmModal: _$modifyConfirmModal,
                openConfirmModal: _$openConfirmModal,
                closeConfirmModal: _$closeConfirmModal,
                deleteBasketsAction: _$deleteBasketsAction,
                fetchBasketsAction: _$fetchBasketsAction,
                insertBasketsAction: _$insertBasketsAction,
                deleteFromCart: _$deleteFromCart,
                vp: vp,
                cartItems: cartItems,
                clearCart: _$clearCart,
                decreaseCnt: _$decreaseCnt,
                increaseCnt: _$increaseCnt,
                onClickSearch: onClickSearch,
                toggleClick: toggleClick
            })
        ]
    });
};
var Header_mapStateToProps = function(state) {
    return {
        show: state.confirm.modal,
        totalCartItems: state.cart.length,
        cartItems: state.cart,
        basketItems: state.baskets.items,
        basketsCount: state.baskets.count,
        productFilters: state.productFilters,
        loading: state.loading.loading,
        // banners: state.banners,
        dummyList: state.dummyList,
        vp: state.vp,
        siteInfo: state.siteInfo
    };
};
var Header_mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    deleteBasketsAction: baskets/* deleteBasketsAction */.Xv,
    insertBasketsAction: baskets/* insertBasketsAction */.el,
    fetchBasketsAction: baskets/* fetchBasketsAction */.Ei,
    clearBasketsAction: baskets/* clearBasketsAction */.Yp,
    initBaskets: baskets/* initBaskets */.fK,
    deleteFromCart: cart/* deleteFromCart */.EI,
    updateProductCategory: productFiltersAction/* updateProductCategory */.pP,
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h,
    fetchDummyList: fetchDummyList,
    clearCart: cart/* clearCart */.LL,
    decreaseCnt: cart/* decreaseCnt */.Yl,
    increaseCnt: cart/* increaseCnt */.us,
    fetchSiteInfo: fetchSiteInfo,
    initUserInfo: action_userInfo/* initUserInfo */.bf
};
/* harmony default export */ var layout_Header = ((0,es/* connect */.$j)(Header_mapStateToProps, Header_mapDispatchToProps)(Header_Header));

;// CONCATENATED MODULE: ./common/util/outsideClick.js

var useClickOutside = function(handler) {
    var domNode = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var maybeHandler = function(event) {
            var ref;
            if (!((ref = domNode.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                handler();
            }
        };
        document.addEventListener("mousedown", maybeHandler);
        return function() {
            document.removeEventListener("mousedown", maybeHandler);
        };
    });
    return domNode;
};
/* harmony default export */ var outsideClick = (useClickOutside);

;// CONCATENATED MODULE: ./components/layout/mobile-category.js
function mobile_category_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function mobile_category_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                mobile_category_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                mobile_category_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function mobile_category_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function mobile_category_templateObject() {
    var data = mobile_category_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    mobile_category_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mobile_category_templateObject1() {
    var data = mobile_category_taggedTemplateLiteral([
        "\n  margin: 10px 0px 0px 0px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n\n  & button {\n    padding: 5px 5px;\n    border: 1px solid #253d4e;\n    background-color: #fff;\n  }\n  .general {\n    border-color: ",
        " !important;\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n  .type {\n    border-color: ",
        " !important;\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n"
    ]);
    mobile_category_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mobile_category_templateObject2() {
    var data = mobile_category_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n"
    ]);
    mobile_category_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mobile_category_templateObject3() {
    var data = mobile_category_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  margin-top: 10px;\n"
    ]);
    mobile_category_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function mobile_category_templateObject4() {
    var data = mobile_category_taggedTemplateLiteral([
        "\n  width: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  border: 1px solid #f2f3f4;\n  height: 40px;\n  padding: 5px 5px;\n  line-height: 1;\n  word-break: keep-all;\n  :hover {\n    border-color: #3bb77e;\n  }\n  & a {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    color: #696969;\n  }\n  & img {\n    width: 30px;\n    height: 30px;\n    margin-right: 5px;\n  }\n"
    ]);
    mobile_category_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var mobile_category_CategorySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ab4fd7a5-0"
})(mobile_category_templateObject());
var mobile_category_CategorySelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab4fd7a5-1"
})(mobile_category_templateObject1(), function(props) {
    return props.categoryType === "general" ? "#3bb77e" : "#7e7e7e";
}, function(props) {
    return props.categoryType === "general" ? "#ffffff" : "#7e7e7e";
}, function(props) {
    return props.categoryType === "general" ? "#3bb77e" : "#ffffff";
}, function(props) {
    return props.categoryType === "type" ? "#3bb77e" : "#7e7e7e";
}, function(props) {
    return props.categoryType === "type" ? "#ffffff" : "#7e7e7e";
}, function(props) {
    return props.categoryType === "type" ? "#3bb77e" : "#ffffff";
});
var mobile_category_CategoryListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab4fd7a5-2"
})(mobile_category_templateObject2());
var mobile_category_CategoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-ab4fd7a5-3"
})(mobile_category_templateObject3());
var mobile_category_Category = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-ab4fd7a5-4"
})(mobile_category_templateObject4());
var MobileCategory = function(param) {
    var categoriRef = param.categoriRef, dummyList = param.dummyList;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)([]), category = ref2[0], setCategory = ref2[1];
    var ref1 = (0,react.useState)("general"), categoryType = ref1[0], setCategoryType = ref1[1];
    var fetchCategory = function() {
        var _ref = mobile_category_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setCategory((ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
                            return categoryType === "type" ? el.division === "T" : el.division === "S";
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCategoryType = function(type) {
        setCategoryType(type);
        fetchCategory(type);
    };
    (0,react.useEffect)(function() {
        if (dummyList.category) {
            fetchCategory();
        }
    }, [
        dummyList,
        categoryType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_category_CategorySection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_category_CategorySelect, {
                categoryType: categoryType,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "general",
                        value: "general",
                        onClick: function(e) {
                            return handleCategoryType("general");
                        },
                        children: "\uD3EC\uC7A5\uC7AC \uBA3C\uC800 \uC120\uD0DD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "type",
                        value: "type",
                        onClick: function(e) {
                            return handleCategoryType("type");
                        },
                        children: "\uD3EC\uC7A5\uD560 \uC0C1\uD488 \uBA3C\uC800 \uC120\uD0DD"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_category_CategoryListWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_category_CategoryList, {
                    children: category === null || category === void 0 ? void 0 : category.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_category_Category, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "/products/".concat(item.ename, "/"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.image,
                                        alt: ""
                                    }),
                                    item.name
                                ]
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};
var mobile_category_mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var mobile_category = ((0,es/* connect */.$j)(mobile_category_mapStateToProps, null)(MobileCategory));

;// CONCATENATED MODULE: ./components/layout/MobileMenu.js
function MobileMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileMenu_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return MobileMenu_arrayLikeToArray(arr);
}
function MobileMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileMenu_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function MobileMenu_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MobileMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MobileMenu_toConsumableArray(arr) {
    return MobileMenu_arrayWithoutHoles(arr) || MobileMenu_iterableToArray(arr) || MobileMenu_unsupportedIterableToArray(arr) || MobileMenu_nonIterableSpread();
}
function MobileMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileMenu_arrayLikeToArray(o, minLen);
}
function MobileMenu_templateObject() {
    var data = MobileMenu_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n  & h5 {\n    margin-bottom: 1rem;\n  }\n  & div {\n    display: flex;\n  }\n  & li {\n    margin-right: 0.5rem;\n  }\n"
    ]);
    MobileMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var UserInfoWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9dfef97-0"
})(MobileMenu_templateObject());
var MobileMenu = function(param) {
    var isToggled = param.isToggled, toggleClick = param.toggleClick, userInfo = param.userInfo, show = param.show, _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, userCoupons = param.userCoupons, siteInfo = param.siteInfo, _$initUserInfo = param.initUserInfo;
    var ref;
    var categoriRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)({
        status: false,
        key: ""
    }), isActive = ref1[0], setIsActive = ref1[1];
    var ref2 = (0,react.useState)(""), btnText = ref2[0], setBtnText = ref2[1];
    var ref3 = (0,react.useState)(""), searchTerm = ref3[0], setSearchTerm = ref3[1];
    var ref4 = (0,react.useState)(""), notificationPermission = ref4[0], setNotificationPermission = ref4[1];
    var ref5 = (0,react.useState)(null), menus1 = ref5[0], setMenus = ref5[1];
    var ref6 = (0,react.useState)(false), isUser = ref6[0], setIsUser = ref6[1];
    //사용자 알림 처리
    var ref7 = useNotiSettingHandler({
        userInfo: userInfo
    }), isToggleActive = ref7.isToggleActive, getPushStats = ref7.getPushStats, onClickToggleBtn = ref7.onClickToggleBtn;
    //토큰&로그인&로그아웃 처리
    var ref8 = useAuthHandler({
        userInfo: userInfo,
        openConfirmModal: _$openConfirmModal,
        setIsUser: setIsUser,
        setBtnText: setBtnText
    }), userName = ref8.userName, userCompanyName = ref8.userCompanyName, authHandler = ref8.authHandler, showBtnText = ref8.showBtnText, logoutConfirmHandler = ref8.logoutConfirmHandler;
    var handleSearch = function() {
        if (searchTerm.length < 2) return (0,common_alert/* failAlert */.qh)("\uB450 \uAE00\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
        clearTimeout();
        router.push({
            pathname: "/search",
            query: {
                search: searchTerm
            }
        });
        setSearchTerm("");
        toggleClick();
    };
    var handleToggle = function(key) {
        if (isActive.key === key) {
            setIsActive({
                status: false
            });
        } else {
            setIsActive({
                status: true,
                key: key
            });
        }
    };
    var domNode = outsideClick(function() {
        setIsActive({
            status: false
        });
    });
    // 메뉴 라우팅
    var buildPage = function(pages) {
        if (!pages) return;
        var temp = MobileMenu_toConsumableArray(pages);
        // 시제품 판촉물 필터링
        var filteredPages = temp.map(function(page) {
            if (page.sub) {
                return MobileMenu_objectSpread({}, page, {
                    sub: page.sub.filter(function(subPage) {
                        // 시제품 제작 메뉴는 siteConfig.Prototype이 null이 아닐 때만 표시
                        if (subPage.url === "/customizing/prototype") {
                            return (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Prototype) !== null;
                        }
                        if (subPage.url === "/customizing/promotion") {
                            return (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Promotion) !== null;
                        }
                        return true;
                    })
                });
            }
            return page;
        });
        var menus = filteredPages.map(function(page, pageIdx) {
            if (page.url === "/customizing/prototype" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Prototype) === null) {
                return null;
            }
            if (page.url === "/customizing/promotion" && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.Promotion) === null) {
                return null;
            }
            if (!page.sub) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    onClick: function() {
                        return handleToggle(pageIdx);
                    },
                    className: isActive.key == pageIdx && page.sub ? "menu-item-has-children active" : "menu-item-has-children",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: page.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: page.title
                        })
                    })
                }, pageIdx);
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    onClick: function() {
                        return handleToggle(pageIdx);
                    },
                    className: isActive.key == pageIdx ? "menu-item-has-children active" : "menu-item-has-children",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "menu-expand",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-angle-small-down"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: page.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: isActive.key == pageIdx ? "dropdown" : "d-none",
                            children: buildPage(page.sub)
                        })
                    ]
                }, pageIdx);
            }
        });
        return menus;
    };
    (0,react.useEffect)(function() {
        getPushStats();
        showBtnText();
    }, [
        userInfo
    ]);
    (0,react.useEffect)(function() {
        setMenus(buildPage(pageRouter/* PageRouter */.L));
        if ( true && "Notification" in window) {
            // 알림 허용 상태 변경 시 실행되는 함수
            var handlePermissionChange = function() {
                setNotificationPermission(Notification.permission);
            };
            // 알림 허용 상태 변경 이벤트를 감지하고 상태를 업데이트합니다.
            Notification.requestPermission().then(handlePermissionChange);
            window.addEventListener("change", handlePermissionChange);
            // 컴포넌트 언마운트 시 이벤트 리스너를 제거합니다.
            return function() {
                window.removeEventListener("change", handlePermissionChange);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        setMenus(buildPage(pageRouter/* PageRouter */.L));
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: isToggled ? "mobile-header-active mobile-header-wrapper-style sidebar-visible " : "mobile-header-active mobile-header-wrapper-style",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile-header-wrapper-inner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobile-header-top",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-header-logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/imgs/theme/logo-header-icon-m.png",
                                            alt: "logo",
                                            style: {
                                                width: "200px"
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "close-style-wrap close-style-position-inherit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "close-style search-close",
                                    onClick: toggleClick,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "icon-top"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "icon-bottom"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobile-header-content-area",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-header-info-wrap ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "single-mobile-header-info ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoWrapper, {
                                        children: userName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-between",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        className: "d-flex justify-content-start align-items-center",
                                                        children: [
                                                            userName,
                                                            " ",
                                                            userCompanyName && "(".concat(userCompanyName, ")")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "d-flex justify-content-start align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct_styles/* Sticker */.My, {
                                                                        className: "mr-5",
                                                                        children: "P"
                                                                    }),
                                                                    (0,splicePrice/* priceComma */.a)((userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.point) || 0),
                                                                    " P"
                                                                ]
                                                            })
                                                        }),
                                                        Number(userCoupons === null || userCoupons === void 0 ? void 0 : userCoupons.total_count) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponInfo, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/mypage/coupon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fi-rs-gift-card mr-10"
                                                                        }),
                                                                        "\uCFE0\uD3F0: ",
                                                                        userCoupons === null || userCoupons === void 0 ? void 0 : userCoupons.total_count,
                                                                        " \uC7A5"
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        notificationPermission === "granted" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNotificationArea, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi fi-rs-bell mr-10"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC54C\uB9BC"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                                                                    width: "48px",
                                                                    height: "24px",
                                                                    fontSize: "10px",
                                                                    bgColor: "#b6b6b6",
                                                                    btnWidth: "24px",
                                                                    btnBgColor: "#3bb77e",
                                                                    btnPadding: "2px 4px",
                                                                    btnLeft: "22px",
                                                                    disabledColor: "#707070",
                                                                    disabledLeft: "2px",
                                                                    mlAuto: "auto",
                                                                    isToggleActive: isToggleActive,
                                                                    onClickToggleBtn: onClickToggleBtn
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/mypage/order",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    style: {
                                                                        fontSize: "14px"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fi fi-rs-user mr-10"
                                                                        }),
                                                                        "\uB9C8\uC774\uD398\uC774\uC9C0"
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                onClick: authHandler,
                                                                className: "header-nav-logout-btn",
                                                                style: {
                                                                    fontSize: "14px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fi fi-rs-sign-out mr-10"
                                                                    }),
                                                                    btnText
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/login",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            style: {
                                                                fontSize: "14px",
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi fi-rs-lock-alt mr-5 pt-1"
                                                                }),
                                                                "\uB85C\uADF8\uC778"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/register",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            style: {
                                                                fontSize: "14px",
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi fi-rs-user mr-5 pt-1"
                                                                }),
                                                                "\uD68C\uC6D0 \uAC00\uC785"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/order-search",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            style: {
                                                                fontSize: "14px",
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi fi-rs-barcode mr-5 pt-1"
                                                                }),
                                                                "\uC8FC\uBB38 \uC870\uD68C"
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mobile-menu-wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCategoryWrapper, {
                                        ref: categoriRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className:  true ? "categori-dropdown-wrap d-flex" : 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_category, {
                                                categoriRef: categoriRef
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "mobile-menu",
                                            ref: domNode,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: menus1
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-social-icon mt-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_styles/* MobileSocialIconWrapper */.Ld, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://pf.kakao.com/_MCxnhxj",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/kakao-talk.png",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.facebook.com/caretstore",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-facebook-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.instagram.com/caretstore/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-instagram-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://talk.naver.com/ct/w4kznv",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-naver-talk.png",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.youtube.com/channel/UC1MTYtvC363yWAB4uf8CBhQ",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/assets/imgs/theme/icons/icon-youtube-white.svg",
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://blog.naver.com/caretstore",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://cdn.imweb.me/upload/S20200506960caff1c89c9/522104c187709.png",
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var MobileMenu_mapStateToProps = function(state) {
    return {
        show: state.confirm.modal,
        siteInfo: state.siteInfo
    };
};
var MobileMenu_mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    initUserInfo: action_userInfo/* initUserInfo */.bf
};
/* harmony default export */ var layout_MobileMenu = ((0,es/* connect */.$j)(MobileMenu_mapStateToProps, MobileMenu_mapDispatchToProps)(MobileMenu));

// EXTERNAL MODULE: ./components/layout/Seo.js + 4 modules
var Seo = __webpack_require__(65250);
// EXTERNAL MODULE: ./redux/action/alert.js
var action_alert = __webpack_require__(4557);
;// CONCATENATED MODULE: ./components/channel/ChannelTalk.js
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var ChannelTalk = /*#__PURE__*/ function() {
    "use strict";
    function ChannelTalk() {
        _classCallCheck(this, ChannelTalk);
        this.loadScript();
    }
    _createClass(ChannelTalk, [
        {
            key: "loadScript",
            value: function loadScript() {
                var l = function l() {
                    if (w.ChannelIOInitialized) {
                        return;
                    }
                    w.ChannelIOInitialized = true;
                    var s = document.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
                    s.charset = "UTF-8";
                    var x = document.getElementsByTagName("script")[0];
                    x.parentNode.insertBefore(s, x);
                };
                var w = window;
                if (w.ChannelIO) {
                    return;
                }
                var ch = function() {
                    ch.c(arguments);
                };
                ch.q = [];
                ch.c = function(args) {
                    ch.q.push(args);
                };
                w.ChannelIO = ch;
                if (document.readyState === "complete") {
                    l();
                } else if (window.attachEvent) {
                    window.attachEvent("onload", l);
                } else {
                    window.addEventListener("DOMContentLoaded", l, false);
                    window.addEventListener("load", l, false);
                }
            }
        },
        {
            key: "boot",
            value: function boot(settings, callback) {
                window.ChannelIO("boot", settings, callback);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                window.ChannelIO("shutdown");
            }
        }
    ]);
    return ChannelTalk;
}();
/* harmony default export */ var channel_ChannelTalk = (ChannelTalk);

;// CONCATENATED MODULE: ./components/layout/sideBanner.js
function sideBanner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sideBanner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sideBanner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sideBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sideBanner_templateObject() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  position: ",
        ";\n  top: ",
        ";\n  left: calc(((100vw) / 2 - 570px) - 170px);\n  max-width: 150px;\n  height: 350%;\n  z-index: 999;\n  background-color: transparent;\n  display: block;\n\n  @media screen and (max-width: 1600px) {\n    left: 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    display: none;\n  }\n  @media screen and (max-width: 991px) {\n    display: none;\n  }\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    sideBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sideBanner_templateObject1() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 90px;\n  height: auto;\n  display: flex;\n  align-items: center;\n  & img {\n    width: 150px !important;\n  }\n"
    ]);
    sideBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sideBanner_templateObject2() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 10px;\n  display: flex;\n  justify-content: center;\n  width: 150px;\n  & span {\n    border-radius: 20%;\n    color: black;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px;\n    background-color: #fff;\n    margin-right: 5px;\n    cursor: pointer;\n    :last-of-type {\n      margin-right: 0px;\n    }\n    z-index: 999;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    sideBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sideBanner_templateObject3() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  display: none;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n  @media screen and (max-width: 768px) {\n    display: flex;\n  }\n"
    ]);
    sideBanner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sideBanner_templateObject4() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  display: none;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-color: #fff;\n  padding: 10px 10px 5px;\n  flex-direction: column;\n  align-items: center;\n  @media screen and (max-width: 768px) {\n    display: flex;\n    .swiper-pagination-bullet {\n      width: 10px !important;\n      height: 10px !important;\n    }\n  }\n"
    ]);
    sideBanner_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sideBanner_templateObject5() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 5px;\n  width: 100%;\n"
    ]);
    sideBanner_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function sideBanner_templateObject6() {
    var data = sideBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  word-break: keep-all;\n  & span {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    padding: 10px;\n    :hover {\n      background-color: #ececec;\n      color: #3bb77e;\n    }\n    :first-of-type {\n      border-right: 1px solid #7e7e7e7e;\n    }\n  }\n"
    ]);
    sideBanner_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Controller */.Qr
]);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-0"
})(sideBanner_templateObject(), function(props) {
    return props.$scroll === "bannerHidden" && "fixed" || "absolute";
}, function(props) {
    return props.$scroll === "scrollCheck" && "10px" || props.$scroll === "bannerHidden" && "90px" || "365px";
});
var StickyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-1"
})(sideBanner_templateObject1());
var SwiperArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-2"
})(sideBanner_templateObject2());
var MobileBannerBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-3"
})(sideBanner_templateObject3());
var MobileBotBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-4"
})(sideBanner_templateObject4());
var BotImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-5"
})(sideBanner_templateObject5());
var BotBtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b783fbd5-6"
})(sideBanner_templateObject6());
var SideBanner = function() {
    var ref = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), bannerList = ref.bannerList, mainSide = ref.mainSide, mobileBtm = ref.mobileBtm;
    var swiperRef = (0,react.useRef)();
    var mobileSwiperRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(true), openBanner = ref1[0], setOpenBanner = ref1[1];
    var ref2 = (0,react.useState)({}), sideSwiper = ref2[0], setSideSwiper = ref2[1];
    var ref3 = (0,react.useState)(""), scroll = ref3[0], setScroll = ref3[1];
    var onClickClose = function() {
        setOpenBanner(false);
    };
    var onClickTodayClose = function() {
        var date = (0,getDate/* getNextDate */.OO)();
        (0,auth/* setCookie */.d8)("IgB", date, {
            expires: date
        });
        onClickClose();
    };
    var swiperOption = {
        navigation: {
            prevEl: ".custom_prev",
            nextEl: ".custom_next"
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        loop: (mainSide === null || mainSide === void 0 ? void 0 : mainSide.length) > 1 ? true : false
    };
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", function() {
            var scrollCheck = window.scrollY >= 100 && window.scrollY < 365;
            var bannderHidden = window.scrollY >= 365;
            if (scrollCheck) {
                return setScroll("scrollCheck");
            }
            if (bannderHidden) {
                return setScroll("bannerHidden");
            }
            setScroll("");
        });
    }, []);
    (0,react.useEffect)(function() {
        if (sideSwiper && sideSwiper.autoplay && (mainSide === null || mainSide === void 0 ? void 0 : mainSide.length) > 1) {
            sideSwiper.autoplay.start();
            sideSwiper.autoplay.run();
            sideSwiper.update();
        }
        if (!(0,auth/* getCookie */.ej)("IgB") && bannerList && (mobileBtm === null || mobileBtm === void 0 ? void 0 : mobileBtm.length) > 0 && openBanner && mobileSwiperRef.autoplay) {
            mobileSwiperRef.autoplay.start();
            mobileSwiperRef.autoplay.run();
            mobileSwiperRef.update();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                $scroll: scroll,
                children: bannerList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, sideBanner_objectSpread({
                            ref: swiperRef,
                            className: "sideBanner"
                        }, swiperOption, {
                            observeParents: true,
                            observer: true,
                            onSwiper: setSideSwiper,
                            updateOnWindowResize: true,
                            children: bannerList && (mainSide === null || mainSide === void 0 ? void 0 : mainSide.length) > 0 && mainSide.map(function(el, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: el.link_url,
                                        target: el.new_win === "Y" ? "_blank" : "_self",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: el.P_FileUrl,
                                            alt: el.img_alt
                                        })
                                    })
                                }, i);
                            })
                        })),
                        bannerList && (mainSide === null || mainSide === void 0 ? void 0 : mainSide.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwiperArrows, {
                            className: (mainSide === null || mainSide === void 0 ? void 0 : mainSide.length) == 1 && "d-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "custom_prev",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "custom_next",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !(0,auth/* getCookie */.ej)("IgB") && bannerList && (mobileBtm === null || mobileBtm === void 0 ? void 0 : mobileBtm.length) > 0 && openBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBannerBg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileBotBanner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BotImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                className: "mobileBotBanner ",
                                autoplay: true,
                                pagination: true,
                                children: mobileBtm.map(function(el, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: el.link_url,
                                            target: el.new_win === "Y" ? "_blank" : "_self",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: el.M_FileUrl,
                                                alt: el.img_alt
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BotBtnWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: onClickTodayClose,
                                    children: "\uC624\uB298 \uADF8\uB9CC\uBCF4\uAE30"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: onClickClose,
                                    children: "\uB2EB\uAE30"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var sideBanner = (SideBanner);

;// CONCATENATED MODULE: ./redux/action/alliance.js

var setAllianceInfo = function(allianceInfo) {
    return function(dispatch) {
        dispatch({
            type: actionTypes/* ALLIANCE_INFO */.n7,
            payload: {
                allianceInfo: allianceInfo
            }
        });
    };
};

;// CONCATENATED MODULE: ./redux/action/banners.js

var setBanners = function(banners) {
    return function(dispatch) {
        dispatch({
            type: actionTypes/* FETCH_BANNER */.IK,
            payload: {
                banners: banners
            }
        });
    };
};

// EXTERNAL MODULE: ./api/banners.js
var api_banners = __webpack_require__(78623);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
;// CONCATENATED MODULE: ./hook/useBrandProductsQuery.js
function useBrandProductsQuery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useBrandProductsQuery_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useBrandProductsQuery_arrayLikeToArray(arr);
}
function useBrandProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useBrandProductsQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useBrandProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useBrandProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useBrandProductsQuery_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useBrandProductsQuery_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useBrandProductsQuery_toConsumableArray(arr) {
    return useBrandProductsQuery_arrayWithoutHoles(arr) || useBrandProductsQuery_iterableToArray(arr) || useBrandProductsQuery_unsupportedIterableToArray(arr) || useBrandProductsQuery_nonIterableSpread();
}
function useBrandProductsQuery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useBrandProductsQuery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useBrandProductsQuery_arrayLikeToArray(o, minLen);
}




var getItemsFromLocalStorage = function() {
    try {
        var storage = localStorage.getItem("enp_cros_storage");
        if (storage) {
            var parsedStorage = JSON.parse(storage);
            return parsedStorage || [];
        }
        return [];
    } catch (error) {
        return [];
    }
};
var useBrandProductsQuery = function(param) {
    var pcodeList = param.pcodeList;
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.PRODUCTS.BRAND.INDEX */.U.PRODUCTS.BRAND.INDEX(pcodeList),
        queryFn: useBrandProductsQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, localItems, items, remainingCount, additionalItems, body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        localItems = getItemsFromLocalStorage();
                        items = [];
                        if (localItems && localItems.length > 0) {
                            // 로컬 스토리지 아이템 추가
                            items = useBrandProductsQuery_toConsumableArray(localItems);
                            // 로컬 스토리지 아이템이 6개 미만인 경우 pcodeList에서 추가
                            if (items.length < 6 && pcodeList && pcodeList.length > 0) {
                                remainingCount = 6 - items.length;
                                additionalItems = pcodeList.slice(0, remainingCount);
                                items = useBrandProductsQuery_toConsumableArray(items).concat(useBrandProductsQuery_toConsumableArray(additionalItems));
                            }
                        } else if (pcodeList && pcodeList.length > 0) {
                            // 로컬 스토리지 아이템이 없는 경우 pcodeList 사용
                            items = pcodeList.slice(0, 6); // 최대 6개까지만 사용
                        }
                        // 혹시 6개를 초과하는 경우 6개로 자르기
                        if (items.length > 6) {
                            items = items.slice(0, 6);
                        }
                        body = {
                            modes: "SetProductView",
                            items: items
                        };
                        _ctx.next = 9;
                        return (0,products/* ProductsApi */.qO)(body);
                    case 9:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000" && (res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data))) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data.Data);
                    case 14:
                        if (!(res === null || res === void 0 ? void 0 : res.Data)) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data);
                    case 16:
                        return _ctx.abrupt("return", []);
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("API \uD638\uCD9C \uC911 \uC624\uB958 \uBC1C\uC0DD:", _ctx.t0);
                        return _ctx.abrupt("return", []);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    19
                ]
            ]);
        })),
        enabled: !!(pcodeList === null || pcodeList === void 0 ? void 0 : pcodeList.length),
        onError: function(error) {
            console.error("Query \uC624\uB958:", error);
        },
        onSuccess: function(data) {
            console.log("Query \uC131\uACF5, \uB370\uC774\uD130:", data);
        },
        refetchOnWindowFocus: false
    });
};

;// CONCATENATED MODULE: ./components/layout/ExitIntentBanner.js
function ExitIntentBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ExitIntentBanner_templateObject() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    ExitIntentBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject1() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -235px;\n  right: 0; /* \uC624\uB978\uCABD \uC815\uB82C */\n  width: 370px;\n  max-width: 370px;\n  z-index: 999;\n  padding: 0;\n  background-color: white;\n  animation: ",
        " 0.3s ease-in-out;\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n\n  @media (max-width: 768px) {\n    position: fixed;\n    top: 0;\n    left: 5%;\n    width: 100%;\n    max-width: 90%;\n    height: 100vh;\n    z-index: 999;\n  }\n"
    ]);
    ExitIntentBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject2() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 768px) {\n    height: 100vh;\n  }\n"
    ]);
    ExitIntentBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject3() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  background-color: #222;\n  color: white;\n  padding: 14px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 500;\n"
    ]);
    ExitIntentBanner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject4() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  padding: 20px;\n\n  @media (max-width: 768px) {\n    flex: 1;\n    overflow-y: auto;\n    padding: 15px;\n  }\n"
    ]);
    ExitIntentBanner_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject5() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    ExitIntentBanner_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject6() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  background: none;\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    ExitIntentBanner_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject7() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  margin-bottom: 20px;\n  text-align: center;\n\n  img {\n    max-width: 100%;\n    border-radius: 10px;\n    cursor: pointer;\n  }\n\n  @media (max-width: 768px) {\n    margin-bottom: 15px;\n  }\n"
    ]);
    ExitIntentBanner_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject8() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  margin-top: 20px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    margin-top: 15px;\n  }\n"
    ]);
    ExitIntentBanner_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject9() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: white;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  transition: 0.2s;\n  overflow: hidden;\n\n  &:hover {\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n  }\n\n  @media (max-width: 768px) {\n    border-radius: 10px;\n  }\n"
    ]);
    ExitIntentBanner_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject10() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: #fff;\n  overflow: hidden;\n"
    ]);
    ExitIntentBanner_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject11() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: block;\n\n  & img {\n    width: 100%;\n    -webkit-transition: all 1s cubic-bezier(0, 0, 0.05, 1);\n    transition: all 1s cubic-bezier(0, 0, 0.05, 1);\n\n    &:hover {\n      transform: scale3d(1.03, 1.03, 1.03) translateZ(0);\n    }\n  }\n"
    ]);
    ExitIntentBanner_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject12() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  padding: 0 10px 15px 10px;\n"
    ]);
    ExitIntentBanner_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject13() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 3rem;\n  font-size: 14px;\n  font-weight: 500;\n  color: #253d4e;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n\n  &:hover {\n    color: #3bb77e;\n  }\n"
    ]);
    ExitIntentBanner_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject14() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  padding: 5px 0;\n"
    ]);
    ExitIntentBanner_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject15() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    ExitIntentBanner_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function ExitIntentBanner_templateObject16() {
    var data = ExitIntentBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    span:first-child {\n      color: #dc3545;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 24px;\n      margin-right: 0.2rem;\n    }\n\n    span:last-child {\n      font-size: 12px;\n      line-height: 24px;\n      font-weight: 500;\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n    }\n  }\n\n  & h5 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #253d4e;\n    margin: 0;\n  }\n"
    ]);
    ExitIntentBanner_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}










// 애니메이션 정의
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(ExitIntentBanner_templateObject());
// 스타일드 컴포넌트 정의
var BannerOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-0"
})(ExitIntentBanner_templateObject1(), fadeIn);
var BannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-1"
})(ExitIntentBanner_templateObject2());
var BannerHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-2"
})(ExitIntentBanner_templateObject3());
var BannerBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-3"
})(ExitIntentBanner_templateObject4());
var BannerTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-4"
})(ExitIntentBanner_templateObject5());
var ExitIntentBanner_CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-978c76c9-5"
})(ExitIntentBanner_templateObject6());
var CouponImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-6"
})(ExitIntentBanner_templateObject7());
// 제품 그리드 스타일
var ProductGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-7"
})(ExitIntentBanner_templateObject8());
// 제품 카드 컴포넌트
var ProductCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-8"
})(ExitIntentBanner_templateObject9());
var ProductImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-9"
})(ExitIntentBanner_templateObject10());
var ProductImg = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-978c76c9-10"
})(ExitIntentBanner_templateObject11());
var ProductContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-11"
})(ExitIntentBanner_templateObject12());
var ProductName = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-978c76c9-12"
})(ExitIntentBanner_templateObject13());
var ProductBottomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-13"
})(ExitIntentBanner_templateObject14());
var PriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-14"
})(ExitIntentBanner_templateObject15());
var PriceBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-978c76c9-15"
})(ExitIntentBanner_templateObject16());
var ExitIntentBanner = function(param) {
    var dummyList = param.dummyList;
    var ref = (0,react.useState)(false), showBanner = ref[0], setShowBanner = ref[1];
    var router = (0,next_router.useRouter)();
    var pageOut = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }).pageOut;
    var ref1 = useBrandProductsQuery({
        pcodeList: dummyList.out_product
    }), brandProducts = ref1.data;
    var handleClose = function() {
        // 배너 숨김 상태로 설정
        setShowBanner(false);
        var expiryDate = new Date();
        expiryDate.setHours(expiryDate.getHours() + 2);
        // 배너 숨김 유지 (2시간 동안)
        (0,auth/* setCookie */.d8)(auth/* BANNER_PRODUCT_COOKIE_NAME */.Wx, "true", {
            path: "/",
            expires: expiryDate
        });
    };
    (0,react.useEffect)(function() {
        // 마우스가 브라우저 창 밖으로 나가는 것을 감지하는 함수
        var handleMouseLeave = function(e) {
            // 마우스가 위쪽으로 나갈 때만 감지 (Y좌표가 0 이하일 때)
            if (e.clientY <= 0) {
                setShowBanner(true);
            }
        };
        // 이벤트 리스너 등록
        document.addEventListener("mouseleave", handleMouseLeave);
        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return function() {
            document.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);
    (0,react.useEffect)(function() {
        // 마우스가 브라우저 창 밖으로 나가는 것을 감지하는 함수
        var handleMouseLeave = function(e) {
            // 마우스가 위쪽으로 나갈 때만 감지 (Y좌표가 0 이하일 때)
            if (e.clientY <= 0) {
                // 현재 쿠키 값 가져오기
                var cookieValue = (0,auth/* getCookie */.ej)(auth/* BANNER_PRODUCT_COOKIE_NAME */.Wx);
                // 쿠키가 "false"이거나 undefined일 때만 배너 표시 및 스크롤 상단으로 이동
                if (cookieValue === "false" || !cookieValue) {
                    setShowBanner(true);
                    // 페이지 최상단으로 즉시 이동
                    window.scrollTo({
                        top: 0
                    });
                }
            }
        };
        // 이벤트 리스너 등록
        document.addEventListener("mouseleave", handleMouseLeave);
        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return function() {
            document.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);
    var bannerCookie = (0,auth/* getCookie */.ej)(auth/* BANNER_PRODUCT_COOKIE_NAME */.Wx);
    // 쿠키가 true이거나 showBanner가 false면 배너를 표시하지 않음
    var shouldShowBanner = showBanner && bannerCookie !== "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shouldShowBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerOverlay, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {
                                children: "\uC774\uB7F0 \uC81C\uD488\uC740 \uC5B4\uB5A0\uC138\uC694?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitIntentBanner_CloseButton, {
                                onClick: handleClose,
                                children: "\u2715"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerBody, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: pageOut === null || pageOut === void 0 ? void 0 : pageOut[0].P_FileUrl,
                                    alt: pageOut === null || pageOut === void 0 ? void 0 : pageOut[0].img_alt,
                                    onClick: function() {
                                        return router.push("".concat(pageOut === null || pageOut === void 0 ? void 0 : pageOut[0].link_url));
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGrid, {
                                children: Array.isArray(brandProducts) && brandProducts.map(function(product) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImgWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/products/".concat(product.pcode),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImg, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: product.main_image,
                                                            alt: product.pname
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductContentWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/products/".concat(product.pcode),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                                                            children: product.pname
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBottomWrapper, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceBox, {
                                                                children: [
                                                                    product.salePer > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                children: [
                                                                                    product.salePer,
                                                                                    "%"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: product.price && " ".concat((0,splicePrice/* priceComma */.a)(product.price), "\uC6D0")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "d-flex",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                                            children: [
                                                                                (0,splicePrice/* priceComma */.a)(product.discount_price),
                                                                                "\uC6D0"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
// Redux 상태를 props로 매핑
var ExitIntentBanner_mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
// connect 함수로 컴포넌트 연결 및 내보내기
/* harmony default export */ var layout_ExitIntentBanner = ((0,es/* connect */.$j)(ExitIntentBanner_mapStateToProps, null)(ExitIntentBanner));

;// CONCATENATED MODULE: ./components/layout/Layout.js
function Layout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Layout_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Layout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Layout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Layout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Layout_templateObject() {
    var data = Layout_taggedTemplateLiteral([
        ""
    ]);
    Layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var Layout_Body = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-9077d302-0"
})(Layout_templateObject());
var Layout = function(param) {
    var dummyList = param.dummyList, children = param.children, //START: breadcrumb
    parent = param.parent, sub = param.sub, subTitle = param.subTitle, subChild = param.subChild, detailsubChild = param.detailsubChild, noBreadcrumb = param.noBreadcrumb, id = param.id, //END: breadcrumb
    headerStyle = param.headerStyle, _$showToastAlert = param.showToastAlert, _$isLoading = param.isLoading, _$isLoaded = param.isLoaded, allianceInfo = param.allianceInfo, _$setAllianceInfo = param.setAllianceInfo, _$setBanners = param.setBanners, banners = param.banners, fetchSiteInfo = param.fetchSiteInfo, siteConfig = param.siteConfig, //START: SEO
    pageTitle = param.pageTitle, pageDesc = param.pageDesc, pageImg = param.pageImg, pageKeyword = param.pageKeyword, //END: SEO
    userInfo = param.userInfo, _$fetchUserInfo = param.fetchUserInfo;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(false), isToggled = ref5[0], setToggled = ref5[1];
    var ref1 = (0,react.useState)(false), isSessionExpirated = ref1[0], setIsSessionExpirated = ref1[1];
    var ref2 = (0,react.useState)({
        pc: "",
        mobile: "",
        over: ""
    }), logo = ref2[0], setLogo = ref2[1];
    var toggleClick = function() {
        setToggled(!isToggled);
        isToggled ? document.querySelector("body").classList.remove("mobile-menu-active") : document.querySelector("body").classList.add("mobile-menu-active");
    };
    // 유저 정보 불러오는 함수 및 토큰 만료 시 분기 처리
    var getUser = function() {
        var _ref = Layout_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _$fetchUserInfo();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUser() {
            return _ref.apply(this, arguments);
        };
    }();
    // 토큰 여부 파싱 후 유저 정보 불러오는 함수 트리거
    var isAccessTokenExisted = function() {
        var _ref = Layout_asyncToGenerator(runtime_default().mark(function _callee() {
            var accessToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        accessToken = (0,auth/* getCookie */.ej)("token");
                        if (accessToken) {
                            getUser();
                        } else {
                            // gtag
                            dataLayer.push({
                                user_id: undefined
                            });
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function isAccessTokenExisted() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkLogo = function() {
        var _ref = Layout_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref3, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!router.query.channel) {
                            _ctx.next = 12;
                            break;
                        }
                        if (!(sessionStorage.getItem("logo") && JSON.parse(sessionStorage.getItem("logo")).pc.includes("alliance"))) {
                            _ctx.next = 5;
                            break;
                        }
                        {
                            setLogo(JSON.parse(sessionStorage.getItem("logo")));
                        }
                        _ctx.next = 10;
                        break;
                    case 5:
                        body = {
                            modes: "Config",
                            division: "store",
                            channel: router.query.channel
                        };
                        _ctx.next = 8;
                        return (0,checkSiteConfig/* default */.Z)(body);
                    case 8:
                        res = _ctx.sent;
                        setLogo({
                            pc: res.Data.channel.logo,
                            mobile: res.Data.channel.mobile_logo,
                            over: res.Data.channel.over_logo
                        });
                    case 10:
                        _ctx.next = 13;
                        break;
                    case 12:
                        {
                            if (dummyList) {
                                ;
                                setLogo({
                                    pc: (ref = dummyList.logo) === null || ref === void 0 ? void 0 : ref.logo,
                                    mobile: (ref3 = dummyList.logo) === null || ref3 === void 0 ? void 0 : ref3.mobile_logo,
                                    over: (ref4 = dummyList.logo) === null || ref4 === void 0 ? void 0 : ref4.over_logo
                                });
                            }
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkLogo() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchBanners = function() {
        var _ref = Layout_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,api_banners/* listSetBanners */.B)(body);
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            _$setBanners(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchBanners() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        var channelTalk = new channel_ChannelTalk();
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.phone) {
            var ref6;
            channelTalk.boot({
                pluginKey: "9c5384ba-4565-4587-893c-f56fcb79ac78",
                memberId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.Member.uid,
                profile: {
                    name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.Member.name,
                    mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (ref6 = userInfo.Member) === null || ref6 === void 0 ? void 0 : ref6.phone,
                    email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.Member.email
                }
            });
        } else {
            channelTalk.boot({
                pluginKey: "9c5384ba-4565-4587-893c-f56fcb79ac78"
            });
        }
        return function() {
            channelTalk.shutdown();
        };
    }, [
        userInfo
    ]);
    // 토큰 만료 시 toast 알림
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        checkLogo();
        isAccessTokenExisted();
        fetchBanners();
        var handleIsLoading = function(e) {
            _$isLoading();
        };
        var handleIsLoaded = function(e) {
            _$isLoaded();
        };
        router.events.on("routeChangeStart", handleIsLoading);
        router.events.on("routeChangeComplete", handleIsLoaded);
        return function() {
            router.events.off("routeChangeStart", handleIsLoading);
            router.events.off("routeChangeComplete", handleIsLoaded);
        };
    }, [
        router,
        router.query,
        dummyList
    ]);
    var userCoupons = (0,react.useMemo)(function() {
        var ref, ref7;
        if ((userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Coupon) === null || ref === void 0 ? void 0 : (ref7 = ref.rows) === null || ref7 === void 0 ? void 0 : ref7.length) > 0) {
            return userInfo === null || userInfo === void 0 ? void 0 : userInfo.Coupon;
        } else {
            return [];
        }
    }, [
        userInfo
    ]);
    // 현재 경로 정보 활용을 위한 breadcrumb Ko data 생성
    var breadcrumbData = {
        parent: parent,
        sub: sub,
        subTitle: subTitle,
        subChild: subChild,
        detailsubChild: detailsubChild
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: pageTitle,
                desc: pageDesc,
                image: pageImg,
                keywords: pageKeyword,
                breadcrumbData: breadcrumbData,
                id: id
            }),
            isToggled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "body-overlay-1",
                onClick: toggleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sideBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Header, {
                headerStyle: headerStyle,
                isToggled: isToggled,
                toggleClick: toggleClick,
                userInfo: userInfo,
                logo: logo,
                userCoupons: userCoupons,
                siteConfig: siteConfig
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_MobileMenu, {
                isToggled: isToggled,
                toggleClick: toggleClick,
                userInfo: userInfo,
                userCoupons: userCoupons
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Body, {
                className: "main position-relative border-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Breadcrumb, {
                        parent: parent,
                        sub: sub,
                        subTitle: subTitle,
                        subChild: subChild,
                        detailsubChild: detailsubChild,
                        noBreadcrumb: noBreadcrumb,
                        id: id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_ExitIntentBanner, {}),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Footer, {})
        ]
    });
};
var Layout_mapStateToProps = function(state) {
    return {
        allianceInfo: state.allianceInfo,
        banners: state.banners,
        dummyList: state.dummyList,
        userInfo: state.userInfo
    };
};
var Layout_mapDispatchToProps = {
    showToastAlert: action_alert/* showToastAlert */.I,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k,
    setAllianceInfo: setAllianceInfo,
    setBanners: setBanners,
    fetchUserInfo: action_userInfo/* fetchUserInfo */.CS
};
/* harmony default export */ var layout_Layout = ((0,es/* connect */.$j)(Layout_mapStateToProps, Layout_mapDispatchToProps)(Layout));


/***/ }),

/***/ 65250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Seo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
;// CONCATENATED MODULE: ./utils/breadcrumb/categories.js
var categoryPathMap = {
    // START: ESG
    ESG자료실: "esg-guide/",
    "ESG \uD658\uACBD\uB274\uC2A4": "esg-guide/news/",
    "ESG \uB274\uC2A4\uB808\uD130": "esg-guide/letter/",
    "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC": "esg-guide/blog/package/",
    "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0": "esg-guide/blog/make/",
    // END: ESG
    // START: CSBOARD
    공지사항: "csboard/notice",
    FAQ: "csboard/faq/",
    "\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC": "csboard/library/",
    "\uC81C\uD734 \uBB38\uC758": "csboard/contact",
    "\uD328\uD0A4\uC9D5 \uC81C\uC548\uBC1B\uAE30": "csboard/b2b/",
    구해드립니다: "csboard/service/"
};

;// CONCATENATED MODULE: ./utils/breadcrumb/index.js


var generateBreadcrumbItems = function(pageType, data, pathSegments, canonicalUrl, id) {
    var breadcrumbItems = [];
    var currentPosition = 1;
    var lastSegment = pathSegments[pathSegments.length - 1];
    var isPagination = !isNaN(parseInt(lastSegment)) && isFinite(lastSegment);
    var cleanPathSegments = isPagination ? pathSegments.slice(0, -1) : pathSegments;
    // 홈 항목 추가
    breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.parent || "\uD648",
        item: resources/* SITE_URL */._
    });
    // 2차 카테고리 (sub) 추가
    if (data.sub) {
        var subPath = "";
        if (categoryPathMap[data.sub]) {
            // 이미 매핑된 카테고리가 있는 경우 해당 경로 사용
            subPath = categoryPathMap[data.sub];
        } else if (pathSegments[0] === "products") {
            subPath = "products";
        } else {
            subPath = pathSegments[0] || "";
        }
        breadcrumbItems.push({
            "@type": "ListItem",
            position: currentPosition++,
            name: data.sub,
            item: "".concat(resources/* SITE_URL */._, "/").concat(subPath, "/")
        });
    }
    // 페이지 타입별 브레드크럼 생성 로직
    if (pageType === "cs") {
        // 고객센터 페이지 상세
        if (data.subTitle) {
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subTitle,
                item: "".concat(resources/* SITE_URL */._, "/").concat(categoryPathMap[data.sub], "/").concat(id, "/")
            });
        }
    } else if (pageType === "esg") {
        // ESG 페이지 브레드크럼 생성
        if (data.subTitle && data.subTitle !== data.sub) {
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subTitle,
                item: "".concat(resources/* SITE_URL */._, "/").concat(categoryPathMap[data.subTitle] || "esg-guide/")
            });
        }
        // 상세 페이지인 경우
        if (cleanPathSegments.length > 2 && data.subChild && data.subChild !== data.subTitle && data.subChild !== data.sub) {
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subChild,
                item: "".concat(resources/* SITE_URL */._, "/").concat(categoryPathMap[data.subTitle] || "esg-guide/", "/").concat(id, "/")
            });
        }
    } else if (pageType === "product") {
        // 상품 페이지 브레드크럼 생성
        var productPath = isPagination ? cleanPathSegments : pathSegments;
        // 3단계: 2차 카테고리
        if (productPath.length > 1) {
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subTitle,
                item: "".concat(resources/* SITE_URL */._, "/products/").concat(productPath[1], "/")
            });
        }
        // 4단계: 상품 2차 카테고리 상세 이름 - only if not pagination
        if (data.subChild && !isPagination) {
            var encodedSubChild = encodeURIComponent(data.subChild);
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subChild,
                item: "".concat(resources/* SITE_URL */._, "/products/").concat(productPath[1], "/").concat(encodedSubChild, "/")
            });
        }
        // 5단계: 상품 상세 이름 - only if not pagination
        if (data.detailsubChild && !isPagination) {
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.detailsubChild,
                item: canonicalUrl
            });
        }
    } else {
        // 기타 일반 페이지
        if (data.subTitle) {
            // 동일한 값이 subChild와 subTitle에 있는 경우 중복 방지
            if (data.subChild === data.subTitle) {
                breadcrumbItems.push({
                    "@type": "ListItem",
                    position: currentPosition++,
                    name: data.subTitle,
                    item: canonicalUrl
                });
            } else {
                // subTitle만 있는 경우 (리스트 페이지)
                breadcrumbItems.push({
                    "@type": "ListItem",
                    position: currentPosition++,
                    name: data.subTitle,
                    item: "".concat(resources/* SITE_URL */._, "/").concat(cleanPathSegments.join("/"), "/")
                });
                // subChild가 있는 경우 (상세 페이지)
                if (data.subChild) {
                    breadcrumbItems.push({
                        "@type": "ListItem",
                        position: currentPosition++,
                        name: data.subChild,
                        item: canonicalUrl
                    });
                }
            }
        } else if (data.subChild) {
            // subTitle이 없지만 subChild가 있는 경우
            breadcrumbItems.push({
                "@type": "ListItem",
                position: currentPosition++,
                name: data.subChild,
                item: canonicalUrl
            });
        }
    }
    return breadcrumbItems;
};

;// CONCATENATED MODULE: ./utils/breadcrumb/pageTypes.js
var getPageType = function(pathSegments) {
    if (pathSegments[0] === "products") return "product";
    if (pathSegments[0] === "esg-guide") return "esg";
    if (pathSegments[0] === "csboard") return "cs";
    return "general";
};

;// CONCATENATED MODULE: ./utils/seo/SeoDefault.js
var defaultSeoConfig = {
    title: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 :: \uBBF8\uB798\uC758 \uB2F9\uC5F0\uD568\uC744 \uB9CC\uB4E4\uB2E4",
    description: "\uBAA8\uB4E0 \uC885\uB958\uC758 \uD3EC\uC7A5\uC7AC\uB97C \uD558\uB098\uC758 \uD50C\uB7AB\uD3FC\uC5D0\uC11C! \uC2A4\uB9C8\uD2B8 \uD328\uD0A4\uC9D5 \uC194\uB8E8\uC158 \uD50C\uB7AB\uD3FC \uCE7C\uB81B\uC2A4\uD1A0\uC5B4. \uD658\uACBD\uD45C\uC9C0\uC778\uC99D \uBC0F \uC7AC\uD65C\uC6A9\uC131 \uB192\uC740 \uD0C4\uC18C\uC800\uAC10 \uD3EC\uC7A5\uC7AC \uB2E4\uC218 \uBCF4\uC720",
    image: "https://file.caretbio.com/caretbio/b2c6985b05f7bef24ed2c91965b47455.jpg",
    keywords: "\uCE7C\uB81B\uBC14\uC774\uC624, \uCE7C\uB81B\uC2A4\uD1A0\uC5B4, \uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C, Eco, Box, \uCE5C\uD658\uACBD\uD3EC\uC7A5, \uC9C0\uC18D\uAC00\uB2A5\uD55C\uD3EC\uC7A5, \uC9C0\uC18D\uAC00\uB2A5\uC131, sustainability, sustainable, \uCE5C\uD658\uACBD\uC77C\uD68C\uC6A9\uD488, \uCE5C\uD658\uACBD\uBD80\uC790\uC7AC, \uCE5C\uD658\uACBD\uBE68\uB300, \uCE5C\uD658\uACBD\uBD09\uD22C, \uCE5C\uD658\uACBD\uD3EC\uC7A5\uBC15\uC2A4, \uCE5C\uD658\uACBD\uD0DD\uBC30\uBC15\uC2A4, \uCE5C\uD658\uACBD\uBC15\uC2A4\uC81C\uC791, \uC5D0\uCF54\uADF8\uB9B0\uBC15\uC2A4, \uC5D0\uCF54\uBC15\uC2A4, \uC5D0\uCF54\uD504\uB80C\uC988, \uC800\uB834\uD55C\uBC15\uC2A4, \uB0A0\uAC1C\uBC15\uC2A4, \uCE5C\uD658\uACBD\uBC15\uC2A4, \uC8FC\uBB38\uC81C\uC791, \uD2B9\uD5C8\uBC15\uC2A4, \uADF8\uB9B0\uBC15\uC2A4, \uC885\uC774\uBC15\uC2A4, \uB178\uD14C\uC774\uD504\uBC15\uC2A4, \uC811\uCC29\uC2DD\uBC15\uC2A4, \uBB34\uC811\uCC29\uBC15\uC2A4, \uD3F4\uB354\uBC15\uC2A4, \uADF8\uBB3C\uC644\uCDA9\uC7AC, \uC6B0\uCCB4\uAD6D\uC0AC\uC774\uC988, A\uD615\uBC15\uC2A4, \uB0A9\uC791\uBC15\uC2A4, \uAE34\uBC15\uC2A4, \uC6B0\uCCB4\uAD6D\uC0AC\uC774\uC988, \uC6B0\uCCB4\uAD6D\uBC15\uC2A4, \uD3F4\uB354\uBC15\uC2A4, \uB192\uC774\uAC00\uBCC0\uD615\uBC15\uC2A4, \uACE8\uD310\uC9C0\uD328\uB4DC, \uD0DD\uBC30\uBC15\uC2A4, \uB18D\uC0B0\uBB3C\uBC15\uC2A4, \uC644\uCDA9\uD328\uB4DC, \uC885\uC774\uB09C\uC88C, \uD3EC\uB3C4\uC644\uCDA9\uC7AC, \uACC4\uB780\uC644\uCDA9\uC7AC, \uBA5C\uB860\uC644\uCDA9\uC7AC, \uC218\uBC15\uC644\uCDA9\uC7AC, \uACF5\uAE30\uC8FC\uC785\uAE30, \uBC14\uC774\uC624\uBE44\uB2D0\uBD09\uD22C, \uD0DD\uBC30\uBD09\uD22C, \uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C, \uC18D\uBE44\uB2D0, \uB9C1\uBD09\uD22C, \uC190\uC7A1\uC774\uBD09\uD22C, \uC704\uC0DD\uBC31, \uC9C0\uD37C\uBC31, \uC885\uC774\uD14C\uC774\uD504, \uC885\uC774\uC644\uCDA9\uC7AC, \uBC8C\uC9D1\uC644\uCDA9\uC7AC, \uD770\uC0C9\uC18D\uC9C0, \uC644\uCDA9\uC7AC\uAC70\uCE58\uB300, \uD06C\uB77C\uD504\uD2B8\uC644\uCDA9\uC7AC, \uD654\uC9C0, \uC804\uC6A9\uAE30\uACC4, \uB300\uB7C9\uAD6C\uB9E4, \uC0DD\uBD84\uD574\uC5D0\uC5B4\uC644\uCDA9\uC7AC, \uC5D0\uC5B4\uC644\uCDA9\uC7AC, \uD3EC\uC7A5\uAE30\uACC4, \uBCF4\uB0C9\uBCF4\uC628\uD3EC\uC7A5\uC7AC, \uCE7C\uB81B\uC5D0\uC5B4\uCFE8\uD329, \uCE7C\uB81B\uC5D0\uC5B4\uD30C\uC6B0\uCE58, \uACF5\uAE30\uC8FC\uC785\uAE30, \uBCF4\uB0C9\uD329, \uC6CC\uD130\uC544\uC774\uC2A4\uD329, \uC544\uC774\uC2A4\uD329\uBC18\uC81C\uD488, \uC885\uC774\uC544\uC774\uC2A4\uD329, \uC18C\uB7C9\uAD6C\uB9E4, \uB300\uB7C9\uAD6C\uB9E4, \uD384\uD504\uC6A9\uAE30, \uD06C\uB77C\uD504\uD2B8\uC6A9\uAE30, \uD50C\uB77C\uC2A4\uD2F1\uC6A9\uAE30, \uC2E4\uB9C1\uC6A9\uAE30, \uAD6D\uBB3C\uC694\uB9AC, \uCE58\uD0A8\uC0D0\uB7EC\uB4DC, \uB3C4\uC2DC\uB77D, \uD584\uBC84\uAC70, \uCD08\uBC25\uC6A9\uAE30, \uC811\uC2DC, \uC18C\uC2A4\uD1B5, \uC77C\uD68C\uC6A9\uB098\uBB34\uC2DD\uAE30, \uC77C\uD68C\uC6A9\uC0DD\uBD84\uD574\uC2DD\uAE30, \uC704\uC0DD\uC7A5\uAC11, \uC544\uC774\uC2A4\uCEF5, \uC544\uC774\uC2A4\uCEF5\uB69C\uAED1, \uC885\uC774\uCEF5, \uC885\uC774\uCEF5\uB69C\uAED1, \uC0DD\uBD84\uD574\uBE68\uB300, \uC885\uC774\uBE68\uB300, \uB300\uB098\uBB34\uBE68\uB300, \uAE30\uD0C0\uC6A9\uD488, \uC2A4\uD2B8\uB808\uCE58\uD544\uB984, \uBC18\uB824\uB3D9\uBB3C\uC6A9\uD488, \uBC30\uBCC0\uBD09\uD22C, \uC2DD\uAE30",
    author: "\uCE7C\uB81B\uBC14\uC774\uC624, \uCE7C\uB81B\uC2A4\uD1A0\uC5B4",
    siteName: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 :: \uBBF8\uB798\uC758 \uB2F9\uC5F0\uD568\uC744 \uB9CC\uB4E4\uB2E4"
};

;// CONCATENATED MODULE: ./components/layout/Seo.js







var Seo = function(param) {
    var title = param.title, desc = param.desc, image = param.image, keywords = param.keywords, breadcrumbData = param.breadcrumbData, id = param.id;
    var router = (0,next_router.useRouter)();
    var pageTitle = title ? "".concat(title, " :: \uCE7C\uB81B\uC2A4\uD1A0\uC5B4") : defaultSeoConfig.title;
    var finalDescription = desc ? desc : defaultSeoConfig.description;
    var finalImage = image ? image : defaultSeoConfig.image;
    var finalKeywords = keywords ? keywords : defaultSeoConfig.keywords;
    // URL 정보 추출 및 가공
    var pathSegments = router.asPath.split("/").filter(Boolean);
    // 페이지 타입 판별
    var pageType = getPageType(pathSegments);
    // 페이지네이션 확인
    var isProductPage = pathSegments[0] === "products";
    var lastSegment = pathSegments[pathSegments.length - 1];
    var isPaginatedProductPage = isProductPage && !isNaN(parseInt(lastSegment)) && isFinite(lastSegment);
    // Canonical URL 생성
    var canonicalUrl;
    if (isPaginatedProductPage) {
        var pathWithoutPagination = pathSegments.slice(0, -1).join("/");
        canonicalUrl = "".concat(resources/* SITE_URL */._, "/").concat(pathWithoutPagination);
    } else {
        canonicalUrl = "".concat(resources/* SITE_URL */._).concat(router.asPath);
    }
    // 상품 ID 패턴 확인 (P로 시작하는 ID)
    var hasPIdPattern = pathSegments.some(function(segment) {
        return /^P\d{10,}$/.test(segment);
    });
    //    Breadcrumb Schema 생성 함수
    var generateBreadcrumbSchema = function() {
        // 새로운 유틸리티 함수 활용하여 브레드크럼 아이템 생성
        var breadcrumbItems = generateBreadcrumbItems(pageType, breadcrumbData || {}, pathSegments, canonicalUrl, id);
        return {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbItems
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: finalDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: defaultSeoConfig.author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: finalKeywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "image",
                content: finalImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            !hasPIdPattern && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "naver-site-verification",
                content: "73434c46afaf95b1aca89b69bf1bbd9b18d465c8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Cache-Control",
                content: "no-cache"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Expires",
                content: "0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Pragma",
                content: "no-cache"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: defaultSeoConfig.siteName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: finalDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: finalImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:keywords",
                content: finalKeywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: finalDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: finalImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#3bb77e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "Rra2K_-5diyQmqHmSncqz4EJUQ3aXQLOgJ95bsVqrDY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(generateBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ var layout_Seo = (Seo);


/***/ }),

/***/ 4557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ showToastAlert; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46330);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22920);


var showToastAlert = function(comment, options) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_1__/* .SHOW_TOAST_ALERT */ .r0
        });
        (0,react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am)(comment, options);
    };
};


/***/ }),

/***/ 83173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ fetchBasketsAction; },
/* harmony export */   "Xv": function() { return /* binding */ deleteBasketsAction; },
/* harmony export */   "Yp": function() { return /* binding */ clearBasketsAction; },
/* harmony export */   "el": function() { return /* binding */ insertBasketsAction; },
/* harmony export */   "fK": function() { return /* binding */ initBaskets; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18682);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55150);
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46330);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




// 회원 장바구니 리스트
var fetchBasketsAction = function() {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var ref, ref1, ref2, body, data;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 5;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .fetchBaskets */ .aO)(body);
                    case 5:
                        data = _ctx.sent;
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__/* .FETCH_BASKETS */ .jM,
                            payload: {
                                baskets: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
                                    return el.pcode != null;
                                }),
                                msg: data === null || data === void 0 ? void 0 : data.msg,
                                count: ((ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.filter(function(el) {
                                    return el.pcode != null;
                                })) === null || ref2 === void 0 ? void 0 : ref2.length) || 0
                            }
                        });
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
// 회원 장바구니 등록
var insertBasketsAction = function(product, cnt) {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var body, data;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify([
                                _objectSpread({}, product, {
                                    pcode: product.pcode,
                                    cnt: cnt
                                })
                            ])
                        };
                        _ctx.next = 4;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .insertBaskets */ .nh)(body);
                    case 4:
                        data = _ctx.sent;
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__/* .INSERT_BASKETS */ .Sv,
                            payload: {
                                code: data === null || data === void 0 ? void 0 : data.code,
                                baskets: data === null || data === void 0 ? void 0 : data.data,
                                count: data === null || data === void 0 ? void 0 : data.count,
                                msg: data === null || data === void 0 ? void 0 : data.msg,
                                product: product
                            }
                        });
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0.message);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
// 회원 장바구니 삭제
var deleteBasketsAction = function(product) {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var body, res, body2, data;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        body = {
                            modes: "DeleteSet",
                            pcode: product.pcode
                        };
                        _ctx.next = 4;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .deleteBasket */ .Cz)(body);
                    case 4:
                        res = _ctx.sent;
                        body2 = {
                            modes: "ListSet"
                        };
                        _ctx.next = 8;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .fetchBaskets */ .aO)(body2);
                    case 8:
                        data = _ctx.sent;
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__/* .DELETE_BASKETS */ .XQ,
                            payload: {
                                msg: data === null || data === void 0 ? void 0 : data.msg,
                                product: product,
                                baskets: data === null || data === void 0 ? void 0 : data.data,
                                count: data === null || data === void 0 ? void 0 : data.count
                            }
                        });
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0.message);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
// 장바구니 비우기
var clearBasketsAction = function() {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var body, res, body2, data;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        body = {
                            modes: "EmptySet"
                        };
                        _ctx.next = 4;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .clearBaskets */ .h0)(body);
                    case 4:
                        res = _ctx.sent;
                        if (res.code === "0000") (0,_common_alert__WEBPACK_IMPORTED_MODULE_2__/* .successAlert */ .Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uB97C \uBE44\uC6E0\uC2B5\uB2C8\uB2E4");
                        body2 = {
                            modes: "ListSet"
                        };
                        _ctx.next = 9;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_1__/* .fetchBaskets */ .aO)(body2);
                    case 9:
                        data = _ctx.sent;
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__/* .CLEAR_BASKETS */ .hX,
                            payload: {
                                msg: data === null || data === void 0 ? void 0 : data.msg,
                                baskets: data === null || data === void 0 ? void 0 : data.data,
                                count: data === null || data === void 0 ? void 0 : data.count
                            }
                        });
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0.message);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
// 리덕스 초기화
var initBaskets = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_3__/* .INIT_BASKETS */ .hz
        });
    };
};


/***/ }),

/***/ 68866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ deleteFromCart; },
/* harmony export */   "LL": function() { return /* binding */ clearCart; },
/* harmony export */   "Xq": function() { return /* binding */ addToCart; },
/* harmony export */   "Yl": function() { return /* binding */ decreaseCnt; },
/* harmony export */   "us": function() { return /* binding */ increaseCnt; }
/* harmony export */ });
/* unused harmony export setCartCnt */
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var addToCart = function(product, cnt) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .ADD_TO_CART */ .G2,
            payload: {
                product: product,
                cnt: cnt
            }
        });
    };
};
var deleteFromCart = function(productCode) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .DELETE_FROM_CART */ .Yw,
            payload: {
                productCode: productCode
            }
        });
    };
};
var setCartCnt = function(product, cnt) {
    return function(dispatch) {
        dispatch({
            type: Types.SET_CNT,
            payload: {
                product: product,
                cnt: cnt
            }
        });
    };
};
var increaseCnt = function(productCode) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .INCREASE_CNT */ .Zm,
            payload: {
                productCode: productCode
            }
        });
    };
};
var decreaseCnt = function(productCode) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .DECREASE_CNT */ .zG,
            payload: {
                productCode: productCode
            }
        });
    };
};
var clearCart = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLEAR_CART */ .qX
        });
    };
};


/***/ }),

/***/ 7330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ updateProductFilters; },
/* harmony export */   "pP": function() { return /* binding */ updateProductCategory; }
/* harmony export */ });
/* unused harmony export updateProductRating */
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var updateProductFilters = function(productFilters) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .UPDATE_PRODUCT_FILTERS */ .Wi,
            payload: {
                productFilters: productFilters
            }
        });
    };
};
var updateProductCategory = function(category) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .UPDATE_PRODUCT_CATEGORY */ .$J,
            payload: {
                category: category
            }
        });
    };
};
var updateProductRating = function(rating) {
    return function(dispatch) {
        dispatch({
            type: Types.UPDATE_RATING,
            payload: rating
        });
    };
};


/***/ }),

/***/ 44625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ fetchUserInfo; },
/* harmony export */   "bf": function() { return /* binding */ initUserInfo; },
/* harmony export */   "gS": function() { return /* binding */ updateUserInfo; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_getUserInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48934);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55150);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48106);
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46330);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};





var fetchUserInfo = function() {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var res, ref;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_api_getUserInfo__WEBPACK_IMPORTED_MODULE_1__/* .getAllUserInfo */ .fp)();
                    case 3:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "8888")) {
                            _ctx.next = 11;
                            break;
                        }
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .removeCookie */ .nJ)("token");
                        (0,_common_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uB85C\uADF8\uC778 \uC720\uC9C0 \uC2DC\uAC04\uC774 \uB9CC\uB8CC \uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                        window.open("/login", "_self");
                        return _ctx.abrupt("return");
                    case 11:
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "9999")) {
                            _ctx.next = 16;
                            break;
                        }
                        (0,_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .removeCookie */ .nJ)("token");
                        return _ctx.abrupt("return", window.open("/", "_self"));
                    case 16:
                        // gtag
                        if ((typeof dataLayer === "undefined" ? "undefined" : _typeof(dataLayer)) != undefined) {
                            ;
                            dataLayer.push({
                                user_id: res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.uid
                            });
                        }
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .FETCH_USER_INFO */ .Yu,
                            payload: {
                                userInfo: _objectSpread({}, res === null || res === void 0 ? void 0 : res.Data)
                            }
                        });
                        return _ctx.abrupt("return", "complete");
                    case 19:
                        _ctx.next = 25;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updateUserInfo = function(info) {
    return function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch({
                            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .UPDATE_USER_INFO */ .Jc,
                            payload: {
                                updateUserInfo: info
                            }
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
var initUserInfo = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .INIT_USER_INFO */ .X1,
            payload: {}
        });
    };
};


/***/ })

}]);